const es: Record<string, string> = {
  // --- LEA-319 Trust-Redesign (variant '50credits-trust'). ES gate copy
  //     translated from the approved DE/EN mockups (Om signs off wording in QA).
  //     Testimonial names/quotes/roles + photos are verbatim from the Webflow
  //     CMS (Janik 2026-06-11).
  'og.title.trust.lead': 'Prueba Leadscraper ',
  'og.title.trust.grad': '3 días gratis',
  'og.title.trust.tail': ' con 50 leads reales.',
  'og.subtitle.trust':
    'Hoy no se cobra nada. Pruebas con leads reales de tu mercado objetivo y, si no encaja, finalizas la prueba con un solo clic. Sin llamadas, sin plazos de aviso.',
  'og.trust.demo.tag': 'Demo en vivo · no es un vídeo de marketing',
  'og.trust.demo.title': 'Mira cómo Leadscraper encuentra tus leads',
  'og.trust.demo.body':
    'Búsqueda real, dashboard real, resultados reales: el fundador Janik te muestra todo el proceso, desde que describes tu mercado objetivo hasta la lista de leads terminada.',
  'og.trust.demo.play': 'Reproducir vídeo demo',
  'og.trust.demo.close': 'Cerrar',
  'og.trust.timeline.1.when': 'Hoy',
  'og.trust.timeline.1.body':
    'Elige un plan y añade un método de pago. {s}: tus 50 créditos están disponibles al instante.',
  'og.trust.timeline.1.strong': '0 € cobrados',
  'og.trust.timeline.2.when': 'Días 1–3',
  'og.trust.timeline.2.body':
    'Pruebas con leads reales. ¿No te convence? {s} finaliza la prueba al instante, sin contacto y sin dar explicaciones.',
  'og.trust.timeline.2.strong': 'Un clic en tu cuenta',
  'og.trust.timeline.3.when': 'A partir del día 3',
  'og.trust.timeline.3.body':
    'Solo entonces empieza tu suscripción en el plan elegido. {s}, sin permanencia mínima.',
  'og.trust.timeline.3.strong': 'Cancela cuando quieras',
  'og.trust.ctaNote': 'Hoy 0 € · Cancelar = 1 clic',
  'og.trust.proof.head': 'Equipos de ventas que ya dieron el salto',
  // Nachfolger des geloeschten og.trust.proof.pill (behauptete Google & OMR ohne Beleg; LEA-619). Nur aus
  // lib/verifiedReviews gerendert, {platform} = Plattformen der gezeigten Bewertungen.
  'og.trust.proof.pillVerified': 'Reseñas en {platform}',
  'og.trust.bar.card.title': '0 € hoy',
  'og.trust.bar.card.body': 'Tarjeta, PayPal o domiciliación SEPA, con la seguridad de Stripe',
  'og.trust.bar.cancel.title': 'Cancela en 5 segundos',
  'og.trust.bar.cancel.body': '1 clic en tu cuenta, sin contacto, efecto inmediato',
  'og.trust.bar.gdpr.title': 'Solo datos públicos',
  'og.trust.bar.gdpr.body': 'RGPD por diseño · Servidores en la UE · solo fuentes públicas',
  'og.trust.founderLine.title': 'Creado en Hamburgo, Alemania',
  'og.trust.founderLine.name': ' · Janik Deimann, Fundador',
  'og.trust.founderLine.sub':
    'Ingeniería alemana, protección de datos de la UE, y cuando nos escribes, te responde una persona.',
  'og.trust.founderLine.ask':
    '¿Todavía con dudas? Escríbenos: support@leadscraper.eu. Te responderá una persona.',

  // --- Paywall revisión 19 (aprobada por Janik el 11-09-2026) ---
  // El alemán es el original aprobado: conserva el «hasta 50» matizado y la
  // nota sobre los créditos adicionales en todas las traducciones.
  'og.r19.accountReady': 'Cuenta creada · Activa tu prueba',
  'og.r19.headline.lead': 'Encuentra hasta',
  'og.r19.headline.grad': '50 leads gratis.',
  'og.r19.lead':
    'Empieza hoy con empresas que encajan con lo que ofreces. Tu prueba incluye {credits} créditos para hasta {credits} leads de empresas.',
  'og.r19.offerNote':
    'Los contactos y la investigación de empresas consumen créditos adicionales. Los créditos usados en ello reducen el número de empresas.',
  'og.r19.rating.value': '4,8 / 5',
  'og.r19.rating.caption': 'Excelente valoración de los usuarios',
  'og.r19.rating.aria': 'Valoración de clientes: 4,8 de 5 estrellas',
  'og.r19.product.footnote': 'Tú decides en qué empresas profundizas.',
  'og.r19.picker.title': 'Empieza ahora gratis.',
  'og.r19.picker.trialCredits': '{credits} créditos de prueba',
  'og.r19.picker.trialPlan': '{plan} · {days} días a 0 €, después {renewal}, cancelable cada mes',
  'og.r19.picker.trialPlanAll': '{plan} · prueba a 0 €, después {renewal}, cancelable cada mes',
  'og.r19.picker.today': '0 €',
  'og.r19.picker.todayLabel': 'hoy',
  'og.r19.picker.description': 'Elige tu paquete para después de la prueba.',
  'og.r19.credits.title': 'Encontrar 1 empresa',
  'og.r19.credits.equals': '=',
  'og.r19.credits.unit': '1 crédito',
  'og.r19.credits.note':
    'Los contactos y la investigación de empresas cuestan créditos adicionales.',
  'og.r19.credits.info': 'Ver un ejemplo del consumo de créditos',
  'og.r19.credits.example':
    'Ejemplo: encuentras 20 empresas y añades contactos e investigación en 10 de ellas. Son 40 créditos.',
  'og.r19.credits.exampleRest': 'Te quedan {rest} de tus {credits} créditos de prueba.',
  'og.r19.credits.disclaimer':
    '{credits} créditos no son automáticamente {credits} contactos investigados por completo.',
  'og.r19.plans.legend': 'Elige tu paquete para después de la prueba',
  'og.r19.plans.creditsPerMonth': '{credits} créditos / mes',
  'og.r19.plans.perMonth': '/ mes',
  'og.r19.plans.caption.basic': 'Para empezar',
  'og.r19.plans.caption.starter': 'Para la captación habitual',
  'og.r19.plans.caption.growth': 'Para un equipo de ventas mayor',
  'og.r19.cta': 'Empezar gratis ahora',
  'og.r19.renewal': 'Después {s} por {credits} créditos.',
  'og.r19.renewal.strong': '{price} € / mes',
  'og.r19.renewal.cancel': 'Cancela antes de que acabe la prueba y no pagarás nada.',
  'og.r19.security': 'Método de pago en el siguiente paso',
  'og.r19.help.faq': 'Prueba y cancelación',
  'og.r19.help.features': 'Paquetes en detalle',
  // MCP self-service token UI (LEA-269)
  'mcp.live': 'En vivo',
  'mcp.tok.generate': 'Generar token',
  'mcp.tok.title': 'Conectar un cliente de IA',
  'mcp.tok.intro':
    'Genera un token personal para conectar Claude, Cursor o tu propio agente a tu cuenta de Leadscraper. El token se muestra solo una vez.',
  'mcp.tok.name': 'Nombre del token',
  'mcp.tok.generating': 'Generando…',
  'mcp.tok.once': 'Copia este token ahora: por seguridad, no se volverá a mostrar.',
  'mcp.tok.yourToken': 'Tu token',
  'mcp.tok.copy': 'Copiar',
  'mcp.tok.copied': 'Copiado',
  'mcp.tok.claudeConfig': 'Configuración de Claude Desktop',
  'mcp.tok.copyConfig': 'Copiar configuración',
  'mcp.tok.done': 'Hecho',
  'mcp.tok.limit': 'Límite de tokens alcanzado: revoca uno antiguo primero.',
  'mcp.tok.mintFailed': 'No se pudo generar el token. Inténtalo de nuevo.',
  'mcp.tok.revoked': 'Token "{name}" revocado',
  'mcp.tok.revokeFailed': 'No se pudo revocar el token.',
  'mcp.tok.expires': 'expira',
  'mcp.tok.lastUsed': 'último uso',
  'mcp.tok.neverUsed': 'nunca usado',
  'mcp.tok.revoke': 'Revocar',
  // LEA-349 Phase 3: Claude.ai (web) OAuth connect path
  'mcp.claude.connect': 'Conectar con Claude',
  'mcp.claude.cardHint': 'Claude.ai (web) se conecta con un clic mediante OAuth, sin token.',
  'mcp.claude.intro':
    'Añade Leadscraper a Claude.ai como conector personalizado. Apruebas el acceso una sola vez, sin token que copiar ni pegar.',
  'mcp.claude.cta': 'Abrir conectores de Claude',
  'mcp.claude.urlLabel': 'La URL de tu servidor MCP',
  'mcp.claude.step1': 'Haz clic en "Abrir conectores de Claude" y luego en "Add custom connector".',
  'mcp.claude.step2': 'Pega la URL de arriba y continúa.',
  'mcp.claude.step3': 'Aprueba el acceso ("Allow"). Claude ya puede usar tus leads.',
  'mcp.claude.desktopNote': '¿Usas Claude Desktop, Cursor o tu propio agente?',
  'mcp.claude.desktopCta': 'Generar un token en su lugar',
  'acct.bill.addMethod': 'Añadir método de pago',
  'acct.bill.cardEnds': 'Visa termina en •• 4242',
  'acct.bill.cardExpHolder': 'Vence 08/2028 · Janik Deimann',
  'acct.bill.col.amount': 'Importe',
  'acct.bill.col.credits': 'Credits',
  'acct.bill.col.date': 'Fecha',
  'acct.bill.col.desc': 'Descripción',
  'acct.bill.col.invoice': 'Factura',
  'acct.bill.col.status': 'Estado',
  'acct.bill.descSub': 'Suscripción {plan} · {month} {year}',
  'acct.bill.empty': 'No se encontraron transacciones',
  'acct.bill.emptySub': 'Tu historial de pagos aparecerá aquí después de tu primera compra.',
  'acct.bill.filter.30': 'Últimos 30 días',
  'acct.bill.filter.90': 'Últimos 90 días',
  'acct.bill.filter.all': 'Todas',
  'acct.bill.history': 'Historial de Transacciones',
  'acct.bill.manageCards': 'Gestionar tarjetas',
  'acct.bill.manageViaStripe': 'Gestionar a través del Portal de Cliente de Stripe',
  'acct.bill.methodAutoAdded':
    'Se añadirá automáticamente después del inicio del período de prueba.',
  'acct.bill.methodOnFile': 'Método de pago registrado',
  'acct.bill.methods': 'Métodos de Pago',
  'acct.bill.noMethods': 'No se encontraron métodos de pago',
  'acct.bill.paid': 'Pagada',
  'acct.bill.pdfUnavailable': 'Ahora mismo no se puede cargar esta factura en PDF aquí. Puedes abrirla y descargarla en Stripe.',
  'acct.bill.pdfOpenStripe': 'Abrir factura en Stripe',
  'acct.bill.primary': 'Principal',
  'acct.dataAccount': 'Datos y cuenta',
  'acct.deleteAccount.btn': 'Eliminar cuenta',
  'acct.deleteAccount.confirmBtn': 'Eliminar cuenta definitivamente',
  'acct.deleteAccount.confirmPwLabel': 'Ingresa tu contraseña para confirmar',
  'acct.deleteAccount.deleting': 'Eliminando ...',
  'acct.deleteAccount.errFailed': 'Eliminación fallida.',
  'acct.deleteAccount.errPwRequired': 'Por favor ingresa la contraseña.',
  'acct.deleteAccount.modalBody':
    'Tu cuenta será desactivada y eliminada definitivamente después de 30 días. Dentro de este plazo puedes reactivarla por email + contraseña. Todos tus Leads, Perfiles y valoraciones serán eliminados irrevocablemente.',
  'acct.deleteAccount.modalTitle': 'Eliminar cuenta',
  'acct.deleteAccount.title': 'Eliminar cuenta',
  'acct.deleteAccount.warn':
    'Tu cuenta será eliminada definitivamente en 30 días. Puedes reactivarla durante este tiempo.',
  'acct.seedimport.title': 'Importar lista de clientes existentes',
  'acct.seedimport.desc':
    'Sube un archivo CSV o de texto con tus clientes existentes — un dominio o URL por línea (o una columna de dominios). Estas empresas nunca se entregan como nuevo lead en NINGUNA audiencia.',
  'acct.seedimport.hint': 'CSV o .txt · máx 5 MB',
  'acct.seedimport.cta': 'Subir CSV',
  'acct.seedimport.uploading': 'Importando …',
  'acct.seedimport.report':
    '{rows} filas · {resolved} dominios reconocidos · {added} nuevos · {total} en tu lista',
  'acct.seedimport.unresolved': '{n} filas omitidas (sin dominio reconocible)',
  'acct.seedimport.capped': 'Límite de importación alcanzado — no se añadieron todos los dominios.',
  'acct.seedimport.failed': 'Error al importar. Revisa el archivo e inténtalo de nuevo.',
  'acct.export.btn': 'Exportar',
  'acct.export.failed': 'Exportación fallida. Por favor inténtalo de nuevo.',
  'acct.export.preparing': 'Preparando exportación: puede tomar un momento con muchos datos.',
  'acct.export.ready': 'Descarga iniciada.',
  'acct.export.sub': 'RGPD Art. 20: Todos tus datos como descarga JSON.',
  'acct.export.title': 'Exportar datos',
  'acct.int.apiKey': 'Clave API',
  'acct.int.apiKeyP': 'Desde la configuración de desarrolladores de tu CRM',
  'acct.int.autoPush': 'Auto-envío con "Encaja"',
  'acct.int.autoPushSub': 'Los leads se envían automáticamente al CRM una vez que los confirmas.',
  'acct.int.bulkPush': 'Enviar {n} a CRM',
  // LEA-282: HubSpot OAuth strings (Wave 2)
  'acct.int.oauthFail': 'Conexión OAuth fallida',
  'acct.int.reconnect': 'Reconectar',
  'acct.int.reconnectRequired': 'Reconexión necesaria',
  'acct.int.connectedVia': 'Conectado vía OAuth',
  // LEA-268 backfill: CRM-button strings missing from the initial deploy
  // (Om bug-report 2026-05-26 — keys rendered as bracketed [det.crmOpenRecord]).
  'det.crmPushing': 'Enviando…',
  'det.crmPushFail': 'Push a CRM fallido',
  'det.crmSubRequired': 'El push a CRM requiere un plan de pago.',
  'det.crmDuplicate': 'Ya está en CRM',
  'det.crmNotConnected': 'Sin CRM conectado: configura uno en Cuenta → Integraciones',
  'det.crmOpenRecord': 'Ver registro',
  'acct.int.pushFail': 'Push a CRM fallido',
  'acct.int.pushDuplicate': 'Ya está en CRM',
  'acct.int.pushSubRequired': 'El push a CRM requiere un plan de pago.',
  'acct.int.bulkSummary': '{pushed} enviados · {skipped} omitidos · {failed} fallidos',
  'leads.bulkPushBtn': 'Enviar {n} a {crm}',
  'leads.bulkPushPickBtn': 'Enviar {n} al CRM ▾',
  'leads.bulkPushTitle': 'Envía los leads actualmente visibles (máx 50) a tu CRM',
  'acct.int.cancel': 'Cancelar',
  'acct.int.connect': 'Conectar',
  // LEA-317
  'acct.int.subRequired':
    'Las integraciones de CRM solo están disponibles en planes de pago. Mejora tu plan para conectar tu CRM.',
  'acct.int.upgradeTitle': 'Mejora tu plan para conectar tu CRM',
  'acct.int.upgradeCta': 'Mejorar plan',
  'acct.int.connectFirst':
    'Conecta tu CRM en la configuración de cuenta para enviar leads automáticamente.',
  'acct.int.connectSuccess': 'Conectado con {name}',
  'acct.int.connected': 'Conectado',
  'acct.int.disconnect': 'Desconectar',
  'acct.int.disconnectSuccess': 'Conexión con {name} desconectada',
  'acct.int.manage': 'Gestionar',
  'acct.int.mapping': 'Mapeo de campos',
  'acct.int.mappingSub': 'Campos de Leadscraper → Campos CRM',
  'acct.int.none': 'Ningún CRM conectado',
  'acct.int.notConnected': 'No conectado',
  'acct.int.notPushedYet': 'Aún no enviado',
  'acct.int.object': 'Tipo de objeto',
  'acct.int.openInCRM': 'Abrir en {name}',
  'acct.int.owner': 'Responsable (Owner)',
  'acct.int.pipeline': 'Pipeline',
  'acct.int.pushSuccess': '{n} lead(s) enviados a {name}',
  'acct.int.pushToCRM': 'Enviar a CRM',
  'acct.int.pushedAt': 'Enviado {when}',
  'acct.int.pushedTo': 'En {name}',
  'acct.int.save': 'Guardar conexión',
  'acct.int.sectionLead': 'Estado CRM',
  'acct.int.stage': 'Etapa para nuevos leads',
  'acct.int.sub':
    'Conecta tu CRM y envía leads que encajen automáticamente, o manualmente por lead.',
  // LEA-334: webhook signing secret + verification handshake
  'acct.int.whsec.title': 'Secreto de firma del webhook',
  'acct.int.whsec.sub':
    'Firmamos cada envío de webhook con HMAC-SHA256 para que tu endpoint pueda verificar que realmente proviene de Leadscraper.',
  'acct.int.whsec.revealed': 'Cópialo ahora: solo se muestra una vez.',
  'acct.int.whsec.copy': 'Copiar',
  'acct.int.whsec.copied': 'Copiado',
  'acct.int.whsec.rotate': 'Rotar y mostrar secreto',
  'acct.int.whsec.rotating': 'Rotando…',
  'acct.int.whsec.rotateHint':
    'Al rotar se genera un secreto nuevo y se muestra una sola vez: actualiza tu endpoint después.',
  'acct.int.whsec.fail': 'No se pudo rotar el secreto de firma.',
  'acct.int.whsec.docs':
    'Verifica: cabecera X-Leadscraper-Signature: t=<unix>,v1=<hex>, donde hex = HMAC-SHA256(secret, "<t>.<rawBody>"). Rechaza la solicitud si no coincide o si la marca de tiempo es antigua.',
  'acct.int.webhookUrl': 'URL del webhook',
  'acct.int.webhookUrlP': 'https://your-endpoint.example.com/leadscraper',
  'acct.int.autoPushSubWebhook':
    'Los nuevos leads se envían a tu webhook automáticamente en cuanto se enriquecen sus contactos.',
  'acct.int.whverify.title': 'Verifica tu endpoint',
  'acct.int.whverify.sub':
    'Un endpoint accesible (que devuelve 2xx) no es lo mismo que uno verificado. Confirma un código de un solo uso para que sepamos que los leads llegan de verdad; hasta entonces, no se entrega ninguno.',
  'acct.int.whverify.verified': '✓ Verificado',
  'acct.int.whverify.unverified': 'Sin verificar',
  'acct.int.whverify.send': 'Enviar evento de prueba',
  'acct.int.whverify.sending': 'Enviando…',
  'acct.int.whverify.resend': 'Reenviar evento de prueba',
  'acct.int.whverify.sent': 'Evento de prueba enviado: busca el código en tu endpoint.',
  'acct.int.whverify.sendFail': 'No se pudo enviar el evento de prueba.',
  'acct.int.whverify.enter': 'Introduce el código (LSWH-…) que llegó a tu endpoint:',
  'acct.int.whverify.confirm': 'Confirmar',
  'acct.int.whverify.ok': 'Webhook verificado: ya se pueden entregar leads.',
  'acct.int.whverify.mismatch': 'Ese código no coincide. Revisa tu endpoint e inténtalo de nuevo.',
  'acct.int.whverify.expired': 'Ese código ha caducado: envía un nuevo evento de prueba.',
  'acct.int.testing': 'Probando conexión...',
  'acct.int.title': 'Integraciones CRM',
  'acct.menu.logout': 'Cerrar sesión',
  'acct.menu.settings': 'Configuración de cuenta',
  'acct.plan.active': 'Activo',
  'acct.plan.canceled': 'Cancelado',
  'acct.plan.refundedEnded':
    'Suscripción reembolsada: plan finalizado. Elige un plan para continuar.',
  'acct.plan.addOneOff': 'Añadir paquete único',
  'acct.plan.afterTrial': 'Después del período de prueba',
  'acct.plan.bonusCredits': 'Credits del paquete',
  'acct.plan.bonusCreditsTip':
    'Credits pagados de paquetes únicos: se acreditan además de la cuota mensual y no caducan.',
  'acct.plan.dayLeft':
    'Queda 1 día de prueba gratuita. Después tu suscripción continúa automáticamente.',
  // LEA-561: Abbuchungsdatum + Ein-Klick-Kuendigung im Trial. Bewusst OHNE
  // Erinnerungs-Versprechen — die Reminder-Mail ist gebaut, aber noch von
  // keinem Scheduler aufgerufen; eine Zusage, die das System nicht halten
  // kann, ist genau der Vertrauensbruch, den LEA-553 abstellen soll.
  'acct.plan.trialFirstCharge': 'Primer cobro el {date}. Cancela cuando quieras con un clic.',
  'acct.plan.daysLeft':
    'Quedan {n} días de prueba gratuita. Después tu suscripción continúa automáticamente.',
  'acct.plan.endsToday':
    'El período de prueba termina hoy. Tu suscripción comienza automáticamente.',
  'acct.plan.leftOf': 'de {total} restantes',
  'acct.plan.monthUsage': 'Leads este mes',
  'acct.plan.nextBill': 'Próxima facturación el {date} · {leads} Leads/mes',
  'acct.plan.cancelsOn': 'Termina el {date}',
  'acct.plan.cancelNote': 'Sin más cargos, activo hasta el {date}.',
  'acct.plan.perMonth': '/ mes',
  'acct.plan.secureSub': 'Asegurar suscripción',
  'acct.plan.switch': 'Cambiar plan',
  'acct.plan.trial': 'Período de prueba',
  'acct.plan.trialCredits': 'Credits de prueba',
  'acct.plan.trialCreditsTip':
    'Credits de prueba gratuitos de tu registro: se acreditan además de la cuota mensual y no caducan.',
  // LEA-704: surplus of a migrated account = the balance carried over, not trial credits.
  'acct.plan.carriedOverCredits': 'Credits transferidos',
  'acct.plan.carriedOverCreditsTip':
    'Tu saldo de antes del cambio al pago por contacto: se suma a la cuota mensual y no caduca.',
  'acct.plan.trialUsage': 'Leads de prueba esta fase',
  'acct.plan.usedThisMonth': '{used} / {total} usado este mes · Reset el {date}',
  'acct.plan.your': 'Tu Plan',
  'acct.prof.avatarErr': 'No se pudo subir la imagen. Inténtalo de nuevo.',
  'acct.prof.avatarMime': 'Por favor selecciona un archivo JPG, PNG o WebP.',
  'acct.prof.avatarSize': 'Archivo demasiado grande (máx. 2 MB).',
  'acct.prof.avatarUpdated': 'Imagen de perfil actualizada.',
  'acct.prof.email': 'Correo electrónico',
  'acct.prof.first': 'Nombre',
  'acct.prof.lang': 'Idioma',
  'acct.prof.last': 'Apellido',
  'acct.prof.save': 'Guardar',
  'acct.prof.title': 'Información del Perfil',
  'acct.prof.upload': 'Subir imagen',
  'acct.prof.uploadHint': 'JPG, PNG o WebP. Máx. 2 MB.',
  'acct.pw.changing': 'Cambiando…',
  'acct.pw.complexity':
    'La nueva contraseña debe contener al menos 8 caracteres, mayúsculas y minúsculas, un dígito y un carácter especial (@$!%*?&).',
  'acct.pw.confirm': 'Confirmar nueva contraseña',
  'acct.pw.cta': 'Cambiar contraseña',
  'acct.pw.current': 'Contraseña actual',
  'acct.pw.failed': 'No se pudo cambiar la contraseña.',
  'acct.pw.minErr': 'Mínimo 8 caracteres.',
  'acct.pw.minHint': 'Mínimo 8 caracteres',
  'acct.pw.mismatch': 'Las contraseñas no coinciden.',
  'acct.pw.new': 'Nueva contraseña',
  'acct.pw.sameAsCurrent': 'La nueva contraseña debe ser diferente a la actual.',
  'acct.pw.success': 'Contraseña cambiada ✓',
  'acct.pw.title': 'Cambiar contraseña',
  'acct.pw.wrongCurrent': 'La contraseña actual es incorrecta.',
  'acct.sec.active': 'Activa',
  'acct.sec.change': 'Cambiar',
  'acct.sec.inactive': 'Inactiva',
  'acct.sec.pw': 'Cambiar contraseña',
  'acct.sec.pwSub': 'Cambia aquí la contraseña de tu cuenta',
  'acct.sec.title': 'Configuración de Seguridad',
  'acct.sec.twofa': 'Autenticación de Dos Factores',
  'acct.sec.twofaActivate': 'Activar 2FA',
  'acct.sec.twofaDeactivate': 'Desactivar 2FA',
  'acct.sec.twofaSoon':
    'La autenticación de dos factores (app Authenticator) aún no está conectada aquí. El interruptor hasta ahora era solo local. La 2FA real viene próximamente.',
  'acct.sec.twofaSub':
    'La autenticación está desactivada. Actívala para añadir una capa adicional de seguridad a tu cuenta.',
  'acct.sub':
    'Gestiona la configuración del perfil, cambia métodos de pago y descarga facturas de transacciones anteriores.',
  'acct.tab.billing': 'Facturación',
  'acct.tab.integrations': 'Integraciones',
  'acct.tab.profile': 'Perfil',
  'acct.founder.title': 'Línea directa con el fundador',
  'acct.founder.body':
    '¿Feedback, una pregunta, un problema? Tu mensaje llega directamente a Janik, no a un sistema de tickets.',
  'acct.founder.cta': 'Escribe a Janik',
  'acct.title': 'Perfil',
  'acct.toast.failed': 'Error al guardar. Por favor, inténtalo de nuevo.',
  'acct.toast.saved': 'Perfil guardado.',

  'ai.collapse': 'Contraer',
  'ai.cortex': 'Leadscraper',
  'ai.dismiss': 'Ocultar',
  'ai.errorReply':
    'No puedo acceder a mis datos ahora mismo. Inténtalo de nuevo en un momento, o formula la pregunta más brevemente.',
  'ai.footer': 'Leadscraper solo conoce tus audiencias y valoraciones, ningún dato externo.',
  'ai.greeting':
    '¡Hola! 👋 Soy tu asistente de Leadscraper. Veo tu Perfil activo "{profile}" y todos los patrones que el sistema ha aprendido. ¿En qué te puedo ayudar?',
  'ai.inputP': 'Pregúntale algo al asistente ...',
  'ai.ins.edge.cta': 'Ver Lead',
  'ai.ins.edge.fallback': 'Leadscraper no está seguro aquí: tu juicio ayuda a afinar el patrón.',
  'ai.ins.edge.title': 'Caso límite: {company}',
  'ai.ins.pattern.cta': 'Revisar patrón',
  'ai.ins.pattern.title': 'Nuevo patrón en "{profile}"',
  'ai.ins.tune.body':
    'Tasa de coincidencia en {rate} %. Puedo ayudarte a formular la siguiente búsqueda de manera más específica.',
  'ai.ins.tune.cta': 'Afinar búsqueda',
  'ai.ins.tune.title': '"{profile}" aún está en entrenamiento',
  'ai.intro':
    'Monitoreo tus Perfiles las 24 horas y te ayudo a formular búsquedas más precisas y señales de aprendizaje seguras.',
  'ai.langHint':
    'Responde en español. Máximo 3-4 frases cortas por respuesta, excepto para instrucciones concretas.',
  'ai.moreN': '+{n} más',
  'ai.now': 'ahora',
  'ai.onlinePrefix': 'En línea · conoce tus {n} audiencias',
  'ai.openChat': 'Abrir chat',
  'ai.quickStart': 'Inicio rápido',
  'ai.seedRefine': 'Propón una búsqueda afinada para mi audiencia «{profile}».',
  'ai.send': 'Enviar',
  'ai.sp1.label': '¿Cómo va mi audiencia activa?',
  'ai.sp1.prompt':
    'Resúmeme en 3 frases qué tan bien Leadscraper ya entiende mi Perfil activo: qué se ha aprendido, qué no?',
  'ai.sp2.label': '¿Qué patrones debo confirmar?',
  'ai.sp2.prompt':
    '¿Qué patrones aprendidos debería confirmar o rechazar a continuación para que el sistema aprenda más rápido?',
  'ai.sp3.label': 'Sugerir búsqueda',
  'ai.sp3.prompt':
    'Sugiéreme basándote en mi Perfil activo una próxima búsqueda precisa, con industria, ubicación, tamaño y extras.',
  'ai.sp4.label': '¿Dónde pierdo calidad?',
  'ai.sp4.prompt':
    '¿Dónde ves potencial en mis Perfiles para tasas de coincidencia más altas? ¿Qué debería ajustar?',
  'ai.tag.confirmed': 'confirmado',
  'ai.tag.uncertain': 'incierto',
  'ai.tag.unconfirmed': 'sin confirmar',
  'ai.thinkingAbout': 'En lo que estoy pensando',

  'api.confidence.cautiously_optimistic': 'cautelosamente optimista',
  'api.confidence.fairly_sure': 'moderadamente seguro',
  'api.confidence.uncertain': 'incierto',
  'api.confidence.very_sure': 'muy seguro',

  'apierr.intentParseTimeout': "Nuestra IA tardó demasiado en leer tu descripción; inténtalo de nuevo en un momento.",

  'auth.login.docTitle': 'Iniciar sesión · Leadscraper',
  'auth.login.email': 'Correo electrónico',
  'auth.login.errCredentials': 'El correo electrónico o contraseña es incorrecto.',
  'auth.login.errEmail': 'Dirección de correo electrónico inválida.',
  'auth.login.errEmpty': 'Por favor completa todos los campos.',
  'auth.login.errGeneric': 'Error al iniciar sesión. Por favor inténtalo de nuevo.',
  'auth.login.errUnverified': 'Por favor confirma primero tu dirección de correo electrónico.',
  'auth.login.forgot': '¿Olvidaste tu contraseña?',
  'auth.login.google': 'Iniciar sesión con Google',
  'auth.login.googleBusy': 'Iniciando sesión con Google…',
  'auth.login.hidePassword': 'Ocultar contraseña',
  'auth.login.microsoft': 'Iniciar sesión con Microsoft',
  'auth.login.microsoftBusy': 'Iniciando sesión con Microsoft…',
  'auth.login.noAccount': '¿Aún no tienes cuenta?',
  'auth.login.or': 'O',
  'auth.login.password': 'Contraseña',
  'auth.login.remember': 'Mantener sesión iniciada',
  'auth.login.showPassword': 'Mostrar contraseña',
  'auth.login.signUp': 'Registrarse',
  'auth.login.sub': 'Inicia sesión en tu cuenta para acceder a tu cuenta.',
  'auth.login.submit': 'Iniciar sesión',
  'auth.login.submitting': 'Iniciando sesión…',
  'auth.login.title': 'Bienvenido de vuelta',
  'auth.register.docTitle': 'Registrarse · Leadscraper',
  'auth.register.email': 'Correo electrónico',
  'auth.register.errEmail': 'Dirección de correo electrónico inválida.',
  'auth.register.errEmpty': 'Por favor, completa todos los campos.',
  'auth.register.errBotCheck': 'Por favor, completa la verificación anti-bots.',
  'auth.register.errPwMismatch': 'Las contraseñas no coinciden.',
  'auth.register.errPwShort': 'La contraseña debe tener al menos 8 caracteres.',
  'auth.register.firstName': 'Nombre',
  'auth.register.google': 'Registrarse con Google',
  'auth.register.googleBusy': 'Registrando con Google...',
  'auth.register.haveAccount': '¿Ya tienes una cuenta?',
  'auth.register.hidePassword': 'Ocultar contraseña',
  'auth.register.lastName': 'Apellido',
  'auth.register.microsoft': 'Registrarse con Microsoft',
  'auth.register.microsoftBusy': 'Registrando con Microsoft...',
  'auth.register.or': 'O',
  'auth.register.password': 'Contraseña',
  'auth.register.passwordConfirm': 'Confirmar contraseña',
  'auth.register.showPassword': 'Mostrar contraseña',
  'auth.register.signIn': 'Iniciar sesión',
  'auth.register.sub':
    'Prueba qué tan fácil es generar listas de leads precisas hoy gracias a agentes de IA.',
  'auth.register.submit': 'Crear cuenta',
  'auth.register.submitting': 'Creando...',
  'auth.register.title': 'Crear cuenta gratuita',
  'auth.reset.backToLogin': 'Volver al inicio de sesión',
  'auth.reset.confirmLabel': 'Confirmar contraseña*',
  'auth.reset.confirmPlaceholder': 'Ingresa la contraseña nuevamente',
  'auth.reset.docTitle': 'Restablecer contraseña · Leadscraper',
  'auth.reset.doneSub': 'Ahora puedes iniciar sesión con tu nueva contraseña.',
  'auth.reset.doneTitle': 'Contraseña cambiada exitosamente',
  'auth.reset.emailLabel': 'Correo electrónico*',
  'auth.reset.emailPlaceholder': 'Ingresa tu dirección de correo electrónico',
  'auth.reset.errInvalidEmail': 'Por favor, ingresa una dirección de correo electrónico válida.',
  'auth.reset.errPwMismatch': 'Las contraseñas no coinciden.',
  'auth.reset.errPwShort': 'La contraseña debe tener al menos 8 caracteres.',
  'auth.reset.errPwWeak':
    'La contraseña debe incluir mayúsculas y minúsculas, un número y un carácter especial.',
  'auth.reset.pwRules':
    'Al menos 8 caracteres, con mayúsculas y minúsculas, un número y un carácter especial.',
  'auth.reset.errRequest': 'La solicitud falló. Por favor, inténtalo de nuevo.',
  'auth.reset.goToLogin': 'Ir al inicio de sesión',
  'auth.reset.haveAccount': '¿Ya tienes una cuenta?',
  'auth.reset.hidePassword': 'Ocultar contraseña',
  'auth.reset.invalidSub':
    'Este enlace para restablecer la contraseña ya no es válido. Por favor, solicita uno nuevo.',
  'auth.reset.invalidTitle': 'Enlace inválido o vencido',
  'auth.reset.newPwLabel': 'Nueva contraseña*',
  'auth.reset.newPwPlaceholder': 'Al menos 8 caracteres',
  'auth.reset.newPwSub': 'Elige una nueva contraseña para tu cuenta.',
  'auth.reset.newPwTitle': 'Establecer nueva contraseña',
  'auth.reset.requestNew': 'Solicitar nuevo enlace',
  'auth.reset.oauthTitle': 'Esta cuenta usa el inicio de sesión con {provider}',
  'auth.reset.oauthSub':
    'Esta cuenta no tiene contraseña. Inicia sesión con {provider} en su lugar.',
  'auth.reset.resetBtn': 'Restablecer contraseña',
  'auth.reset.saving': 'Guardando...',
  'auth.reset.send': 'Enviar enlace',
  'auth.reset.sending': 'Enviando...',
  'auth.reset.sentSub':
    'Si existe una cuenta con este correo electrónico, te hemos enviado un enlace para restablecer. Revisa tu bandeja de entrada (y spam si es necesario).',
  'auth.reset.sentTitle': 'Correo enviado',
  'auth.reset.showPassword': 'Mostrar contraseña',
  'auth.reset.signIn': 'Iniciar sesión',
  'auth.reset.sub':
    'Ingresa tu dirección de correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
  'auth.reset.title': 'Restablecer contraseña',
  'auth.shell.nextSlide': 'Siguiente diapositiva',
  // LEA-285: auth slide carousel — mirrors apps/auth/src/lib/i18n.ts.
  'auth.slides.1.headline':
    'Los agentes de IA encuentran empresas B2B que coinciden exactamente con tu perfil de cliente objetivo.',
  'auth.slides.2.headline':
    'Cada lista de leads se genera desde cero a partir de fuentes públicas, sin datos obsoletos o revendidos.',
  'auth.slides.3.headline':
    'Cada lead incluye a los responsables de la toma de decisiones, enlaces de origen y una razón clara de por qué encaja.',
  'auth.slides.aria.region': 'Características del producto',
  'auth.slides.aria.slide': 'Diapositiva {n} de {total}',
  'auth.slides.aria.goTo': 'Ir a la diapositiva {n}',

  // --- Login + Registrierung, Revision 19 (Janik 17.09.2026) ---
  // Uebersetzung; das deutsche Original ist die Referenz.
  'auth.r19.skip': 'Saltar al contenido',
  'auth.r19.header.haveAccount': '¿Ya tienes cuenta?',
  'auth.r19.hero.titleLead': 'Encuentra a los',
  'auth.r19.hero.titleGrad': 'clientes',
  'auth.r19.hero.titleTail': 'para los que está hecha tu oferta.',
  'auth.r19.hero.lead':
    'Describe a quién quieres llegar. Leadscraper encuentra empresas adecuadas, investiga a las personas de contacto y te muestra por dónde empezar la conversación.',
  'auth.r19.demo.caption': 'Tu investigación. Paso a paso.',
  'auth.r19.demo.play': 'Ver el recorrido',
  'auth.r19.form.title': 'Empieza con Leadscraper.',
  'auth.r19.form.google': 'Con Google',
  'auth.r19.form.microsoft': 'Con Microsoft',
  'auth.r19.form.separator': 'o con tu correo electrónico',
  'auth.r19.form.businessEmail': 'Correo electrónico de empresa',
  'auth.r19.form.emailPlaceholder': 'tu@empresa.com',
  'auth.r19.form.show': 'Mostrar',
  'auth.r19.form.hide': 'Ocultar',
  'auth.r19.legal.accept':
    'Al registrarte, aceptas nuestros {terms}. Encontrarás información sobre tus datos en nuestra {privacy}.',
  'auth.r19.legal.privacyLink': 'política de privacidad',
  'auth.r19.proof.founderTitle': 'Con el acompañamiento personal del fundador.',
  'auth.r19.proof.founderBody': 'Janik es tu persona de contacto directa.',
  'auth.r19.confidence.eyebrow': 'Antes de tu primera conversación',
  'auth.r19.confidence.title1': 'Sabes a quién te diriges.',
  'auth.r19.confidence.title2': 'Y por qué.',
  'auth.r19.confidence.p1.title': 'Las fuentes están incluidas.',
  'auth.r19.confidence.p1.body':
    'Ves en qué se basa la investigación y puedes comprobar los datos tú mismo.',
  'auth.r19.confidence.p2.title': 'Lo que falta, se ve.',
  'auth.r19.confidence.p2.body':
    'Si falta un dato, es visible. Así decides cómo seguir investigando.',
  'auth.r19.confidence.p3.title': 'Recibes un punto de partida.',
  'auth.r19.confidence.p3.body':
    'El conocimiento de la empresa te ayuda a preparar el primer contacto con un motivo concreto.',
  'auth.r19.founder.eyebrow': 'Personalmente a tu lado',
  'auth.r19.founder.role': 'Fundador de Leadscraper',
  'auth.r19.founder.photoAlt': 'Janik Deimann, fundador de Leadscraper',
  'auth.r19.founder.body':
    'Te ayudo personalmente con tu búsqueda y tus preguntas sobre Leadscraper.',
  'auth.r19.founder.contact': 'Preguntar en el chat',
  'auth.r19.footer.copyright': '© Leadscraper · Deimann Com GmbH',
  'auth.r19.footer.privacy': 'Privacidad',
  'auth.r19.footer.imprint': 'Aviso legal',
  // Geprueft 17.09.2026: HTTP 200.
  'auth.r19.footer.imprintUrl': 'https://www.leadscraper.de/es/aviso-legal',
  'auth.r19.footer.navLabel': 'Información legal',
  'auth.verify.defaultError': 'Ha ocurrido un error.',
  'auth.verify.docTitle': 'Confirmar correo electrónico · Leadscraper',
  'auth.verify.error': 'Confirmación fallida',
  'auth.verify.goToDashboard': 'Ir al panel ahora',
  'auth.verify.noToken': 'Falta enlace de confirmación',
  'auth.verify.noTokenSub':
    'Haz clic en el enlace del correo electrónico que te enviamos. Si no has recibido un correo, puedes solicitar uno nuevo.',
  'auth.verify.resendError': 'Solicitar nuevo correo de confirmación',
  'auth.verify.resendFailed': 'No se pudo reenviar el correo.',
  'auth.verify.resendNoToken': 'Reenviar correo de confirmación',
  'auth.verify.resending': 'Enviando...',
  'auth.verify.resent': 'Correo enviado nuevamente ✓',
  'auth.verify.success': '¡Exitoso!',
  'auth.verify.successSub':
    'Tu dirección de correo electrónico ha sido confirmada. Serás redirigido al panel...',
  'auth.verify.title': 'Confirmar correo electrónico',
  'auth.verify.toLogin': 'Al inicio de sesión',
  'auth.verify.verifying': 'Confirmando correo electrónico...',
  'auth.verify.verifyingSub': 'Un momento, por favor.',

  'bill.ret.cancelBody':
    'No se realizó ningún cargo. Puedes reiniciar el proceso de pago en cualquier momento.',
  'bill.ret.cancelCta': 'Volver al panel de control',
  'bill.ret.cancelTitle': 'Proceso cancelado',
  'bill.ret.cta': 'Al panel de control',
  'bill.ret.docTitleCancel': 'Proceso cancelado · Leadscraper',
  'bill.ret.docTitleSuccess': 'Pago exitoso · Leadscraper',
  'bill.ret.errorBody':
    'Tu pago posiblemente fue exitoso. No pudimos cargar el estado en este momento. Por favor revisa en tu cuenta bajo "Facturación".',
  'bill.ret.errorTitle': 'Estado no disponible',
  'bill.ret.rowCredits': 'Credits',
  'bill.ret.rowCreditsAvail': '{n} disponibles',
  'bill.ret.rowNextRenewal': 'Próxima facturación',
  'bill.ret.rowPlan': 'Plan',
  'bill.ret.seedCta': 'A mis leads',
  'bill.ret.seedDone': 'Ya están listos los {delivered} leads. Vamos allá.',
  'bill.ret.seedPartial':
    '{delivered} leads ya están listos. El resto de tu saldo queda disponible para tus propias búsquedas.',
  'bill.ret.seedWorking':
    '{delivered} de {total} leads están terminados, el resto se está enriqueciendo ahora. En total tarda entre 10 y 30 minutos.',
  'bill.ret.seedWorkingCreated':
    'Tus {created} leads están creados. La búsqueda de los contactos tarda entre 10 y 30 minutos. Mejor exporta cuando estén todos.',
  'bill.ret.seedWorkingZero':
    'Tus leads se están creando ahora mismo. La búsqueda de los contactos tarda entre 10 y 30 minutos. Mejor exporta cuando estén todos.',
  'bill.ret.successBodyCredits': 'Tus Credits han sido acreditados.',
  'bill.ret.successBodySub': 'Tu suscripción está activa. Ahora tienes acceso a tus Leads.',
  'bill.ret.successTitle': 'Pago exitoso',
  'bill.ret.verifying': 'Procesando pago …',
  'bill.ret.verifyingSub': 'Estamos actualizando tu cuenta. Esto tomará solo un momento.',

  'billing.disabled': 'Los pagos no están disponibles actualmente. Por favor, inténtalo más tarde.',
  'billing.errorClose': 'Cerrar',
  'billing.errorTitle': 'Algo salió mal',
  'billing.portalNoCustomer':
    'La gestión de suscripción está disponible solo después de la primera compra.',
  'billing.trialStarted': 'Bienvenido a la suscripción {plan}, período de prueba en curso.',
  // LEA-546: der Tarifwechsel wurde serverseitig abgelehnt, weil das Abo
  // gerade nicht änderbar ist (Kündigung vorgemerkt bzw. Zahlung offen).
  'billing.reactivateFirst':
    'Tu suscripción está programada para terminar. Reactívala primero y luego podrás cambiar de plan.',
  'billing.manageInPortal':
    'Esta suscripción no se puede cambiar ahora mismo. Abre el portal de facturación para resolver el pago.',
  'billing.unknownError': 'Error desconocido en el proceso de pago.',
  'billing.alreadySubscribed': 'Ya tienes esta suscripción. Tu plan actual está en Facturación.',

  'boot.connectionError': 'Error de conexión',
  'boot.connectionErrorDesc': 'No se pudo establecer conexión con el servidor: {msg}',
  'boot.retry': 'Intentar de nuevo',
  'boot.reconnecting': 'Reconectando… (intento {n})',

  'common.cancel': 'Cancelar',
  'common.collapse': 'Contraer',
  'common.edit': 'Editar',
  'common.hide': 'Ocultar',
  'common.loading': 'Cargando ...',
  'common.month.apr': 'Abril',
  'common.month.aug': 'Agosto',
  'common.month.dec': 'Diciembre',
  'common.month.feb': 'Febrero',
  'common.month.jan': 'Enero',
  'common.month.jul': 'Julio',
  'common.month.jun': 'Junio',
  'common.month.mar': 'Marzo',
  'common.month.may': 'Mayo',
  'common.month.nov': 'Noviembre',
  'common.month.oct': 'Octubre',
  'common.month.sep': 'Septiembre',
  'common.refresh': 'Actualizar',
  'common.save': 'Guardar',
  'common.saving': 'Guardando ...',

  'cortex.activeSince': 'Audiencia activa desde',
  'cortex.confirm': 'Confirmar',
  'cortex.confirmed': 'confirmado por ti',
  'cortex.correct': 'Corregir',
  'cortex.ctaRate': 'Evaluar primeros Leads ahora',
  'cortex.feedbacks': 'Feedbacks',
  'cortex.fits': 'Encaja',
  'cortex.fitsNot': 'No encaja',
  'cortex.footer':
    'Cuando corriges u olvidas una declaración, ya no se usará para clasificar tus Leads.',
  'cortex.forget': 'Olvidar',
  'cortex.hero': 'Esto es lo que Leadscraper ha aprendido de tus {n} evaluaciones.',
  'cortex.heroEmpty':
    'Aún vacío. Leadscraper comenzará a aprender cuando evalúes los primeros Leads.',
  'cortex.heroEmptySub':
    'Leadscraper es la memoria de tu perfil: qué prefieres, qué rechazas y dónde el sistema aún no está seguro.',
  'cortex.heroSub':
    'Puedes confirmar, corregir u olvidar cada declaración. Los cambios se aplicarán en la próxima ejecución de clasificación.',
  'cortex.learned': 'Lo que Leadscraper ha aprendido',
  'cortex.matchRate': 'Tasa de coincidencia',
  'cortex.medium': 'medio',
  'cortex.mediumNote': 'sigue en observación',
  'cortex.patterns': 'Patrones aprendidos',
  'cortex.patternsPending': 'Pendientes de confirmar',
  'cortex.perWeek': 'por semana',
  'cortex.plain': 'En palabras simples, como tú lo leerías.',
  'cortex.roi.avgOrder': 'Ø Volumen de pedido',
  'cortex.roi.disclaimer':
    'Valor calculado, basado en tu tasa de acierto actual. Cuando Leadscraper madure, las cifras serán más realistas.',
  'cortex.roi.expectedFits': 'Leads esperados que encajan',
  'cortex.roi.leads': 'Leads',
  'cortex.roi.newCustomers': 'Nuevos clientes',
  'cortex.roi.revenue': 'Ingresos proyectados',
  'cortex.roi.revenueSub': 'con el estado actual',
  'cortex.roi.sub': 'Lo que podría valer tu estado actual.',
  'cortex.roi.title': 'Estimación de ROI',
  'cortex.roi.viaRate': 'Ø Tasa de acierto',
  'cortex.roi.winLabel': 'Tasa de conversión',
  'cortex.roi.winRate': 'Tasa de conversión',
  'cortex.runs.col.action': 'Acción',
  'cortex.runs.col.date': 'Fecha',
  'cortex.runs.col.leads': 'Leads',
  'cortex.runs.col.matchrate': 'Tasa de coincidencia',
  'cortex.runs.col.params': 'Parámetros de búsqueda',
  'cortex.runs.count': 'Ejecuciones',
  'cortex.runs.repeat': 'Repetir',
  'cortex.runs.sub': 'Todas las consultas que has iniciado para esta audiencia.',
  'cortex.runs.title': 'Búsquedas',
  'cortex.sinceStart': 'desde el inicio',
  'cortex.step': 'Paso',
  'cortex.step1': 'Abrir Leads',
  'cortex.step1d': 'Revisa las primeras tarjetas en tu lista.',
  'cortex.step2': 'Encaja / No encaja',
  'cortex.step2d': 'Evalúa cada Lead. Cuando rechaces, da una razón breve.',
  'cortex.step3': 'Revisar aquí',
  'cortex.step3d': 'Después de ~20 feedbacks, aquí aparecerán las primeras declaraciones claras.',
  'cortex.strong': 'fuerte',
  'cortex.strongNote': 'patrones fiables',
  'cortex.tierMedium': 'Medio',
  'cortex.tierStrong': 'Fuerte',
  'cortex.tierWeak': 'Débil',
  'cortex.title': 'Memory',
  'cortex.uncertain': 'Leadscraper no está seguro aquí',
  'cortex.weak': 'débil',
  'cortex.weakNote': 'Leadscraper no está seguro aquí',

  'crm.bald': 'PRONTO',
  'crm.comingSoon': 'Próximamente disponible',
  'crm.customAgent': 'Agente personalizado',
  'crm.history.duplicate': 'Ya en CRM',
  'crm.history.empty': 'Aún no hay envíos. Usa "Enviar a CRM" en un Lead para comenzar.',
  'crm.history.failed': 'Falló',
  'crm.history.loading': 'Cargando…',
  'crm.picker.title': '¿A qué CRM enviar?',
  'crm.picker.subtitle': 'Elige dónde debe ir este lead. Puedes cambiar cuando quieras.',
  'crm.history.sent': 'Enviado',
  'crm.history.sub': 'Los últimos 50 Leads enviados a tu CRM, más recientes primero.',
  'crm.history.title': 'Historial de envíos',
  'crm.mcpComingSoon': 'Disponible cuando el servidor MCP esté en vivo.',
  'crm.mcpSub':
    'Conecta Leadscraper directamente con Claude, ChatGPT, Cursor o tu propio agente vía Model Context Protocol. Tus Leads, perfiles y Memory estarán disponibles nativamente como herramientas.',
  'crm.mcpTitle': 'Leadscraper como servidor MCP',
  'crm.preview.bulkBody':
    'Crea {n} registros de organizaciones (y personas para Leads con datos de contacto). Se omitirán los duplicados que ya estén en tu CRM: tus registros existentes permanecerán intactos.',
  'crm.preview.bulkSub': '{n} Leads serán enviados a tu CRM',
  'crm.preview.dedupNote':
    'Si este Lead ya está en tu CRM (comparación por dominio), se registrará el envío pero no se creará un nuevo registro: mantienes lo que tienes.',
  'crm.preview.noContact': 'Solo Org',
  'crm.preview.plusMore': '+ {n} más…',
  'crm.preview.pushBtn': 'Enviar ahora',
  'crm.preview.pushNBtn': 'Enviar {n} ahora',
  'crm.preview.pushing': 'Enviando…',
  'crm.preview.singleSub': 'Esto será creado en tu CRM',
  'crm.preview.skipPerson': '· omitido (sin email o teléfono en este Lead)',
  'crm.preview.title': 'Vista previa: Envío a {crm}',
  'crm.preview.willCreate': 'Se creará',
  'crm.preview.willCreatePerson': '· contacto principal con email/teléfono',
  'crm.preview.withContact': 'Org + Persona',
  'crm.section.available': 'Disponible',
  'crm.section.comingNext': 'Próximamente',
  'crm.section.comingNextLabel': 'Pronto',
  'crm.section.connected': 'Conectado',
  'crm.section.morePlanned': 'Más integraciones planificadas',
  'crm.tooltipComingSoon':
    'La integración con {name} llegará pronto. Te notificaremos cuando esté disponible.',

  'dash.actNow': 'Abrir',
  'dash.action': 'Acción',
  'dash.activeRuns.run': 'Búsqueda',
  'dash.activeRuns.runs': 'Búsquedas',
  'dash.activeRuns.title': 'Leadscraper está trabajando para ti',
  'dash.avgOrder': 'Ø Volumen de pedido',
  'dash.cadence.daily': 'diariamente',
  'dash.cadence.hourly': 'cada hora',
  'dash.cadence.manual': 'manual',
  'dash.cadence.monthly': 'mensualmente',
  'dash.cadence.weekly': 'semanalmente',
  'dash.close': 'Cerrar',
  'dash.col.lastRun': 'Última ejecución',
  'dash.col.leads': 'Leads',
  'dash.col.matchrate': 'Tasa de coincidencia',
  'dash.col.profile': 'Audiencia',
  'dash.col.profileH': 'Audiencia',
  'dash.col.query': 'Audiencia objetivo',
  'dash.col.queryName': 'Consulta',
  'dash.col.statusH': 'Estado',
  'dash.col.trained': 'Entrenado',
  'dash.col.whenH': 'Cuándo',
  'dash.company.analyzeBtn': 'Analizar',
  'dash.company.analyzeFresh': '✨ Entrenar Leadscraper',
  'dash.company.analyzing': 'Leadscraper leyendo…',
  'dash.company.cachedToast': 'Perfil cargado desde memoria.',
  'dash.company.collapsed':
    'Leadscraper conoce tu empresa: todas las justificaciones se adaptan a ti.',
  'dash.company.doneToast': '✓ Leadscraper ya te conoce.',
  'dash.company.editBody':
    'Introduce tu website empresarial. Leadscraper la lee y recuerda permanentemente qué ofreces, a quién vendes, y qué argumentos usas: para que cada justificación en tus Leads se convierta en una estrategia de propuesta personalizada en lugar de solo "encaja con el sector".',
  'dash.company.editTitle': 'Para que Leadscraper perfeccione tus propuestas, cuéntanos qué vendes',
  'dash.company.emptyBody':
    'Introduce tu website empresarial y Leadscraper entenderá en 10 segundos qué vendes. A partir de entonces, cada justificación de Lead explicará concretamente por qué TU oferta encaja con ESTE Lead, en lugar de solo "encaja con el sector". Ese es el momento eureka.',
  'dash.company.emptyTitle': 'Leadscraper aún no te conoce',
  'dash.company.errorFallback': 'Análisis fallido: por favor, inténtalo de nuevo.',
  'dash.company.setupBadge': 'Configuración necesaria',
  'dash.company.stage1': 'Cargando tu sitio web…',
  'dash.company.stage2': 'Entendiendo lo que ofreces…',
  'dash.company.stage3': 'Identificando tu público objetivo…',
  'dash.company.stage4': 'Conectando todo con tu valor…',
  'dash.company.stage5': 'Casi terminado…',
  'dash.company.urlHint':
    'Introduce tu website. En cuanto esté la URL, podrás entrenar a Leadscraper.',
  'dash.company.urlPlaceholder': 'https://mi-empresa.es',
  'dash.cortex.reanalyze':
    'Analizar de nuevo: Leadscraper revisará la página con una perspectiva fresca',
  'dash.cortex.reanalyzeKeepTitle': '¿Conservar tus cambios manuales?',
  'dash.cortex.reanalyzeKeepBody':
    'Has editado este perfil de empresa manualmente. Al volver a analizar se pueden conservar tus cambios y actualizar solo el resto, o restablecer todo a las nuevas sugerencias de la IA.',
  'dash.cortex.reanalyzeKeepCta': 'Conservar mis cambios',
  'dash.cortex.reanalyzeResetCta': 'Restablecer a sugerencias de la IA',
  'dash.cortex.sells': 'Lo que vendes',
  'dash.cortex.title': 'Lo que Leadscraper sabe sobre tu empresa',
  'dash.cortex.toWhom': 'A quién',
  'dash.cortex.valueProps': 'Propuestas de valor',
  'dash.date': 'Fecha',
  'dash.done': 'Completado',
  'dash.empty.defineAudience': '+ Definir audiencia objetivo ahora',
  'dash.empty.noFiltered': 'No hay consultas en este filtro.',
  'dash.empty.noProfile': 'Aún no hay ninguna audiencia creada.',
  'dash.empty.noQueryStartedAll':
    'Aún no se ha iniciado ninguna consulta de leads en todas las audiencias.',
  'dash.empty.noQueryStartedForProfile':
    'Aún no se ha iniciado ninguna consulta de Leads para "{profile}".',
  'dash.empty.showAll': 'Mostrar todos ({n})',
  'dash.empty.startHint':
    'Haz clic en "Iniciar búsqueda" para definir una consulta (tipo de empresa, región, rol, ...).',
  'dash.filter.all': 'Todos',
  'dash.filter.oneshot': 'Únicos',
  'dash.filter.running': 'En ejecución',
  'dash.filter.scheduled': 'Programados',
  'dash.fmtNext.inDays': 'en {n}d',
  'dash.fmtNext.inH': 'en {n}h',
  'dash.fmtNext.inMin': 'en {n}m',
  'dash.fmtNext.soon': 'inicia pronto',
  'dash.fmtNext.tomorrow': 'mañana',
  'dash.funnel.deepened': 'Profundizado',
  'dash.funnel.evaluated': 'Evaluado',
  'dash.funnel.identified': 'Identificado',
  'dash.funnel.ready': 'Listo',
  'dash.inProgress': 'En proceso',
  'dash.inbox.edge': 'Caso límite',
  'dash.inbox.edges': 'Casos límite',
  'dash.inbox.hint': 'Sugerencia',
  'dash.inbox.leadsFrom': '{leads} Leads de {profiles} {profileWord}',
  'dash.inbox.less': 'Mostrar menos',
  'dash.inbox.more': '+ {n} más',
  'dash.inbox.profileWord': 'audiencia',
  'dash.inbox.profilesWord': 'audiencias',
  'dash.inbox.showAll': 'Mostrar todos los {n}',
  'dash.inbox.title': 'Pendientes para hoy',
  'dash.lastQueries.subAll':
    'Tus búsquedas iniciadas más recientemente en todos los perfiles. Al hacer clic se abren los detalles y puedes repetir la búsqueda.',
  'dash.lastQueries.subForProfile':
    'Tus búsquedas iniciadas más recientemente para "{profile}". Al hacer clic se abren los detalles y puedes repetir la búsqueda.',
  'dash.lastQueries.title': 'Últimas consultas de Leads',
  'dash.lastSearch': 'Última búsqueda: {result}',
  'dash.lastSearch.error': 'Error',
  'dash.lastSearch.zero': '0 Leads',
  'dash.lastYear': 'Último año',
  'dash.leads': 'Leads',
  'dash.leadsGen': 'Leads generados',
  'dash.leadsGenerated': 'Lead generado',
  'dash.learning.body':
    'Con cada ✓ "encaja" o ✗ "no encaja" {scope}, Leadscraper perfecciona su comprensión de tu Lead ideal, y filtra los próximos resultados en consecuencia.',
  'dash.learning.cta': 'Evaluar {n} Leads',
  'dash.learning.hint': 'Inicia una búsqueda arriba. En cuanto haya Leads, podrás evaluarlos.',
  'dash.learning.scopeAll': 'en tus audiencias',
  'dash.learning.scopeProfile': 'para "{name}"',
  'dash.learning.title': 'Leadscraper espera tu primer feedback',
  'dash.maturity.label': 'Nivel de madurez: {label}',
  'dash.maturity.next.many': 'Faltan {n} feedbacks hasta {stage}.',
  'dash.maturity.next.one': 'Falta {n} feedback hasta {stage}.',
  'dash.maturity.stage.calibrated': 'Calibrado',
  'dash.maturity.stage.early': 'Aprendiendo',
  'dash.maturity.stage.mature': 'Maduro',
  'dash.maturity.usage':
    'Leadscraper utiliza tu feedback con diferente intensidad según el nivel de madurez en la próxima búsqueda.',
  'dash.months': 'May,Jun,Jul,Ago,Sep,Oct,Nov,Dic,Ene,Feb,Mar,Abr',
  'dash.newBadge': 'nuevo',
  'dash.newCust': 'Nuevos clientes',
  'dash.newCustomers': 'Nuevos clientes',
  'dash.newProfile': 'Nueva audiencia',
  'dash.nextRun.autoPaused': 'Auto-pausado · 3 búsquedas vacías',
  'dash.nextRun.in': 'Próxima ejecución en {time}',
  'dash.nextRun.manual': 'Manual · sin horario',
  'dash.nextRun.paused': 'Pausado',
  'dash.nextRun.pausedCredits': 'Pausado · Credits agotados',
  'dash.nextRun.soon': 'Próximamente',
  'dash.nextUp': 'A continuación',
  'dash.onlyFavorites': 'Solo favoritos',
  'dash.openLeads': 'Abrir Leads →',
  'dash.openProfile': 'Abrir Leads',
  'dash.profileDrop.create': 'Crear primera audiencia',
  'dash.profileDrop.createSub': 'Define tu audiencia objetivo y podrás comenzar',
  'dash.profiles': 'activo',
  'dash.progress': 'Progreso',
  'dash.projRevenue': 'Ingresos proyectados',
  'dash.projectedRevenue': 'Ingresos proyectados',
  'dash.query.businessType': 'Tipo de empresa',
  'dash.query.contact': 'Persona de contacto',
  'dash.query.dashExplain':
    '"—" significa: Leadscraper no rastreó el valor (llegará con V1.13 como rastreo completo de ejecución).',
  'dash.query.deepAnalysis': 'Análisis en profundidad',
  'dash.query.deepAnalysisHint': 'Website + aviso legal revisados',
  'dash.query.delivered': 'Entregado',
  'dash.query.deliveredHint': 'Resultados efectivos',
  'dash.query.evaluated': 'Evaluado',
  'dash.query.evaluatedHint': 'Razonamiento de Leadscraper aplicado',
  'dash.query.extras': 'Criterios adicionales',
  'dash.query.failedTitle': 'Búsqueda fallida',
  'dash.query.header': 'Consulta de Leads',
  'dash.query.howWorked': 'Cómo ha trabajado Leadscraper',
  'dash.query.identified': 'Identificado',
  'dash.query.identifiedHint': 'Empresas encontradas en búsqueda web + directorios',
  'dash.query.leadsSoFar': '{n} Leads hasta ahora · aún ejecutándose',
  'dash.query.loading': 'cargando…',
  'dash.query.noLeads': 'No se encontraron Leads',
  'dash.query.profile': 'Audiencia: {name}',
  'dash.query.region': 'Región / Ubicación',
  'dash.query.rerun': 'Ejecutar de nuevo',
  'dash.query.rerunTitle':
    'Volver a pasar esta consulta por Leadscraper (p. ej. tras actualizar la audiencia)',
  'dash.query.restart': 'Reiniciar',
  'dash.query.runHistory': 'Historial de las últimas ejecuciones',
  'dash.query.runningNoLeads': 'Aún ejecutándose, pronto llegarán Leads',
  'dash.query.showLeads': 'Mostrar {n} Leads',
  'dash.query.rerunRow': 'Repetir',
  'dash.query.rerunCta': 'Repetir búsqueda',
  'dash.query.searchedLabel': 'Lo que buscaste',
  'dash.query.autoRepeat': 'Repetir automáticamente',
  'dash.query.openSettings': 'Abrir ajustes',
  'dash.query.startedAt': 'Iniciado: {date}',
  'dash.query.suggestions': 'Sugerencias de Leadscraper',
  'dash.query.technicalDetails': 'Detalles técnicos',
  'dash.query.unfeasibleTitle': 'Leadscraper considera que la consulta no es viable',
  'dash.query.unnamed': 'Consulta sin nombre',
  'dash.query.whenRuns': '¿Cuándo se ejecuta esta búsqueda?',
  'dash.queryHint': 'Nota sobre la búsqueda',
  'dash.queryId': 'ID de consulta',
  'dash.renameQuery': 'Renombrar consulta',
  'dash.roi': 'Calculadora ROI',
  'dash.roiShort': 'ROI',
  'dash.run.audience': 'Audiencia objetivo:',
  'dash.run.businessType': 'Tipo de empresa',
  'dash.run.businessTypeP': 'ej. fabricante de cajas plegables con troquel propio',
  'dash.run.cancel': 'Cancelar',
  'dash.run.contact': 'Persona de contacto',
  'dash.run.contactP': 'ej. dirección general, dirección de compras',
  'dash.run.extras': 'Restricciones adicionales',
  'dash.run.extrasP':
    'ej. no corporativo, preferible gestión familiar, certificación FSC preferida, 50–250 empleados',
  'dash.run.forWhich': '¿Para qué audiencia objetivo?',
  'dash.run.minField': 'Indica al menos el tipo de empresa',
  'dash.run.notBackendProfile':
    'Esta audiencia aún no está registrada en el backend. Crea una real a través de',
  'dash.run.notBackendProfileCta': '+ Nueva audiencia',
  'dash.run.notBackendProfileEnd': '. Entonces el scraper funcionará.',
  'dash.run.optional': '(opcional)',
  'dash.run.pastQueries': 'Últimas consultas de Leads',
  'dash.run.pastQueriesHint': 'Clic para usar los valores',
  'dash.run.region': 'Región / Ubicación',
  'dash.run.regionHint':
    'Ciudad, comunidad autónoma, región o "nacional": escríbelo como buscarías.',
  'dash.run.regionP':
    'ej. Madrid, Comunidad de Madrid, área metropolitana de Barcelona, o nacional',
  'dash.run.searchBtn': 'Buscar 10 Leads',
  // LEA-338 Part A / LEA-355 — auto-enrich contact-persons toggle (added in LEA-355).
  'dash.run.withContact.label': 'Enriquecer la persona de contacto automáticamente',
  'dash.run.withContact.hint':
    'Cada nuevo lead se enriquece al instante con las personas de contacto adecuadas y sus datos. También puedes revisar primero los leads y enriquecerlos uno a uno, recomendable cuando estás empezando.',
  'dash.run.withContact.cost':
    'Hasta {n} créditos: solo se cobran si el enriquecimiento tiene éxito.',
  // LEA-418: per-phase credit-cost transparency
  'dash.run.cost.base': 'Coste: {n} leads = {n} créditos (1 por lead entregado).',
  'dash.run.cost.extras': 'Contactos e insights: +1 crédito/lead cada uno, solo si los pides.',
  'lt.next.connectCostHint': 'Solo 1 crédito si hay un contacto localizable; si no, gratis.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'lt.next.connectFreeHint': 'Gratis — solo pagas al desbloquear a una persona de contacto.',
  // LEA-356 — cascading Phase-3 acquisition-plan toggle.
  'dash.run.withPlan.label': 'Generar plan de captación automáticamente',
  'dash.run.withPlan.hint':
    'Para cada lead enriquecido se crea un plan de captación a medida: un enfoque de contacto concreto basado en las personas de contacto encontradas.',
  'dash.run.withPlan.cost':
    'Hasta {n} créditos: solo se cobran si el plan se genera correctamente.',
  'dash.run.sub': '10 Credits · 10 Leads · típicamente 5–12 min',
  'dash.run.title': 'Iniciar búsqueda de Leads',
  'dash.sched.change': 'cambiar',
  'dash.sched.daily': 'Diariamente',
  'dash.sched.dailySub': '10 leads frescos cada día',
  'dash.sched.manual': 'Manual',
  'dash.sched.manualSub': 'Sin programación, solo al hacer clic',
  'dash.sched.pause': '⏸ Pausar',
  'dash.sched.resume': '▶ Reanudar',
  'dash.sched.sub': 'Leadscraper extrae regularmente 10 leads nuevos para esta audiencia.',
  'dash.sched.time': 'Programar consultas',
  'dash.sched.title': 'Programar consultas',
  'dash.sched.toast.error': 'No se pudo guardar la programación: {err}',
  'dash.sched.toast.manual': 'Programación eliminada: la audiencia solo se ejecuta manualmente.',
  'dash.sched.toast.paused': 'Audiencia en pausa: sin ejecuciones automáticas.',
  'dash.sched.toast.set':
    'Programación configurada: Leadscraper funciona automáticamente ({cadence}).',
  'dash.sched.twiceWeekly': 'Lun / Jue',
  'dash.sched.twiceWeeklySub': '2× por semana, ~20 leads/semana',
  'dash.sched.weekly': 'Semanalmente',
  'dash.sched.weeklySub': '10 leads una vez por semana',
  'dash.schedInd.nextRun': 'próxima ejecución',
  'dash.schedInfo.everyNh': 'cada {n} h',
  'dash.schedInfo.hourly': 'cada hora',
  'dash.schedInfo.oneshot': 'única vez',
  'dash.schedInfo.paused': 'pausado',
  'dash.simulation': 'Simulación',
  'dash.startRun': 'Iniciar búsqueda',
  'dash.startRunDisabledHint': 'Crea primero una audiencia y luego inicia una búsqueda',
  'dash.status': 'Estado',
  'dash.status.delivered.many': '{n} Leads entregados',
  'dash.status.delivered.one': '{n} Lead entregado',
  'dash.status.deliveredSuffix.many': 'Leads entregados',
  'dash.status.deliveredSuffix.one': 'Lead entregado',
  'dash.status.done': 'Completado',
  'dash.status.empty': 'Sin resultados',
  'dash.status.failed': 'Fallido',
  'dash.status.running': 'En ejecución',
  'dash.status.runningEllipsis': 'En ejecución…',
  'dash.status.runningPrefix': 'En ejecución · ',
  'dash.status.unfeasible': 'No viable',
  'dash.step.delivery': 'Compilar Leads',
  'dash.step.discovery': 'Identificar empresas',
  'dash.step.done': 'Finalizado',
  'dash.step.fallbackProfile': 'Audiencia',
  'dash.step.hydration': 'Analizar empresas en profundidad',
  'dash.step.planning': 'Leadscraper recuerda',
  'dash.step.reasoning': 'Leadscraper evalúa',
  'dash.step.starting': 'Iniciando…',
  'dash.timeline': 'Evolución de métricas en el tiempo',
  'dash.totalLeads': 'Total de Leads',
  'dash.whenCell.next': 'próximo {label}',
  'dash.winRate': 'Tasa de conversión',
  'dash.yourLeads': 'Tus Leads',
  'dash.yourProfiles': 'Tus audiencias',
  'dash.yourProfilesSub':
    'Todas las audiencias que entrenas. Un clic abre los leads de esta audiencia.',

  'det.accepted': 'Aceptado',
  'det.back': 'Volver a los resultados de búsqueda',
  'det.city': 'Ubicación',
  'det.companyProfile': 'Perfil de empresa',
  'det.contact': 'Contacto',
  'det.contactsEmpty':
    'Aún no se han extraído contactos. Leadscraper busca en aviso legal + LinkedIn.',
  'det.crmSoonTitle':
    'La integración con CRM llega pronto. Te notificaremos cuando HubSpot, Pipedrive y otros estén conectados.',
  'det.decider': 'Tomador de decisiones',
  'det.delivers': 'Proporciona:',
  'det.draftMail': 'Preparar borrador de email',
  'det.draftMailSoonToast':
    'Los borradores de email desde el Lead aún no están disponibles, pronto.',
  'det.fetched': 'obtenido',
  'det.fits': 'Encaja',
  'det.fitsNot': 'No encaja',
  'det.founded': 'Fundación',
  'det.markedFit': '✓ Marcado como encaja',
  'det.rejectAnyway': '↩ ¿No encaja después de todo?',
  'det.markedNotFit': '× Marcado como no encaja',
  'det.memoryHint': 'Nota para tu memoria',
  'det.memoryHintText':
    'Cuando aceptes o rechaces este Lead, afectará Leads similares en "{profile}", pero no tus otros perfiles.',
  'det.open': 'Abrir',
  'det.patterns': 'Patrones aprendidos que aplican aquí',
  'det.publicOnly':
    'Todas las fuentes son de acceso público. Leadscraper nunca almacena datos de directorios no públicos o de pago.',
  'det.research.footer':
    'Leadscraper prueba diferentes métodos de búsqueda (LinkedIn, sitio web de empresa, prensa, Xing) antes de recurrir al CEO como alternativa. Así es transparente por qué se muestra exactamente este contacto.',
  'det.research.hit': '✓ Resultado',
  'det.research.label': 'Proceso de investigación',
  'det.research.noHit': '○ sin resultado',
  'det.research.resultMany': 'Resultados',
  'det.research.resultOne': 'Resultado',
  'det.research.summaryFallback':
    '{n} métodos de búsqueda probados, ningún rol específico encontrado, CEO como alternativa',
  'det.research.summaryFound': 'Contacto encontrado en etapa {stage}: {label}',
  'det.research.summaryNoHit': '{n} métodos de búsqueda sin resultados',
  'det.sector': 'Sector',
  'det.shortProfile': 'Perfil breve',
  'det.similar': 'Similar a Leads que has aceptado antes',
  'det.size': 'Empleados',
  'det.sourcesCount': 'Fuentes',
  'det.sourcesSub':
    'Cada campo en este Lead se puede rastrear hasta una fuente pública específica.',
  'det.sourcesTitle': 'De dónde proviene esta información',
  'det.trail.searched': 'Cortex consultó {n} fuentes públicas',
  'det.trail.website': 'Sitio web',
  'det.trail.register': 'Registro mercantil',
  'det.trail.google': 'Búsqueda en Google',
  'det.trail.press': 'Prensa',
  'det.trail.pages': '{n} páginas',
  'det.trail.profiles': '{n} perfiles',
  'det.capturedAt': 'registrado',
  'det.derivedAt': 'deducido',
  'det.sourcePage': 'Página de origen',
  'det.sourcesBelegtCount': '{n} con fuente',
  'det.sourcesTagline': 'De dónde viene cada dato: abierto y verificable.',
  'det.sourcesBelegt': '{n} de {total} con fuente',
  'det.sourcesFieldCount': '{n} campos',
  'det.lastChecked': 'última comprobación',
  'det.sourcesUnsourced': 'Aún sin fuente',
  'det.sourcesHonesty':
    'Los datos oficiales y públicos están documentados directamente; las estimaciones de IA se marcan como tales. Leadscraper no usa bases de datos de pago.',
  'det.sourcesFlex':
    'Otros ocultan de dónde vienen sus datos. Nosotros mostramos cada fuente, verificable.',
  'ld.tier.officialName': 'Fuente oficial',
  'ld.tier.officialSub': 'Registro oficial e información legal obligatoria',
  'ld.tier.publicName': 'Fuente pública',
  'ld.tier.publicSub': 'Consultable públicamente en la web',
  'ld.tier.inferredName': 'Deducido por Cortex',
  'ld.tier.inferredSub': 'Estimación: verifica antes de enviar',
  'ld.tier.officialFallback': 'Fuente oficial',
  'ld.tier.publicFallback': 'Fuente pública',
  'ld.tier.inferredFallback': 'Deducido por Cortex',
  'ld.tier.legendOfficial': 'oficial',
  'ld.tier.legendPublic': 'público',
  'ld.tier.legendInferred': 'deducido · verificar',
  'ld.tier.legendUnsourced': 'pendiente',
  'ld.srcLabel.dork': 'Búsqueda web pública',
  'ld.srcLabel.icypeas_finder': 'Correo deducido',
  'ld.srcLabel.role_match': 'Coincidencia de rol',
  'ld.srcLabel.cortexNace': 'Análisis de sector de Cortex',
  'ld.field.vatId': 'NIF-IVA',
  'ld.field.facebook': 'Facebook',
  'ld.field.instagram': 'Instagram',
  'ld.field.country': 'País',
  'ld.field.contactPhone': 'Teléfono (contacto)',
  'det.toCRM': 'Transferir a CRM',
  'det.webExcerpts': 'Extractos del sitio web',
  'det.website': 'Sitio web',
  'det.whyFits': 'Por qué encaja contigo',
  'det.whyFitsSub': 'basado en lo que Leadscraper ha aprendido sobre ti',

  'error.account_deleted': 'Esta cuenta ha sido eliminada.',
  'error.email_unverified':
    'Por favor verifica primero tu dirección de email (enlace en el email de registro).',
  'error.demo_read_only': 'Esto está desactivado en la demo. No se ha cambiado nada.',
  'error.impersonate_target_not_found':
    'Cuenta de prueba no encontrada: el UID no existe en este entorno de BD (Mini / Staging / Producción).',
  'error.invalidInput': 'Entrada inválida.',
  'error.noProfile': 'Ninguna audiencia seleccionada.',
  'error.profileNotRegistered':
    'La audiencia aún no está registrada en el backend. Abro el asistente.',
  'error.unauthenticated':
    'No has iniciado sesión. Por favor recarga la página e inicia sesión nuevamente.',

  'expired.body':
    'Tu acceso está en pausa. Reactiva tu suscripción para volver a buscar Leads y ejecutar tus grupos objetivo.',
  'expired.readOnly':
    'Puedes seguir viendo y exportando tus Leads. Las nuevas búsquedas y la búsqueda de contactos requieren una suscripción activa.',
  'expired.creditsKept': 'Tus {credits} Credits están congelados, no eliminados.',
  'expired.cta': 'Reactivar suscripción',
  'expired.ctaLoading': 'Cargando…',
  'expired.title': 'Tu suscripción ha finalizado',
  // LEA-704: welcome-back screen for expired accounts moved into the reveal model.
  'revealMigration.title': 'Bienvenido de nuevo',
  'revealMigration.subtitle': 'Leadscraper ahora cobra por contacto',
  'revealMigration.free': 'Buscar empresas y contactos es gratis',
  'revealMigration.payPerContact': 'Solo pagas cuando desbloqueas a una persona de contacto',
  'revealMigration.units': 'Tu saldo se mantiene: {n} contactos para desbloquear',
  'revealMigration.unitsOne': 'Tu saldo se mantiene: 1 contacto para desbloquear',
  'revealMigration.unitsNone': 'Compra contactos en paquetes cuando los necesites',
  'revealMigration.cta': 'Continuar',
  'revealMigration.ctaLoading': 'Un momento…',
  'revealMigration.error': 'No ha funcionado. Inténtalo de nuevo.',

  'fb.blocked.headline': 'La consulta es demasiado amplia',
  'fb.blocked.subline':
    'Con esto Leadscraper encontraría principalmente portales, asociaciones o consultorías, no empresas individuales reales.',
  'fb.cta.adjust': 'Ajustar consulta',
  'fb.cta.bypass': 'Iniciar de todos modos',
  'fb.cta.bypassTitle':
    'La consulta pasará por Leadscraper de todos modos, bajo tu propia responsabilidad',
  'fb.cta.sharpen': 'Volver y refinar',
  'fb.field.ansprechpartner': 'Persona de contacto',
  'fb.field.ort': 'Ubicación',
  'fb.field.rawQuery': 'Texto libre',
  'fb.field.region': 'Región',
  'fb.field.unternehmensart': 'Tipo de empresa',
  'fb.field.zusatz': 'Criterios adicionales',
  'fb.fieldWarnings': 'Campos con advertencias',
  'fb.suggestions': 'Formulaciones más específicas',
  'fb.suggestionsHint':
    'Copia una de las sugerencias de vuelta al campo o formula por ti mismo: esto aumenta la tasa de coincidencias de manera medible.',
  'fb.warning.headline': 'Esta consulta es muy específica',
  'fb.warning.subline':
    'Con esta combinación de filtros, Leadscraper posiblemente encuentre pocos o ningún resultado. Puedes iniciar de todos modos o abrir un poco la consulta.',

  'find.amount': 'Cantidad de Leads',
  'find.amountHint': 'El valor debe estar entre 1 y 1000',
  'find.businessType': 'Tipo de empresa',
  'find.businessTypeP': 'ej. restaurante, abogado, asesor fiscal',
  'find.contact': 'Persona de contacto',
  'find.contactP': 'ej. propietario, vendedor, director general',
  'find.creditNote': '(1 Lead = 1 Credit)',
  'find.extras': 'Restricciones adicionales',
  'find.extrasP': 'Define tu audiencia objetivo con más precisión',
  'find.forProfile': '¿Para qué audiencia?',
  'find.forProfileHint': 'Tus valoraciones entrenan a Leadscraper para esta audiencia.',
  'find.location': 'Ubicación',
  'find.locationP': 'ej. Madrid, Barcelona, Valencia',
  'find.start': 'Iniciar Leadscraper',
  'find.title': 'Encontrar nuevos Leads',
  'find.trainsProfile': 'Entrena',

  'hero.eyebrow': 'Leadscraper te conoce',
  'hero.stat.feedbacks': 'Feedbacks totales',
  'hero.stat.matchrate': '⌀ Tasa de coincidencia',
  'hero.stat.profiles': 'audiencias activas',
  'hero.sub':
    'Cada "Encaja / No encaja" define qué Leads aparecerán mañana arriba. Estas son tus métricas actuales.',
  'hero.title': 'En todas las audiencias, Leadscraper se vuelve más preciso con cada valoración.',

  'inbox.sched.body': 'Próxima ejecución {rel}: nuevos Leads llegarán automáticamente {where}.',
  'inbox.sched.cta': 'Ver',
  'inbox.sched.inCRM': 'en el CRM',
  'inbox.sched.inList': 'en tu lista',
  'inbox.sched.title': '{n} ejecuciones programadas activas',

  'ld.aggregatorWarn':
    'El sitio web propio de la empresa aún se está determinando. Mientras tanto mostramos la URL fuente (directorio/prensa) de donde proviene esta empresa.',
  'ld.comingSoon': '· próximamente',
  'ld.company': 'Empresa',
  'ld.companySite': 'Sitio web de la empresa',
  'ld.contactPhoneUnknown': 'Línea directa no pública',
  'ld.contacts': 'Contactos',
  'ld.decisionMaker': '· Decisor',
  'ld.email.apply': 'Aplicar patrón',
  'ld.email.confGuessed': 'estimado',
  'ld.email.confLikely': 'probable',
  'ld.email.confPlausible': 'plausible',
  'ld.email.copied': 'Email estimado copiado al portapapeles.',
  'ld.email.derivedFrom':
    'Derivado de {n} email{s} del sitio web de la empresa. {conf}: verifica antes de enviar.',
  'ld.email.noDirectExplain':
    'No encontramos el email directo de {first} {last}. Sin embargo, hemos identificado el esquema de emails de la empresa: al hacer clic te mostraremos la dirección probable. Tú tienes la responsabilidad.',
  'ld.email.notFound': 'No se encontró email directo para este contacto.',
  'ld.emailLabel': 'E-mail',
  'ld.emailPattern': 'Patrón de email',
  'ld.emailPattern.confHigh': 'alta',
  'ld.emailPattern.confLow': 'baja',
  'ld.emailPattern.confMid': 'media',
  'ld.emailPattern.hint': 'Todos los contactos de esta empresa probablemente siguen este patrón.',
  'ld.emailPattern.noPattern': 'Los emails encontrados ({n}) no siguen un patrón claro.',
  'ld.emailPattern.noSamples': 'No se encontraron emails de empleados en el sitio web.',
  'ld.emailPattern.notFound': 'No se encontró patrón',
  'ld.emailPattern.notRecognized': 'no reconocido',
  'ld.emailPattern.sourceMany': 'Fuentes',
  'ld.emailPattern.sourceOne': 'Fuente',
  'ld.fetchedThisWeek': 'esta semana',
  'ld.field.acquisitionHook': 'Gancho de captación de Leadscraper',
  'ld.field.centralEmail': 'Email central',
  'ld.field.centralPhone': 'Teléfono central',
  'ld.field.certs': 'Certificados',
  'ld.field.city': 'Ciudad',
  'ld.field.companyName': 'Nombre de empresa',
  'ld.field.customerRefs': 'Referencias de clientes',
  'ld.field.description': 'Perfil breve',
  'ld.field.email': 'Email (decisor)',
  'ld.field.employees': 'Número de empleados',
  'ld.field.firstName': 'Nombre (decisor)',
  'ld.field.foundedYear': 'Año de fundación',
  'ld.field.hrNumber': 'Número de registro mercantil',
  'ld.field.jobSnapshot': 'Vacantes abiertas',
  'ld.field.lastName': 'Apellido (decisor)',
  'ld.field.legalForm': 'Forma jurídica',
  'ld.field.linkedin': 'LinkedIn (decisor)',
  'ld.field.locations': 'Ubicaciones',
  'ld.field.nace': 'Sector NACE',
  'ld.field.ownership': 'Propietario / Historia',
  'ld.field.revenueRange': 'Rango de ingresos',
  'ld.field.role': 'Cargo (decisor)',
  'ld.field.sizeClass': 'Clase de tamaño',
  'ld.field.street': 'Calle',
  'ld.field.triggerEvent': 'Evento disparador',
  'ld.field.website': 'URL del sitio web',
  'ld.field.xing': 'XING (decisor)',
  'ld.field.deciderProfile': 'Perfil del responsable',
  'ld.field.zip': 'Código postal',
  'ld.linkedinPublic': 'LinkedIn · público',
  'ld.match.borderline': 'caso límite',
  'ld.match.excellent': 'excelente',
  'ld.match.solid': 'coincidencia válida',
  'ld.match.strong': 'coincidencia sólida',
  'ld.sparkle.certs': 'Certificados y premios',
  'ld.sparkle.customers': 'Referencias de clientes',
  'ld.sparkle.hookFake':
    'Aquí puedes conectar porque {company} muestra un perfil clásico de empresa mediana con necesidades concretas: encaja directamente con tu oferta.',
  'ld.sparkle.hookLabel': 'Gancho de captación de Leadscraper',
  'ld.sparkle.hookUnlockLink': 'el sitio web de tu empresa',
  'ld.sparkle.hookUnlockPost':
    '. Leadscraper entonces generará un gancho personalizado por cada lead.',
  'ld.sparkle.hookUnlockPre': 'Ingresa arriba en el dashboard ',
  'ld.sparkle.jobs': 'Snapshot de vacantes',
  'ld.sparkle.jobsBadge': '{n} vacantes abiertas',
  'ld.sparkle.locations': 'Ubicaciones',
  'ld.sparkle.locked': '· bloqueado',
  'ld.sparkle.ownerSince': 'desde {year}',
  'ld.sparkle.ownership': 'Estructura de propiedad',
  'ld.sparkle.staleAction':
    'Inicia la consulta nuevamente en el dashboard. Entonces generaremos para ESTE lead un gancho de captación personalizado más todas las señales de ventas (eventos disparadores, vacantes abiertas, clientes, ...).',
  'ld.sparkle.staleMsg':
    'Este lead fue generado antes de que tu perfil de empresa fuera registrado en Leadscraper.',
  'ld.sparkle.sub': '· Señales de ventas del análisis web en vivo',
  'ld.sparkle.title': 'Leadscraper Magic',
  'ld.sparkle.trigger': 'Evento disparador',
  'ld.sparkle.waitLabel': '· esperando re-ejecución',
  'ld.specialization': 'Especialización',
  'ld.srcDesc.firecrawl': 'Página principal del sitio web de la empresa (en caché).',
  'ld.srcDesc.footer':
    'Footer del sitio web: ubicaciones, certificados, vías de contacto alternativas.',
  'ld.srcDesc.haiku_extracted':
    'Leadscraper extrajo campos estructurados del contenido del sitio web hidratado (descripción, clientes, eventos desencadenantes).',
  'ld.srcDesc.handelsregister':
    'Registro empresarial alemán oficial: número HRB, sede, fecha de registro.',
  'ld.srcDesc.impressum':
    'Página de información legal con nombre de empresa, forma jurídica, dirección, administración. Se obtiene y analiza.',
  'ld.srcDesc.json_ld':
    'Metadatos legibles por máquina Schema.org del sitio web (perfil organizacional).',
  'ld.srcDesc.karriere':
    'Página de carreras: vacantes abiertas, perfiles buscados (señal de crecimiento).',
  'ld.srcDesc.kontakt':
    'Página de contacto/ubicación: números de teléfono, direcciones de email, posibles personas de contacto.',
  'ld.srcDesc.llm_haiku':
    'Leadscraper extrajo campos estructurados del contenido del sitio web hidratado (descripción, clientes, eventos desencadenantes).',
  'ld.srcDesc.llm_sonnet': 'Leadscraper evaluó el lead según tu audiencia + memoria.',
  'ld.srcDesc.news': 'Página de prensa/actualidad: últimos eventos, expansiones, premios.',
  'ld.srcDesc.regex_derived':
    'Derivado de otros datos: ej. patrón de email de email conocido de empresa + nombre.',
  'ld.srcDesc.serp': 'Resultados de Google para búsqueda específica de dominio o persona.',
  'ld.srcDesc.team': 'Página de equipo/empleados: personas y roles.',
  'ld.srcDesc.ueber_uns':
    'Autodescripción de la empresa: historia, propietarios, valores, referencias de clientes.',
  'ld.srcDesc.user_feedback':
    'Confirmaste o descartaste manualmente este Lead: nivel de confianza más alto.',
  'ld.srcLabel.firecrawl': 'Sitio web de la empresa (página principal)',
  'ld.srcLabel.footer': 'Footer del sitio web',
  'ld.srcLabel.haiku_extracted': 'Extracción IA',
  'ld.srcLabel.handelsregister': 'Registro mercantil',
  'ld.srcLabel.impressum': 'Aviso legal',
  'ld.srcLabel.json_ld': 'Datos estructurados (Schema.org)',
  'ld.srcLabel.karriere': 'Página de carreras',
  'ld.srcLabel.kontakt': 'Página de contacto',
  'ld.srcLabel.llm_haiku': 'Extracción IA',
  'ld.srcLabel.llm_sonnet': 'Evaluación IA',
  'ld.srcLabel.news': 'Prensa / Noticias',
  'ld.srcLabel.regex_derived': 'Derivación de patrones',
  'ld.srcLabel.serp': 'Búsqueda en Google',
  'ld.srcLabel.team': 'Página de equipo',
  'ld.srcLabel.ueber_uns': 'Página quiénes somos',
  'ld.srcLabel.user_feedback': 'Tu feedback',
  'ld.toast.accepted': '„{company}" guardado como Encaja.',
  'ld.toast.feedbackErr': 'No se pudo guardar el feedback. Inténtalo de nuevo.',
  'ld.toast.rejected': '„{company}" marcado como No encaja.',
  'ld.trust.inferred': '🔵 Derivado por IA',
  'ld.trust.inferredTitle': 'Derivado por la IA de Leadscraper: no es fuente oficial.',
  'ld.trust.official': '🛡 Oficial',
  'ld.trust.officialTitle': 'Fuente legalmente autorizada (registro mercantil/aviso legal).',
  'ld.trust.public': '🟡 Público',
  'ld.trust.publicTitle': 'Públicamente visible en el sitio web de la empresa.',
  'ld.uncertainty': 'Leadscraper está {score} aquí: {text}.',
  'ld.unverified.body':
    'Coincidencia genérica de sector: la especialización no fue mencionada en el contenido del sitio web. Si es estrictamente necesario, precisa la consulta (ej. „tienda especializada en {token}").',
  'ld.unverified.title': '„{token}" no pudo ser verificado por Leadscraper en esta empresa',
  'ld.viaCentralPhone': 'A través de centralita',
  'ld.websiteExcerpt': 'Extracto del sitio web',
  'ld.xingPublic': 'XING · público',

  'leads.act.cancel': 'Cancelar',
  'leads.act.details': 'Detalles',
  'leads.act.fits': 'Encaja',
  'leads.act.fitsDone': 'Guardado como Encaja',
  'leads.act.fitsNot': 'No encaja',
  'leads.act.fitsNotDone': 'Guardado como No encaja',
  'leads.act.reason': 'Elegir razón',
  'leads.allProfiles': 'Todas las audiencias',
  'leads.allProfilesHeader': 'Todas las audiencias',
  'leads.allProfilesShow': 'Mostrar todas las audiencias',
  'leads.backToActive': '← volver a la audiencia activa',
  'leads.cardView': 'Tarjetas',
  'leads.chip.edge': 'Caso límite · ¿Tu opinión?',
  'leads.chip.pattern': 'Forma un patrón',
  'leads.col.actions': 'Acciones',
  'leads.col.centralEmail': 'Email',
  'leads.col.centralPhone': 'Teléfono',
  'leads.col.city': 'Ubicación',
  'leads.col.company': 'Empresa',
  'leads.col.crm': 'CRM',
  'leads.col.decider': 'Decisor',
  'leads.col.founded': 'Fundación',
  'leads.col.lastActivity': 'Última actividad',
  'leads.col.legalForm': 'Forma legal',
  'leads.col.match': 'Coincidencia',
  'leads.col.nace': 'Sector',
  'leads.col.phase': 'Fase',
  'leads.col.phone': 'Teléfono',
  'leads.col.profile': 'Audiencia',
  'leads.col.revenue': 'Ingresos',
  'leads.col.sector': 'Sub-sector',
  'leads.col.size': 'Empleados',
  'leads.col.status': 'Estado',
  'leads.col.website': 'Sitio web',
  'leads.cols.btn': 'Columnas',
  'leads.cols.fixed': 'Fijo',
  'leads.cols.reset': 'Restablecer',
  'leads.cols.sub': 'Muestra solo lo que necesitas.',
  'leads.cols.title': 'Mostrar columnas',
  'leads.count': '{shown} de {total} Leads',
  'leads.crm.push': 'Enviar',
  'leads.crm.notSynced': 'No sincronizado',
  'leads.crm.syncedTo': 'Sincronizado con {crm}',
  'leads.crm.pushFailed': 'Error al enviar',
  'leads.crossOverview.many': '{n} leads · todas las audiencias',
  'leads.crossOverview.one': '{n} lead · todas las audiencias',
  'leads.daysAgo': 'hace {n} días',
  'leads.empty':
    'No hay leads para este perfil. Inicia una nueva búsqueda en "Buscar nuevos leads".',
  'leads.exp.memoryRefs': 'De tu memoria',
  'leads.exp.uncertain': 'Leadscraper tiene {score} de certeza: {note}.',
  'leads.exp.whyShown': 'Por qué Leadscraper te muestra este lead',
  'leads.export': 'Exportar',
  'leads.filter.all': 'Todos',
  'leads.filter.fits': 'Encaja',
  'leads.filter.fitsNot': 'No encaja',
  'leads.filter.unrated': 'Sin evaluar',
  'leads.filterBy': 'Filtrar por audiencia',
  'leads.footerHint':
    'Haz clic en una fila para ver el análisis breve. El botón "Detalles" abre la vista completa.',
  'leads.searchP': 'Empresa, sector, ubicación, decisor …',
  'leads.status.accepted': 'Encaja',
  'leads.status.rejected': 'No encaja',
  'leads.status.unseen': 'Sin revisar',
  'leads.sub': '{n} Leads · agrupados por tus perfiles. Un clic abre la vista 360° de la empresa.',
  'leads.tableView': 'Tabla',
  'leads.title': 'Tus leads',
  'leads.toast.accepted': '"{}" guardado como Encaja. Leadscraper aprende de esto.',
  'leads.toast.export': 'La función de exportación llegará pronto.',
  'leads.toast.rejected':
    '"{}" rechazado · Razón: {}. Leadscraper aprende de esto para próximas búsquedas.',

  'lp.card.examplesHint': '(IDs de Leads de tu historial de evaluaciones para este cluster)',
  'lp.card.hideExamples': 'Ocultar ejemplos',
  'lp.card.showExamplesMany': 'Mostrar {n} Leads de ejemplo',
  'lp.card.showExamplesOne': 'Mostrar {n} Lead de ejemplo',
  'lp.cl.age': 'Antigüedad de la empresa',
  'lp.cl.age.mock': 'Empresas establecidas fundadas antes de 2010 preferidas',
  'lp.cl.bizModel': 'Modelo de negocio',
  'lp.cl.bizModel.mock': 'Proveedores operativos, no agencias o intermediarios',
  'lp.cl.buyingSignals': 'Señales de compra',
  'lp.cl.buyingSignals.mock': 'Se buscan eventos trigger activos (crecimiento, contratación)',
  'lp.cl.domainBlock': 'Bloqueo de dominio',
  'lp.cl.domainBlock.mock': 'Dominios de competidores se excluyen consistentemente',
  'lp.cl.geo': 'Ubicación',
  'lp.cl.geo.mock': 'NRW + BaWü fuertemente preferidos, Alemania del Este menos',
  'lp.cl.industry': 'Industria',
  'lp.cl.industry.mock': 'Prefiere sector servicios (M-N) sobre industria',
  'lp.cl.ownership': 'Propietario',
  'lp.cl.ownership.mock': 'Empresas familiares >> Filiales PE y corporaciones',
  'lp.cl.role': 'Contacto',
  'lp.cl.role.mock': 'Se espera nivel director general, jefe de departamento muy junior',
  'lp.cl.size': 'Tamaño de empresa',
  'lp.cl.size.mock': 'Tendencia hacia operadores más pequeños (10-50 empleados)',
  'lp.cl.techStack': 'Stack tecnológico',
  'lp.cl.techStack.mock': 'Ciertas tecnologías se buscan/evitan consistentemente',
  'lp.cta.count': 'Evaluar {n} Leads',
  'lp.cta.open': 'Abrir Leads',
  'lp.cta.rate': 'Evaluar Leads',
  'lp.error.load': 'Error al cargar',
  'lp.evidence.many': '{n} evidencias',
  'lp.evidence.one': '{n} evidencia',
  'lp.journey.active': 'Activamente personalizado',
  'lp.journey.matchRate': 'Tasa de coincidencia',
  'lp.journey.matched': 'encajaron',
  'lp.journey.notMatched': 'no encajaron',
  'lp.journey.preview': 'Primer entrenamiento',
  'lp.journey.title': '{n} evaluaciones: {accepted} encaja · {rejected} no encaja',
  'lp.loading': 'Cargando estado de aprendizaje…',
  'lp.locked.pill': 'desde {n} evaluaciones',
  'lp.ps.bizModel.analyse':
    'Leadscraper tiene el filtro estándar activo: agencias, distribuidores y marketplaces se despriorizan automáticamente en el reasoning cuando no coinciden con la solicitud.',
  'lp.ps.bizModel.content': 'Proveedores operativos (no intermediarios puros)',
  'lp.ps.bodyDefault':
    'Estas tarjetas muestran lo que Leadscraper ha **analizado** específicamente de tu perfil + los Leads confirmados. Evalúa más específicamente con motivo para que los clusters se agudicen.',
  'lp.ps.bodyHigh':
    'Con solo {rejected} {rejectWord} Leadscraper no puede formar clusters de exclusión firmes: estas tarjetas muestran lo que Leadscraper ha **analizado** específicamente de tu perfil + los {accepted} Leads confirmados. Tan pronto como rechaces más específicamente, los clusters madurarán a filtros firmes.',
  'lp.ps.footerBody':
    'A partir de **50 evaluaciones** Leadscraper considera en cada nueva búsqueda no solo tu entrada y lo que vende tu empresa, sino también tu **perfil aprendido como tendencia**: industria, rango de tamaño, ubicación, rol, estructura de propiedad. No como filtro firme, sino como ponderación adicional en el reasoning. Esto significa que una nueva consulta por "asesores fiscales Hamburgo" no busca genéricamente todas las consultorías fiscales, sino que automáticamente prefiere consultorías medianas dirigidas por propietarios, análogo a la imagen del perfil que has construido aquí.',
  'lp.ps.footerTitle': 'Cómo esto influye en tus próximas búsquedas',
  'lp.ps.geo.analyseNo':
    'Leadscraper prioriza resultados de esta región y cura resultados del perímetro cuando la región central se vuelve escasa.',
  'lp.ps.geo.analyseYes':
    'Leadscraper ha confirmado {n} empresas de esta región como adecuadas: el ancla geográfica está establecida.',
  'lp.ps.geo.fallback': 'Región DACH',
  'lp.ps.industry.analyseNo':
    'Leadscraper busca sistemáticamente empresas que coincidan con tu descripción de industria.',
  'lp.ps.industry.analyseYes':
    'Leadscraper confirma esta industria a través de {n} Leads aceptados: la segmentación por industria está ajustada.',
  'lp.ps.industry.anyBranche':
    'Tu perfil está abierto a todas las industrias: Cortex deriva la tendencia real de tus valoraciones. Actualmente {n} Leads aceptados como base. Cuantas más valoraciones, más precisa será la tendencia de industria derivada.',
  'lp.ps.industry.fallback': 'Derivado de la intención de tu perfil',
  'lp.ps.ownership.analyseHigh':
    'Leadscraper reconoce de los Leads confirmados que tu enfoque está en empresas dirigidas por propietarios: las filiales corporativas se sugieren más moderadamente.',
  'lp.ps.ownership.analyseLow':
    'Evalúa específicamente una filial corporativa con "no encaja" para que Leadscraper pueda formar un cluster de propietario firme aquí.',
  'lp.ps.ownership.contentHigh': 'Perfil de propietario/mediana empresa confirmado',
  'lp.ps.ownership.contentLow': 'Mezcla de estructuras de propietario y corporativas más pequeñas',
  'lp.ps.ownership.label': 'Estructura de propiedad',
  'lp.ps.rejectionMany': 'rechazos',
  'lp.ps.rejectionOne': 'rechazo',
  'lp.ps.role.analyseHigh':
    'Leadscraper escribe activamente según este rol en el reasoning: datos legales + páginas de carreras + LinkedIn se filtran específicamente para esto.',
  'lp.ps.role.analyseLow':
    'Leadscraper busca específicamente estos roles en datos legales + páginas de carreras, solo recurre a directores ejecutivos cuando el rol específico no está publicado.',
  'lp.ps.role.fallback': 'Nivel de dirección ejecutiva',
  'lp.ps.size.analyseHigh':
    'Con {pct}% de tasa de acierto Leadscraper ve que tu rango de tamaño deseado se alcanza de forma estable: no se detecta necesidad de corrección.',
  'lp.ps.size.analyseLow':
    'Leadscraper ajusta el rango de empleados más finamente a tu idea con cada rechazo.',
  'lp.ps.size.contentHigh': 'Leadscraper identifica el rango de tamaño con precisión',
  'lp.ps.size.contentLow': 'Tendencia mediana empresa de los Leads confirmados',
  'lp.ps.titleDefault': 'Lo que Leadscraper entiende de tus evaluaciones',
  'lp.ps.titleHigh': 'Leadscraper entiende tu audiencia, {pct}% de acierto',
  'lp.ps.understands': 'Leadscraper entiende',
  'lp.s0.body':
    'Con {preview} Leads evaluados te mostramos la primera impresión. Con {active} Leadscraper busca activamente para TI, basándose en tus patrones específicos.',
  'lp.s0.eyebrow': 'Leadscraper aprende contigo',
  'lp.s0.headline': 'Leadscraper está construyendo tu audiencia',
  'lp.s0.openMany': '{n} Leads aún sin evaluar. Evalúalos para avanzar más rápido.',
  'lp.s0.openOne': '{n} Lead aún sin evaluar. Evalúalo para avanzar más rápido.',
  'lp.s1.body':
    'Las primeras tendencias son visibles. Con {n} evaluaciones esto se incorpora activamente a tus búsquedas.',
  'lp.s1.eyebrow': 'Primera impresión',
  'lp.s1.headline': 'Leadscraper aún recopila evidencias',
  'lp.s1.morePatterns': 'Más patrones, serán visibles con {n} evaluaciones',
  'lp.s1.strongestLabel': 'Tendencia más fuerte hasta ahora',
  'lp.s2.headline': 'Leadscraper busca para TI',
  'lp.s2.ignoredMany':
    '{n} evaluaciones fueron "ya conocemos" o "datos incorrectos": estas no se incluyen intencionalmente en el aprendizaje.',
  'lp.s2.ignoredOne':
    '{n} evaluación fue "ya conocemos" o "datos incorrectos": estas no se incluyen intencionalmente en el aprendizaje.',
  'lp.s2.pillActive': 'Personalizado activamente',
  'lp.s2.pillSharp': 'La audiencia está afinada',
  'lp.s2.pillUpdating': 'Actualización en curso',
  'lp.s2.reanalysisAgo': 'Último re-análisis: hace {n} evaluaciones · Próximo en {next}',
  'lp.s2.reanalysisCurrent': 'Re-análisis actual · Próximo en {n}',
  'lp.s2.weakLabel': 'Tendencias débiles, se fortalecerán con más datos',
  'lp.sq.activeSubS1':
    'Basado en tus primeras {n} evaluaciones, se agudizan con cada paso de re-análisis.',
  'lp.sq.activeSubS2':
    'Actualizado tras {n} evaluaciones · Re-análisis cada {interval} evaluaciones.',
  'lp.sq.activeTitle': 'Leadscraper propone estas búsquedas',
  'lp.sq.badge.crossSell': 'Cross-Sell',
  'lp.sq.badge.expansion': 'Expansión',
  'lp.sq.badge.pattern': 'Patrón',
  'lp.sq.badge.salesFit': 'Sales-Fit',
  'lp.sq.badge.zoomOut': 'Zoom-out',
  'lp.sq.emptyBody':
    'Las propuestas se calcularán con tu próximo re-análisis de patrones (cada {n} evaluaciones).',
  'lp.sq.eyebrow': 'Consultas de búsqueda optimizadas',
  'lp.sq.launch': 'Iniciar búsqueda',
  'lp.sq.loading': 'Leadscraper calculando propuestas…',
  'lp.sq.lockedBody':
    'Una vez que hayas evaluado {n} Leads, Leadscraper sugerirá 3–5 consultas de búsqueda, estructuradas como tus entradas, con probabilidad de coincidencia y breve justificación.',
  'lp.sq.lockedTitle': 'Leadscraper prepara propuestas concretas',
  'lp.sq.mockA.contact': 'Dirección ejecutiva',
  'lp.sq.mockA.rationale': 'Propuesta de ejemplo de cómo Leadscraper sugiere búsquedas.',
  'lp.sq.mockA.region': 'Baviera',
  'lp.sq.mockA.type': 'Fabricantes de maquinaria medianos',
  'lp.sq.mockB.rationale': 'Propuesta de ejemplo de cómo Leadscraper sugiere búsquedas.',
  'lp.sq.mockB.region': 'DACH',
  'lp.sq.mockB.type': 'Planificadores TGA sector hospitalario',
  'lp.sq.tier.hypothesis': 'Hipótesis de prueba',
  'lp.sq.tier.solid': 'Sólido',
  'lp.sq.tier.strong': 'Fuerte',
  'lp.sq.tier.veryStrong': 'Muy fuerte',
  'lp.tone.drop': 'FUERTE DROP',
  'lp.tone.keep': 'FUERTE KEEP',
  'lp.tone.softDrop': 'LIGERO DROP',
  'lp.tone.softKeep': 'LIGERO KEEP',

  'lt.badge.soft': 'posible',
  'lt.dashHint1': 'En el dashboard encontrarás una pista al respecto (símbolo',
  'lt.dashHint2': 'junto al estado).',
  'lt.exp.btn': 'Exportar',
  'lt.exp.csvHint': '.csv (separado por comas)',
  'lt.exp.fail': 'Error en la exportación: {err}',
  'lt.exp.ing': 'Exportando…',
  'lt.exp.noRows': 'No se encontraron Leads para exportar.',
  'lt.exp.success': '{n} filas exportadas como {fmt}.',
  'lt.exp.tipNoLeads': 'Solo se pueden exportar leads con contactos o un plan terminado',
  'lt.exp.tipReady': 'Exportar {n} leads',
  'lt.exp.tipWrongFilter': 'Solo se pueden exportar leads que encajan. Cambia al filtro "Encaja".',
  'lt.exp.toastNoLeads':
    'Solo se pueden exportar leads con contactos o un plan de adquisición terminado.',
  'lt.exp.unknownErr': 'Error desconocido',
  'lt.expH.city': 'Ubicación',
  'lt.expH.company': 'Empresa',
  'lt.expH.companyEmail': 'E-mail corporativo',
  'lt.expH.companyPhone': 'Teléfono corporativo',
  'lt.expH.contact': 'Persona de contacto',
  'lt.expH.direct': 'directo',
  'lt.expH.email': 'E-mail',
  'lt.expH.emailSource': 'Fuente del e-mail',
  'lt.expH.guessed': 'estimado ({n}%)',
  'lt.expH.profile': 'Audiencia',
  'lt.expH.role': 'Cargo',
  'lt.expH.sector': 'Sector',
  'lt.feedbackFail': 'No se pudo guardar el feedback. Inténtalo de nuevo.',
  'lt.naceF.A': 'Agricultura, ganadería, silvicultura y pesca',
  'lt.payoff.avoided': 'El dossier ahora evita:',
  'lt.payoff.flowsIn': 'Se incorpora al próximo análisis.',
  'lt.naceF.B': 'Industrias extractivas',
  'lt.naceF.C': 'Industria manufacturera',
  'lt.naceF.D': 'Suministro de energía eléctrica, gas, vapor y aire acondicionado',
  'lt.naceF.E': 'Suministro de agua, actividades de saneamiento, gestión de residuos',
  'lt.naceF.F': 'Construcción',
  'lt.naceF.G': 'Comercio al por mayor y al por menor; reparación de vehículos',
  'lt.naceF.H': 'Transporte y almacenamiento',
  'lt.naceF.I': 'Hostelería',
  'lt.naceF.J': 'Información y comunicaciones',
  'lt.naceF.K': 'Actividades financieras y de seguros',
  'lt.naceF.L': 'Actividades inmobiliarias',
  'lt.naceF.M': 'Prestación de servicios profesionales, científicos y técnicos',
  'lt.naceF.N': 'Prestación de otros servicios empresariales',
  'lt.naceF.O': 'Administración pública, defensa; seguridad social',
  'lt.naceF.P': 'Educación',
  'lt.naceF.Q': 'Actividades sanitarias y de servicios sociales',
  'lt.naceF.R': 'Actividades artísticas, recreativas y de entretenimiento',
  'lt.naceF.S': 'Otros servicios',
  'lt.naceF.T': 'Actividades de los hogares',
  'lt.naceF.U': 'Actividades de organizaciones extraterritoriales',
  'lt.naceS.A': 'Agricultura/Forestal',
  'lt.naceS.B': 'Minería',
  'lt.naceS.C': 'Industria manufact.',
  'lt.naceS.D': 'Energía',
  'lt.naceS.E': 'Agua/Residuos',
  'lt.naceS.F': 'Construcción',
  'lt.naceS.G': 'Comercio',
  'lt.naceS.H': 'Transporte/Almacén',
  'lt.naceS.I': 'Hostelería',
  'lt.naceS.J': 'IT/Medios',
  'lt.naceS.K': 'Finanzas/Seguros',
  'lt.naceS.L': 'Inmobiliaria',
  'lt.naceS.M': 'Profesional',
  'lt.naceS.N': 'Otros servicios',
  'lt.naceS.O': 'Admin. pública',
  'lt.naceS.P': 'Educación',
  'lt.naceS.Q': 'Salud',
  'lt.naceS.R': 'Arte/Entret.',
  'lt.naceS.S': 'Otros servicios',
  'lt.naceS.T': 'Hogares priv.',
  'lt.naceS.U': 'Extraterritorial',
  'lt.next.title': 'Próximos pasos',
  'lt.next.verifyContacts': 'Verificar contactos',
  'lt.next.verifyingContacts': 'Verificando contactos …',
  'lt.next.contactsVerified': '{n} contactos verificados',
  'lt.next.contactVerified': 'Contacto verificado',
  'lt.next.openPlan': 'Abrir plan',
  'lt.next.generatingPlan': 'Generando plan de adquisición …',
  'lt.next.credit': '1 crédito',
  'lt.next.retry': 'Reintentar',
  'lt.next.verifyFirst': 'Verifica primero los contactos',
  'lt.next.failedHint': 'El último intento falló. Puedes volver a intentarlo.',
  'lt.profileLeads': 'Leads · {name}',
  'lt.profileSub': '{n} leads · todas las consultas de esta audiencia llegan aquí',
  'lt.profileSubOne': '1 lead · todas las consultas de esta audiencia llegan aquí',
  'lt.queryClear': 'Quitar filtro',
  'lt.queryLabel': 'Filtrado por Query:',
  'lt.resetToast': 'Valoración para {c} restablecida',
  'lt.ring.match': 'Coincidencia {pct}%',
  'lt.ring.rejected': 'Rechazado, valorado como 0',
  'lt.rm.cancel': 'Cancelar',
  'lt.rm.header': 'Descartar lead',
  'lt.rm.noteOptional': 'Nota para Leadscraper (opcional)',
  'lt.rm.noteRequired': 'Por favor describe brevemente (obligatorio)',
  'lt.rm.placeholderOpt':
    '¿Qué pasó por alto o evaluó mal Leadscraper? (Cuanto más específico, mejor aprende el sistema.)',
  'lt.rm.placeholderReq': 'Ej. "Competidor: venden solución similar"',
  'lt.rm.sub': 'Dinos por qué: Leadscraper aprende de ello y mejorará la próxima vez.',
  'lt.rm.submit': 'Descartar lead',
  'lt.rr.already_known': 'Ya lo conocemos',
  'lt.rr.already_known.hint': 'Ya está en el CRM o ya fue contactado (no es señal de aprendizaje)',
  'lt.rr.bad_data': 'Datos incorrectos',
  'lt.rr.bad_data.hint': 'La dirección, nombre o información de contacto no es correcta',
  'lt.rr.no_buying_signal': 'No hay necesidad reconocible',
  'lt.rr.no_buying_signal.hint':
    'Sin eventos desencadenantes, sin vacantes abiertas, sin señal de crecimiento',
  'lt.rr.not_operator': 'No es operador',
  'lt.rr.not_operator.hint': 'Agencia, intermediario o promotor en lugar de proveedor operativo',
  'lt.rr.other': 'Otra razón',
  'lt.rr.other.hint': 'Escribe brevemente el motivo abajo (texto libre)',
  'lt.rr.wrong_industry': 'Sector incorrecto',
  'lt.rr.wrong_industry.hint': 'Leadscraper identificó mal el sector de negocio',
  'lt.rr.wrong_ownership': 'Estructura de propiedad incorrecta',
  'lt.rr.wrong_ownership.hint':
    'Filial de corporación en lugar de empresa familiar, forma legal incorrecta, etc.',
  'lt.rr.wrong_region': 'Ubicación incorrecta',
  'lt.rr.wrong_region.hint': 'La sede / región no coincide con la búsqueda',
  'lt.rr.wrong_role': 'Contacto incorrecto',
  'lt.rr.wrong_role.hint': 'La persona o rol no es el responsable de decisiones',
  'lt.rr.wrong_size': 'Tamaño de empresa incorrecto',
  'lt.rr.wrong_size.hint': 'Muy pequeña, muy grande o corporativo en lugar de mediana empresa',
  'lt.tip.accepted': 'Aceptado, clic para anular',
  'lt.tip.contacts': 'Mostrar {n} contactos',
  'lt.tip.dragCol': 'Arrastrar ancho de columna',
  'lt.tip.openCompany': 'Abrir detalles de la empresa',
  'lt.tip.openLead': 'Abrir detalles del lead',
  'lt.tip.rejected': 'Rechazado, clic para anular',
  'lt.tip.softKeep':
    'Posiblemente relevante: Leadscraper tiene una incertidumbre aquí, ver detalle',
  'lt.tip.unseen': 'Aún no visto',
  // AddCompanyManualModal — alta manual mediante URL
  'lt.manual.modal.eyebrow': 'Pipeline · manual',
  'lt.manual.modal.title': 'Añadir empresa',
  'lt.manual.modal.desc':
    'Leadscraper verifica el sitio web y extrae los datos básicos de la empresa. Luego el lead aparece en {phase}, desde donde puedes obtener contactos + un plan de adquisición.',
  'lt.manual.modal.phase': '«Empresa añadida»',
  'lt.manual.modal.websiteLabel': 'Sitio web',
  'lt.manual.modal.placeholder': 'p. ej. heuerlogistics.de',
  'lt.manual.modal.hint': 'Intentaremos acceder al sitio web. No se cobra ningún crédito si falla.',
  'lt.manual.modal.cancel': 'Cancelar',
  'lt.manual.modal.close': 'Cerrar',
  'lt.manual.modal.submit': 'Añadir',
  'lt.manual.modal.submitting': 'Añadiendo …',
  'lt.manual.modal.creditOne': '{n} crédito',
  'lt.manual.modal.creditMany': '{n} créditos',
  'lt.manual.modal.errEmpty': 'Introduce un sitio web.',
  'lt.manual.modal.errInvalid': 'Esto no parece un sitio web válido (p. ej. heuerlogistics.de).',

  'mem.cancel': 'Cancelar',
  'mem.editHint': 'Leadscraper utilizará esta declaración desde la próxima clasificación.',
  'mem.editKicker': 'Corregir suposición aprendida',
  'mem.editTitle': '¿Cómo debe aprenderlo Leadscraper?',
  'mem.param.contact': 'Contacto',
  'mem.param.extras': 'Extras',
  'mem.param.leads': 'Leads',
  'mem.param.location': 'Ubicación',
  'mem.param.sector': 'Sector',
  'mem.profile': 'Perfil',
  'mem.save': 'Guardar suposición',
  'mem.screenLabel': 'Memory',
  'mem.screenLabelEmpty': 'Memory · vacío',
  'mem.toast.confirmed': 'Suposición confirmada.',
  'mem.toast.corrected': 'Corrección guardada.',
  'mem.toast.forgotten': 'Suposición olvidada.',
  'mem.today': 'Hoy',

  'mob.abo': 'Plan y Credits',
  'mob.acct.aria': 'Mi cuenta',
  'mob.active': 'Activo',
  'mob.back': '← Volver',
  'mob.changePassword': 'Cambiar contraseña',
  'mob.changePlan': 'Cambiar plan',
  'mob.detail.contacts': 'Contactos ({n})',
  'mob.detail.fits': '✓ Adecuado',
  'mob.detail.label.email': 'E-mail',
  'mob.detail.label.phone': 'Teléfono',
  'mob.detail.label.website': 'Sitio web',
  'mob.detail.notFitting': '✗ No adecuado',
  'mob.detail.rejected': '✗ Rechazado',
  'mob.detail.section.company': 'Empresa',
  'mob.fb.fits': '✓ Adecuado',
  'mob.fb.rejected': '✗ Rechazado',
  'mob.home.activeProfile': 'Audiencia activa',
  'mob.home.cta.newSearch': 'Iniciar nueva búsqueda',
  'mob.home.emptyHint': 'Inicia una nueva búsqueda o cambia de audiencia.',
  'mob.home.newLeads': 'Nuevos Leads',
  'mob.home.stat.fits': 'Adecuados',
  'mob.home.stat.leads': 'Leads',
  'mob.home.stat.matchRate': 'Tasa de coincidencia',
  'mob.home.viewAll': 'Ver todos →',
  'mob.leads.cta.newSearch': 'Iniciar nueva búsqueda',
  'mob.leads.filter.all': 'Todos',
  'mob.leads.filter.fits': 'Adecuados',
  'mob.leads.filter.open': 'Abiertos',
  'mob.leads.filter.rejected': 'Rechazados',
  'mob.leads.new': '＋ Nuevo',
  'mob.leads.title': 'Leads',
  'mob.logout': 'Cerrar sesión',
  'mob.logoutConfirm': '¿Seguro que quieres cerrar sesión?',
  'mob.more.help': 'Ayuda y contacto',
  'mob.more.invoices': 'Facturas',
  'mob.more.label.email': 'E-mail',
  'mob.more.plan.monthly': 'Plan mensual',
  'mob.more.plan.trial': 'Prueba',
  'mob.more.section.account': 'Mi cuenta',
  'mob.more.section.help': 'Ayuda y App',
  'mob.more.title': 'Más',
  'mob.more.toDesktop': 'Cambiar a escritorio',
  'mob.more.toDesktop.value': 'Funcionalidad completa',
  'mob.nav.account': 'Cuenta',
  'mob.nav.home': 'Inicio',
  'mob.nav.leads': 'Leads',
  'mob.nav.profile': 'Audiencias',
  'mob.onDesktop': 'En escritorio',
  'mob.profile.active': 'Activo',
  'mob.profile.leadsCount': '{n} Leads',
  'mob.profile.newCount': '{n} nuevos',
  'mob.profile.stat.match': 'Coincidencia',
  'mob.profile.switchTo': 'Cambiar a',
  'mob.profile.title': 'Audiencias',
  'mob.queryPlaceholder': 'ej. Panaderías, Asesores fiscales, Zapaterías',
  'mob.search.askWho': '¿A quién buscas?',
  'mob.search.cancel': 'Cancelar',
  'mob.search.profileLabel': 'Audiencia: {name}',
  'mob.search.region': 'Región (opcional)',
  'mob.search.regionPlaceholder': 'ej. Cataluña, Madrid, Andalucía',
  'mob.search.start': 'Iniciar búsqueda',
  'mob.search.title': 'Nueva búsqueda',
  'mob.toast.accepted': '✓ Marcado como adecuado',
  'mob.toast.rejected': '✗ Rechazado',
  'mob.toast.runStarted': 'Búsqueda iniciada, llegará en ~2 min',
  'mob.trialLeads': 'Leads de prueba restantes',
  'mob.upgrade': 'Actualizar a Pro',
  'mob.upgradeHint': 'Más Leads + Programación',
  'mob.wizardHint':
    'Crea tu primer perfil desde un escritorio: el asistente aún no está disponible en móvil.',

  'mobile.empty.noContactData': 'No hay datos de contacto disponibles.',
  'mobile.empty.noOpenLeads': 'No hay Leads abiertos.',
  'mobile.empty.noProfileSelected': 'Ninguna audiencia seleccionada.',
  'mobile.empty.noProfileShort': 'Sin audiencia.',
  'mobile.empty.nothingFound': 'No se encontró nada.',
  'mobile.note.label': 'Nota:',
  'mobile.note.scheduleDesktop':
    'Los horarios y la memoria de la audiencia se editan en escritorio.',
  'mobile.tip.label': 'Consejo:',
  'mobile.tip.profilesDesktop':
    'Varias audiencias (p. ej. por sector o región) se crean en escritorio.',

  'ms.aud.computingBody':
    'En unos segundos Leadscraper describirá aquí tu audiencia objetivo con sus propias palabras.',
  'ms.aud.computingEyebrow': 'Leadscraper analiza tus evaluaciones',
  'ms.aud.computingTitle': 'Reconocimiento de patrones en curso…',
  'ms.aud.derivedFrom': 'Derivado de tus {n} evaluaciones',
  'ms.aud.eyebrowS1': 'Primera evaluación de Leadscraper',
  'ms.aud.eyebrowS2': 'Evaluación actual de Leadscraper',
  'ms.aud.fallbackBody':
    'Tan pronto como termine el re-análisis (en pocos segundos), aparecerá aquí una descripción concreta de tu audiencia objetivo.',
  'ms.aud.fallbackEyebrow': 'Primera evaluación de Leadscraper',
  'ms.aud.fallbackTitle':
    'Leadscraper está actualizando la evaluación con tus últimas {n} evaluaciones.',
  'ms.aud.learnedLabel': 'Aprendido concretamente',
  'ms.aud.lockedEyebrow': 'Audiencia en palabras de Leadscraper',
  'ms.aud.lockedMock':
    'Buscas operadores pequeños en NRW con contratación activa, contactos nivel directivo, dirigidos por familias con clara tendencia industrial de maquinaria.',
  'ms.aud.lockedPill': 'a partir de {n} evaluaciones',
  'ms.aud.nextReanalysis': ' · Próximo re-análisis en {n}',
  'ms.aud.recomputeEyebrow': 'Leadscraper actualiza tu evaluación',
  'ms.aud.recomputeTitle': 'Con tus últimas evaluaciones se está recalculando la evaluación…',
  'ms.aud.trainS1':
    'Continúa entrenando el scraper y obtendrás **resultados realmente sólidos**: cada evaluación hace Leadscraper más preciso.',
  'ms.aud.trainS2':
    'Continúa entrenando Leadscraper: **cada evaluación afina las búsquedas** que ejecutan automáticamente para ti desde ahora.',
  'ms.card.label': 'Estado de Leadscraper',
  'ms.card.ratings': '{n} / {threshold} evaluaciones',
  'ms.card.s2active': '{n} evaluaciones · activo en el razonamiento',
  'ms.card.s2reanalysis': '{n} evaluaciones · siendo re-analizado',
  'ms.cv.age': 'Antigüedad de la empresa: {rule}',
  'ms.cv.bizModel': 'Modelo de negocio: {rule}',
  'ms.cv.buyingSignals': 'Señales de compra: {rule}',
  'ms.cv.domainBlock': 'Exclusión: {rule}',
  'ms.cv.geo': 'Región: {rule}',
  'ms.cv.industry': 'Industria: {rule}',
  'ms.cv.ownership': 'Propiedad: {rule}',
  'ms.cv.role': 'Contacto: {rule}',
  'ms.cv.size': 'Tamaño: {rule}',
  'ms.cv.techStack': 'Stack tecnológico: {rule}',
  'ms.donut.match': 'encaja',
  'ms.donut.matchRate': 'Tasa de coincidencia',
  'ms.donut.noMatch': 'no encaja',
  'ms.donut.ratings': 'Evaluaciones',
  'ms.donut.title': 'Estado de evaluaciones',
  'ms.error': 'Error',
  'ms.msg.s0': 'Aprende contigo · {n}/{threshold} hasta vista previa',
  'ms.msg.s1': 'Primera impresión · {n}/{threshold} hasta activo',
  'ms.msg.s2active': 'Activamente personalizado · {n} evaluaciones',
  'ms.msg.s2reanalysis': 'Analizando de nuevo · {n}',
  'ms.stage0.eyebrow': 'Aprende contigo',
  'ms.stage1.eyebrow': 'Primera impresión',
  'ms.stage2.eyebrow': 'Activamente personalizado',

  'nace.A': 'Agricultura, ganadería, silvicultura y pesca',
  'nace.B': 'Industrias extractivas',
  'nace.C': 'Industria manufacturera',
  'nace.D': 'Suministro de energía eléctrica, gas, vapor y aire acondicionado',
  'nace.E':
    'Suministro de agua, actividades de saneamiento, gestión de residuos y descontaminación',
  'nace.F': 'Construcción',
  'nace.G': 'Comercio al por mayor y al por menor; reparación de vehículos de motor y motocicletas',
  'nace.H': 'Transporte y almacenamiento',
  'nace.I': 'Hostelería',
  'nace.J': 'Información y comunicaciones',
  'nace.K': 'Actividades financieras y de seguros',
  'nace.L': 'Actividades inmobiliarias',
  'nace.M': 'Actividades profesionales, científicas y técnicas',
  'nace.N': 'Actividades administrativas y servicios auxiliares',
  'nace.O': 'Administración pública y defensa; seguridad social obligatoria',
  'nace.P': 'Educación',
  'nace.Q': 'Actividades sanitarias y de servicios sociales',
  'nace.R': 'Actividades artísticas, recreativas y de entretenimiento',
  'nace.S': 'Otros servicios',
  'nace.T': 'Actividades de los hogares como empleadores de personal doméstico',
  'nace.U': 'Actividades de organizaciones y organismos extraterritoriales',

  'naceShort.A': 'Agri/Ganadería',
  'naceShort.B': 'Minería',
  'naceShort.C': 'Manufactura',
  'naceShort.D': 'Energía',
  'naceShort.E': 'Agua/Residuos',
  'naceShort.F': 'Construcción',
  'naceShort.G': 'Comercio',
  'naceShort.H': 'Transporte',
  'naceShort.I': 'Hostelería',
  'naceShort.J': 'IT/Medios',
  'naceShort.K': 'Finanzas/Seguros',
  'naceShort.L': 'Inmobiliario',
  'naceShort.M': 'Profesional',
  'naceShort.N': 'Otros Servicios',
  'naceShort.O': 'Admin. Pública',
  'naceShort.P': 'Educación',
  'naceShort.Q': 'Salud',
  'naceShort.R': 'Arte/Entret.',
  'naceShort.S': 'Otros Servicios',
  'naceShort.T': 'Hogares Priv.',
  'naceShort.U': 'Extraterritorial',

  'nav.activeProfile': 'Audiencia activa',
  'nav.apiStatus.checking': 'Verificando estado de API …',
  'nav.apiStatus.down': 'API no disponible. Por favor recarga la página',
  'nav.apiStatus.ok': 'API disponible',
  'nav.apiStatus.slow': 'API responde lento',
  'nav.buyLeads': 'Comprar Leads ahora',
  'nav.cortex': 'Audiencia',
  'nav.credits': 'Credits Disponibles',
  'nav.credits.available': 'Disponibles',
  'nav.credits.label': 'Saldo de cuenta',
  'nav.credits.remaining': 'Restantes',
  'nav.credits.total': 'Total',
  'nav.credits.upgrade': 'Actualizar',
  'nav.dashboard': 'Dashboard',
  'nav.deleteProfile': 'Eliminar audiencia',
  'nav.deleteProfileBody':
    'Todos los leads, valoraciones y patrones aprendidos de «{name}» se eliminarán de forma permanente. Esta acción no se puede deshacer.',
  'nav.deleteProfileBusy': 'Eliminando …',
  'nav.deleteProfileCta': 'Eliminar definitivamente',
  'nav.deleteProfileError': 'No se pudo eliminar la audiencia. Inténtalo de nuevo.',
  'nav.deleteProfileInFlight':
    'Hay una búsqueda en curso para esta audiencia. Espera a que termine.',
  'nav.deleteProfileSuccess': 'Audiencia eliminada.',
  'nav.deleteProfileTitle': '¿Eliminar audiencia?',
  'nav.feedbacks': 'Feedbacks',
  'nav.leads': 'Leads',
  'nav.matchRate': 'Tasa de acierto',
  'nav.rated': 'valorados',
  'nav.open': 'abiertos',
  'nav.rateNudge.title': 'Ir a los leads que aún no has valorado',
  'nav.allRated': 'Todos valorados',
  'nav.newProfile': 'Crear nueva audiencia',
  'nav.onboardingRequired': 'Por favor completa primero los 3 pasos de configuración inicial.',
  'nav.openSettings': 'Abrir configuración y aprendizajes de "{name}"',
  'nav.profileName': 'Nombre de la audiencia',
  'nav.profileNameP': 'ej. Proveedores de servicios TI DACH',
  'nav.renameProfile': 'Renombrar audiencia',
  'nav.renameProfileSub': 'Elige un nuevo nombre para esta audiencia.',
  'nav.runs.footer': 'Haz clic en una audiencia para ver el progreso. Puedes seguir trabajando.',
  'nav.runs.leadsReady': '{n} Lead{s} listo{s}',
  'nav.runs.many': '{n} búsquedas ejecutándose',
  'nav.runs.one': '1 búsqueda ejecutándose',
  'nav.runs.title': 'Búsquedas en curso',
  'nav.startSubscription': 'Iniciar suscripción',
  'nav.switchProfiles': 'Cambiar de audiencia',

  'notif.act.edge': 'Ver casos límite',
  'notif.act.pattern': 'Confirmar en Leadscraper',
  'notif.act.review': 'Ver leads',
  'notif.dismiss': 'Ocultar',
  'notif.edge.body':
    '{n} leads inciertos en {profile}: tu opinión mejora Leadscraper significativamente.',
  'notif.edge.title': 'Los casos límite necesitan tu opinión',
  'notif.empty.sub': 'Leadscraper está aprendiendo.',
  'notif.empty.title': 'Todo fluye bien.',
  'notif.kind.edge': 'Caso límite',
  'notif.kind.pattern': 'Patrón',
  'notif.kind.review': 'Revisar',
  'notif.pattern.back': 'Atrás',
  'notif.pattern.badge': 'Patrón aprendido',
  'notif.pattern.confirmedLabel': 'Patrón confirmado.',
  'notif.pattern.needsConfirm': '¿Es correcto?',
  'notif.pattern.no': 'No, rechazar',
  'notif.pattern.rejectedLabel': 'Patrón rechazado.',
  'notif.pattern.saveAndClose': 'Guardar',
  'notif.pattern.stage2': 'Guardado',
  'notif.pattern.title': 'Patrón detectado',
  'notif.pattern.whyLabel': '¿Por qué? (opcional)',
  'notif.pattern.whyPlaceholder':
    'Ayuda a Leadscraper a aprender el matiz, pero no es obligatorio.',
  'notif.pattern.yes': 'Sí, correcto',
  'notif.review.body': 'Tienes {n} leads sin evaluar.',
  'notif.review.cta': 'Revisar ahora',
  'notif.review.title': 'Evaluar nuevos leads',
  'notif.sub': 'Sugerencias para que Leadscraper sea más preciso.',
  'notif.title': 'Notificaciones',

  'np.abort': 'Cancelar',
  'np.audience': 'Describir audiencia objetivo',
  'np.audienceHint':
    'Cuanto más específico, mejor será la primera clasificación. Puedes ajustar esto después en cualquier momento.',
  'np.audienceHintLong':
    'Escríbelo como se lo explicarías a un nuevo empleado de ventas. Leadscraper lo usa como base para la evaluación, y sigue aprendiendo de cada feedback.',
  'np.audienceLabel': 'Descripción de audiencia objetivo',
  'np.audienceP':
    'Ejemplo: Queremos ganar asesorías fiscales medianas para nuestra solución de recruiting. El objetivo es una primera conversación con la dirección.',
  'np.back': 'Atrás',
  'np.briefingHelp.q1': '¿Cuál es tu objetivo con este público objetivo?',
  'np.briefingHelp.q2': '¿Qué ofreces?',
  'np.briefingHelp.q3': '¿Por qué tu oferta es relevante para este público objetivo?',
  'np.briefingHelp.q4': '¿Cuál es tu propuesta de valor más fuerte?',
  'np.briefingHelp.q5': '¿Qué problemas resuelves?',
  'np.briefingHelp.q6': '¿A quién quieres contactar primero?',
  'np.briefingHelp.q7': '¿Qué canal funciona para ti: email, teléfono, LinkedIn?',
  'np.briefingHelp.q8': '¿Cuál debe ser el siguiente paso: respuesta, cita, demo, propuesta?',
  'np.briefingHelp.q9': '¿Qué se debe evitar en el primer contacto?',
  'np.briefingHelpFooter':
    'Estos no son campos obligatorios, solo orientación para el texto libre.',
  'np.briefingHelpTitle': 'Útil para Leadscraper',
  'np.coldStart': 'Inicio en frío, sin parámetros base',
  'np.coldStartDesc':
    'El perfil comienza completamente vacío. Después de ~20 feedbacks aparecen las primeras afirmaciones claras en Leadscraper.',
  'np.companySize': 'Tamaño de empresa',
  'np.companySizeP': 'ej. 50–250 empleados',
  'np.continue': 'Continuar',
  'np.create': 'Crear audiencia',
  'np.created': 'Audiencia creada. Leadscraper está listo.',
  'np.creating': 'Creando...',
  'np.header': 'Nueva audiencia',
  'np.headline': 'Definir audiencia objetivo',
  'np.suggHeading': 'Sugerencias para tu audiencia',
  'np.suggHint':
    'Al hacer clic se aplica la sugerencia: puedes alternar entre ellas, escribir tu propio texto o crear directamente.',
  'np.draftWriting': 'Leadscraper está redactando tu briefing …',
  'np.draftErrorLabel': 'Nota:',
  'np.draftErrorFallback':
    'No se pudo generar el borrador del briefing. Puedes seguir escribiendo manualmente.',
  'np.industry': 'Sector',
  'np.industryP': 'ej. Packaging, cajas plegables',
  'np.name': 'Nombre de la audiencia',
  'np.nameP': 'ej. Fabricantes de cajas plegables NRW',
  'np.notes': 'Notas adicionales',
  'np.notesP': 'Exclusiones, tipos de clientes, palabras clave...',
  'np.nothingYet': ': nada predefinido. Leadscraper se formará a través de tu feedback.',
  'np.optional': 'Opcional',
  'np.region': 'Región / Estado',
  'np.regionP': 'ej. NRW, DACH, toda Alemania',
  'np.skip': 'Saltar',
  'np.step1Sub':
    'Dale a tu perfil un nombre claro. Leadscraper usa esta descripción como punto de partida, antes de que tu feedback afine el patrón.',
  'np.step1Title': '¿Quién o qué estás buscando?',
  'np.step2Sub':
    'Opcional: Leadscraper usa estas especificaciones como base. El perfil aprende más una vez que evalúes leads.',
  'np.step2Title': 'Parámetros iniciales',
  'np.stepOf': 'Paso {n} de 2',
  'np.summaryTitle': 'Leadscraper comienza con',
  'np.title': 'Crear nueva audiencia',
  'np.whatHappens': '¿Qué pasa después?',
  'np.whatHappensBody':
    'En el dashboard inicias una <b>consulta de búsqueda</b> y defines sector, región y tamaño. Leadscraper encuentra empresas con los contactos adecuados y crea un plan de captación por lead a partir de este briefing.',

  'offer.beta.pricing.intro': 'Invitación Beta · 55% de descuento el primer mes',

  'og.beta.cardCta': 'Activar paquete Beta',
  'og.beta.cardFeature.1': '500 Leads / mes con alcance Growth',
  'og.beta.cardFeature.2': 'Activación inmediata. Sin prueba',
  'og.beta.cardFeature.3': 'Cancelable en cualquier momento con 1 clic',
  'og.beta.cardFoot': 'Tarjeta requerida · pago seguro vía Stripe',
  'og.beta.cardName': 'Tu paquete Beta',
  'og.beta.feature.1.bold': '500 Leads',
  'og.beta.feature.1.lead': '',
  'og.beta.feature.1.tail': ' por mes, emails y teléfonos verificados',
  'og.beta.feature.2': 'Targeting con IA en lenguaje natural',
  'og.beta.feature.3': 'Integraciones CRM + exportación CSV/Excel',
  'og.beta.feature.4': 'Cumple GDPR · Datos en la UE',
  'og.beta.feature.5.bold': 'WhatsApp a Janik',
  'og.beta.feature.5.lead': 'Acceso directo ',
  'og.beta.feature.5.tail': ' para preguntas',
  'og.beta.narrativeBody':
    'Buscamos {profis} que usen nuestro sistema temprano, den feedback honesto y ayuden a decidir cómo se desarrolla Leadscraper. A cambio pagas {price} por tu primer mes de nuestro paquete Growth, en lugar de los 490 € normales — después aplica el precio normal, cancela cuando quieras.',
  'og.beta.narrativePrice': 'solo 220 €',
  'og.beta.narrativeProfis': '30 profesionales de ventas activos',
  'og.beta.narrativeTitle': '¿Por qué esta oferta?',
  'og.beta.priceNowSuffix': '/ primer mes',
  'og.beta.priceFootnote': 'después {n} €/mes · cancela cuando quieras',
  'og.beta.priceOld': '{n} € / mes normal',
  'og.beta.savings': 'Ahorras {n} € en tu primer mes',
  'og.cancelAny': 'Cancelable en cualquier momento',
  'og.cta': 'Probar 3 días gratis: {plan}',
  'og.ctaBeta': 'Asegurar acceso Beta: {price} € / mes',
  'og.ctaPlain': 'Continuar con {plan}',
  'og.ctaSub':
    'Sin pago los primeros 3 días · Después {price},00 € / mes · {leads} Leads de prueba incluidos',
  'og.ctaSubPlain': '{price},00 € / mes · activación inmediata',
  'og.dsgvo': 'Cumple GDPR · Servidores ES',
  'og.eyebrow.beta': 'Invitación Beta personal',
  'og.eyebrow.trial50': '50 Credits de regalo',
  'og.hlBanner.trial50.body':
    'Después de elegir el plan recibes inmediatamente {credits} en tu cuenta. Úsalos en los próximos 3 días. Si no cancelas, cambias automáticamente al plan elegido.',
  'og.hlBanner.trial50.credits': '{n} Credits',
  'og.hlBanner.trial50.title': 'Así funciona tu prueba:',
  'og.later': 'Decidir después →',
  'og.leadsIncl': '{n} Leads por mes incluidos',
  'og.maiOffer.cta': 'Oferta Mayo: 100 Leads B2B por 49 € asegurados',
  'og.maiOffer.detail': 'Perfecto para empezar, sin compromiso.',
  'og.maiOffer.feature.1': 'Emails y números de teléfono verificados',
  'og.maiOffer.feature.2': 'IA targeting en lenguaje natural',
  'og.maiOffer.feature.3': 'Integraciones CRM + Export CSV/Excel',
  'og.maiOffer.feature.4': 'Conforme a GDPR · Datos en la UE',
  'og.maiOffer.feature.5': 'Desde mes 2: 190 €/mes, cancelable con 1 clic',
  'og.maiOffer.leadsNum': '100',
  'og.maiOffer.leadsUnit': 'Leads / mes',
  'og.maiOffer.planName': 'Basic',
  'og.maiOffer.price': '49 €',
  'og.maiOffer.priceNote': '0,49 € en lugar de 1,90 € por Lead, solo este mes.',
  'og.maiOffer.priceOriginal': 'En lugar de 190 € / mes',
  'og.maiOffer.priceSuffix': '/ mes',
  'og.moneyBack': 'Garantía de 14 días',
  'og.perMonth': '€ / mes',
  'og.plan': 'Plan',
  'og.planBadge.recommended': 'Recomendado',
  'og.planCta.loading': 'Continuar al pago…',
  'og.planCta.pick.basic': 'Elegir Basic',
  'og.planCta.pick.growth': 'Elegir Growth',
  'og.planCta.pick.starter': 'Elegir Starter',
  'og.planCta.trial.basic': 'Prueba gratis 3 días',
  'og.planCta.trial.growth': 'Prueba gratis 3 días',
  'og.planCta.trial.starter': 'Prueba gratis 3 días',
  'og.planDetail.basic': 'Para equipos de ventas pequeños que hacen seguimiento específico.',
  'og.planDetail.growth': 'Para equipos que quieren escalar outbound.',
  'og.planDetail.starter': 'Mejor relación calidad-precio para equipos activos.',
  'og.planFeature.basic.1': 'Emails y teléfonos verificados',
  'og.planFeature.basic.2': 'Targeting con IA en lenguaje natural',
  'og.planFeature.basic.3': 'Integraciones CRM + exportación CSV/Excel',
  'og.planFeature.basic.4': 'Conforme RGPD · Datos en la UE',
  'og.planFeature.growth.1': 'Todo lo de Starter',
  'og.planFeature.growth.2': '5× más Leads al mes',
  'og.planFeature.growth.3': 'Llamada de onboarding personalizada',
  'og.planFeature.growth.4': 'Soporte premium directo con Janik',
  'og.planFeature.starter.1': 'Todo lo de Basic',
  'og.planFeature.starter.2': '2,5× más Leads al mes',
  'og.planFeature.starter.3': 'Cola de Leads prioritaria',
  'og.planFeature.starter.4': 'Soporte por email < 4 h',
  'og.planLeadsUnit': 'Leads / mes',
  'og.planPriceNote.basic.default': 'Equivale a 1,90 € por Lead',
  'og.planPriceNote.basic.trial': 'Después {price}\u00A0€/mes · 100 Credits incluidos',
  'og.planPriceNote.growth.default': 'Equivale a 0,98 € por Lead, ahorra 48%',
  'og.planPriceNote.growth.trial':
    'Después {price}\u00A0€/mes · 500 Credits incluidos · Ahorra 48%',
  'og.planPriceNote.starter.default': 'Equivale a 1,16 € por Lead, ahorra 39%',
  'og.planPriceNote.starter.trial':
    'Después {price}\u00A0€/mes · 250 Credits incluidos · Ahorra 39%',
  'og.planPriceSuffix.default': '/ mes',
  'og.planPriceSuffix.trial': '/ mes después del trial',
  'og.planPriceSuffix.trialToday': 'hoy',
  'og.ready': 'Tu cuenta está lista',
  'og.recommended': 'Recomendado',
  'og.split.badge.start': 'Perfecto para empezar',
  'og.split.rating.note': '· Excelentes comentarios de usuarios',
  'og.split.rating.score': '4.8 / 5.0',
  'og.split.trust.cancel': 'Cancelable con 1 clic',
  'og.split.trust.gdpr': 'Conforme RGPD',
  'og.step.activateBeta': 'Activar paquete Beta',
  'og.step.created': 'Cuenta creada',
  'og.step.pickPlan': 'Elegir plan',
  'og.step.start': 'Comenzar',
  'og.step.startTrial': 'Probar 3 días gratis',
  'og.sub1': 'Elige tu plan para probar Leadscraper',
  'og.sub1b': '3 días gratis',
  'og.sub2': 'Sin pago ahora, puedes cancelar en cualquier momento durante el periodo de prueba.',
  'og.subtitle.beta':
    'Como Beta tester obtienes nuestro paquete más potente (500 Leads por mes) a un precio especial: tu primer mes cuesta 220 € en lugar de 490 €. Sin permanencia mínima, cancela cuando quieras.',
  'og.subtitle.default':
    'Tres planes, la misma calidad de datos. Elige cuántos Leads necesitas por mes. Puedes cambiar y cancelar en cualquier momento con un clic.',
  'og.subtitle.mai':
    'Ahorra 74% el primer mes, después cambia o cancela con 1 clic cuando quieras.',
  'og.subtitle.trial50': '50 Leads gratis, prueba 3 días, cancela cuando quieras.',
  'og.title.beta.grad': 'seleccionado',
  'og.title.beta.lead': 'Fuiste ',
  'og.title.beta.tail': ' para la Beta.',
  'og.title.default.grad': 'comienza en 60 segundos',
  'og.title.default.lead': 'Elige tu plan y ',
  'og.title.default.tail': '.',
  'og.title.mai.grad': 'ventaja competitiva desleal',
  'og.title.mai.lead': 'Tu ',
  'og.title.mai.tail': ' empieza aquí.',
  'og.title.trial50.grad': 'ahora gratis',
  'og.title.trial50.lead': '50 Leads B2B por valor de 100 €, ',
  'og.title.trial50.tail': '.',
  'og.trial': 'Probar 3 días gratis',
  'og.trial50v2.cta': 'Conseguir 50 Credits gratis',
  'og.trial50v2.detail': 'Credits suficientes para probar Leadscraper completamente.',
  'og.trial50v2.feature.1': 'Emails y teléfonos verificados',
  'og.trial50v2.feature.2': 'Targeting con IA en lenguaje natural',
  'og.trial50v2.feature.3': 'Integraciones CRM + exportación CSV/Excel',
  'og.trial50v2.feature.4': 'Conforme RGPD · Datos en la UE',
  'og.trial50v2.feature.5': 'Continúa después de 3 días, cancelable con 1 clic',
  'og.trial50v2.leadsNum': '50',
  'og.trial50v2.leadsUnit': 'Leads en 3 días',
  'og.trial50v2.planName': 'Trial',
  'og.trial50v2.price': 'Gratis',
  'og.trial50v2.priceNote': 'Termina después de 3 días o continúa, cancelable con 1 clic.',
  'og.trialIncl': 'incl.',
  'og.trialLeadsN': '{n} Leads de prueba',
  'og.trust.beta.lock.body': 'sin recargos ocultos',
  'og.trust.beta.lock.title': 'Precio especial beta el primer mes',
  'og.trust.cancel.body.default': 'Sin permanencia mínima',
  'og.trust.cancel.body.trial': 'Gratis durante el trial',
  'og.trust.cancel.title.default': 'Cancelable con 1 clic',
  'og.trust.card.body.default': 'Pago seguro a través de Stripe',
  'og.trust.card.body.trial': 'Cobro después de 3 días',
  'og.trust.card.title.default': 'Tarjeta requerida',
  'og.trust.card.title.trial': 'Tarjeta para activación',
  'og.trust.gdpr.body': 'Servidores en la UE · solo fuentes públicas',
  'og.trust.gdpr.title': 'Conforme RGPD',
  'og.welcome': 'Bienvenido, Janik.',

  'onb.step1Done': 'Leadscraper ahora conoce tu oferta: ve el análisis abajo',

  'onb.heroTitle': 'Tu ventaja competitiva empieza aquí',

  'onb.heroDesc':
    'En 3 pasos a tus primeros 10 leads. Leadscraper te conoce de verdad y por fin te entrega leads que realmente encajan.',

  'onb.helpCardTitle': '¿Nuevo en Leadscraper?',
  'onb.helpCardDesc':
    'Nuestra guía de inicio rápido te lleva en pocos minutos de la cuenta y el correo a tu primer público objetivo.',
  'onb.helpCardCta': 'Leer los primeros pasos',
  'onb.helpCardDismissAria': 'Ocultar aviso',

  'onb.stepLabel': 'Paso {n}',

  'onb.b2cLead': 'Leadscraper solo encuentra empresas, no clientes particulares.',

  'onb.b2cBody':
    'Tu análisis web indica que vendes a consumidores finales. Por eso las sugerencias de abajo apuntan a multiplicadores B2B (p. ej. promotoras, administradores de fincas) en lugar de los particulares directamente. Si no tienes una capa B2B adecuada, Leadscraper probablemente no sea la herramienta adecuada para tu negocio.',

  'onb.step2LabelDone': 'Primera audiencia lista. Leadscraper la ha guardado',

  'onb.step2LabelPending':
    'Define tu primer grupo objetivo: ¿a quién quieres exactamente como cliente?',

  'onb.step2Cta': 'Crear audiencia',

  'onb.step2Badge': 'Crear ahora',

  'onb.step2Locked': 'Esperando el paso 1',

  'onb.step3Title': 'Primera búsqueda',

  'onb.step3DescFull':
    'En cuanto tu primer perfil esté listo, inicias la búsqueda aquí directamente. Leadscraper encuentra 10 leads en 30-90 segundos, exactamente el grupo objetivo que acabas de crear.',

  'onb.step3Cta': 'Iniciar búsqueda',

  'onb.step3Badge': 'Iniciar ahora',

  'onb.step3Locked': 'Esperando el paso 2',
  'onb.step1Pending':
    'Cuéntale brevemente a Leadscraper sobre ti: un vistazo a tu sitio web es suficiente para que entienda lo que vendes',
  'onb.step2Desc':
    "Describe a tus clientes ideales en 1-2 frases: ej. 'Asesores fiscales en Madrid, 3-15 empleados, gerente general'. Con esto Leadscraper construye tus consultas de búsqueda, aprende con cada feedback, y el perfil se afina durante semanas.",
  'onb.step2Title': 'Crea tu primera audiencia',
  'onb.step3Done':
    'Primera búsqueda ejecutándose. Leadscraper te entregará los primeros 10 Leads pronto',
  'onb.step3Pending':
    'Búsqueda para tu público objetivo. Leadscraper entrega 10 Leads personalizados',

  'pd.activeSince': 'Activo desde {date}',
  'pd.company.analyze': 'Analizar',
  'pd.company.analyzed': 'Leadscraper ha analizado tu empresa (Confianza {n}%).',
  'pd.company.analyzedAt': 'Analizado el {date}',
  'pd.company.analyzing': 'Analizando…',
  'pd.company.cached': 'Perfil cargado desde caché.',
  'pd.company.cancel': 'Cancelar',
  'pd.company.change': 'Cambiar',
  'pd.company.confidence': '{n}% seguro',
  'pd.company.costHint':
    'Costo ~$0.015 por análisis. Re-análisis automático cada 30 días si tu sitio cambia.',
  'pd.company.error': 'Análisis fallido. Por favor inténtalo de nuevo.',
  'pd.company.inputDesc1':
    'Leadscraper lee la página de tu empresa y recuerda lo que vendes, a quién vendes y qué argumentos usas. Con cada Lead, Leadscraper entonces escribe ',
  'pd.company.inputDesc2': ' en lugar de solo "encaja con la industria".',
  'pd.company.inputDescStrong': 'tu estrategia de pitch personalizada',
  'pd.company.inputTitle': 'Introduce tu propia página web',
  'pd.company.knownTitle': 'Lo que Leadscraper sabe sobre tu empresa',
  'pd.company.placeholder': 'https://mi-empresa.com',
  'pd.company.reanalyze': 'Re-analizar ahora',
  'pd.company.reanalyzing': 'Re-analizando…',
  'pd.company.sellLabel': 'Lo que vendes',
  'pd.company.staleAt': 'Re-análisis pendiente {date}',
  'pd.company.targetLabel': 'A quién',
  'pd.company.techDetails': 'Detalles Técnicos',
  'pd.company.valueLabel': 'Propuestas de valor',
  'pd.cortex.comingSoon': 'pronto disponible',
  'pd.cortex.sub': 'Donde Leadscraper es más preciso con tu segmentación',
  'pd.cortex.title': 'Audiencia Leadscraper',
  'pd.curve.coldSub': 'Cold',
  'pd.curve.currentRate': 'tasa de acierto actual',
  'pd.curve.highPct':
    'Leadscraper acierta con {n}% muy precisamente: la curva de aprendizaje se dibuja en cuanto lleguen datos históricos a lo largo del tiempo. ',
  'pd.curve.highPctStrong': 'Todo según el plan.',
  'pd.curve.inWeeks': 'en {n} semanas',
  'pd.curve.learningActive': 'Leadscraper está aprendiendo activamente',
  'pd.curve.liftLabel': 'Mejora desde el inicio',
  'pd.curve.liftSub': 'tasa de coincidencia absoluta',
  'pd.curve.lockLabel': 'a partir de 50 valoraciones',
  'pd.curve.lowPct':
    'Leadscraper recopila el historial de tus {n} valoraciones. Con más datos, la línea de tendencia será más precisa.',
  'pd.curve.midPct':
    'Con tus {n} valoraciones Leadscraper construye el historial: la curva de aprendizaje será más visible con cada ejecución adicional.',
  'pd.curve.milestone200': '200 valoraciones',
  'pd.curve.milestone200Sub': 'modelo estabilizado',
  'pd.curve.milestone50': '50 valoraciones',
  'pd.curve.milestone50Sub': 'primeros patrones',
  'pd.curve.mockAxisEnd': '50 valoraciones',
  'pd.curve.mockTitle': 'Tasa de acierto en las últimas 50 valoraciones',
  'pd.curve.noData': 'Aún hay muy pocos datos.',
  'pd.curve.start': 'Inicio',
  'pd.curve.sub': 'Cómo ha evolucionado la tasa de coincidencia con cada valoración.',
  'pd.curve.subShort': 'Cómo evoluciona la tasa de coincidencia con cada evaluación',
  'pd.curve.title': 'Curva de aprendizaje',
  'pd.curve.today': 'Hoy',
  'pd.curve.todaySub': '{n} valoraciones',
  'pd.decisions.checked': '{n} candidatos revisados',
  'pd.decisions.checkedSg': '{n} candidato revisado',
  'pd.decisions.delivered': '{n} entregados',
  'pd.decisions.hint':
    '¿Ves un patrón que está mal? Reformula tu consulta: Leadscraper toma todas estas decisiones como ejemplos de aprendizaje para la próxima ejecución, en cuanto confirmes la memoria de la audiencia.',
  'pd.decisions.more': '+ {n} más…',
  'pd.decisions.rejected': '{n} rechazados',
  'pd.decisions.showAll': 'Mostrar todos los rechazados',
  'pd.decisions.showLess': 'Mostrar menos',
  'pd.decisions.title': 'Decisiones de Leadscraper · última ejecución',
  'pd.empty.cta': 'Ir al dashboard',
  'pd.empty.desc1': 'Una audiencia es ',
  'pd.empty.desc2':
    ': Leadscraper recopila en ella todos los aprendizajes de tus valoraciones. Crea tu primera audiencia en el panel; después encontrarás aquí todos los patrones, supuestos, motivos de rechazo y el historial de ejecuciones.',
  'pd.empty.descStrong': 'un contenedor de aprendizaje',
  'pd.empty.title': 'Aún no hay ninguna audiencia creada',
  'pd.hex.bizModel': 'Modelo de negocio',
  'pd.hex.industry': 'Industria',
  'pd.hex.location': 'Ubicación',
  'pd.hex.ownership': 'Propiedad',
  'pd.hex.role': 'Rol',
  'pd.hex.size': 'Tamaño',
  'pd.leads.sub': 'Vista previa: encuentra la lista completa en la pestaña Leads.',
  'pd.leads.title': 'Últimos Leads',
  'pd.leads.viewAll': 'Ver todos',
  'pd.learn.calibratedHint': 'Leadscraper ahora toma activamente tus patrones en el razonamiento.',
  'pd.learn.coldStartHint':
    'Valora más Leads para que Leadscraper comience a reconocer tus patrones.',
  'pd.learn.earlyHint':
    'Con cada valoración adicional, el reconocimiento de patrones se vuelve más preciso.',
  'pd.learn.emptyDesc1': 'En cuanto hagas clic en ',
  'pd.learn.emptyDesc2': ' o ',
  'pd.learn.emptyDesc3':
    ' en la lista de Leads, Leadscraper aprende tus preferencias y te muestra aquí lo que deduce de ellas.',
  'pd.learn.emptyFit': 'encaja',
  'pd.learn.emptyNotFit': 'no encaja',
  'pd.learn.emptyTitle': 'Aún no se ha dado feedback',
  'pd.learn.fits': 'Encaja',
  'pd.learn.lastRating': 'Última valoración ',
  'pd.learn.loadError': 'Error al cargar',
  'pd.learn.loading': 'Cargando estado del aprendizaje de feedback…',
  'pd.learn.matchRate': 'Tasa de acierto',
  'pd.learn.matchRateSub': 'encaja / valorado',
  'pd.learn.matureMsg':
    'Perfil completamente calibrado: Leadscraper trata tus patrones casi como reglas.',
  'pd.learn.morePrefix': 'Aún ',
  'pd.learn.moreSuffix': ' valoraciones hasta nivel ',
  'pd.learn.narrativeHide': 'Ocultar carta a la IA',
  'pd.learn.narrativeShow': 'Mostrar carta a la IA',
  'pd.learn.narrativeSub':
    'Exactamente este texto será pasado a la IA de Leadscraper en la próxima ejecución, literalmente.',
  'pd.learn.negative': 'negativo',
  'pd.learn.noData': 'No hay datos de feedback disponibles.',
  'pd.learn.noRating': 'Aún no hay valoración',
  'pd.learn.notFits': 'No encaja',
  'pd.learn.positive': 'positivo',
  'pd.learn.rated': 'Valorado',
  'pd.learn.ratingStatus': 'Estado de valoración',
  'pd.learn.recentTitle': 'Valoraciones recientes',
  'pd.learn.stageCali': 'Calibrado',
  'pd.learn.stageEarly': 'Aprendiendo',
  'pd.learn.stageMature': 'Maduro',
  'pd.learn.stageNext': 'siguiente nivel',
  'pd.learn.topReasons': 'Motivos de rechazo más frecuentes',
  'pd.learn.topReasonsDesc1': 'De tus ',
  'pd.learn.topReasonsDesc2':
    ' rechazos. Leadscraper recuerda estos patrones y empuja hacia abajo candidatos similares en la próxima ejecución.',
  'pd.learn.totalSub': '{n} en total',
  'pd.openLeads': 'Abrir Leads',
  'pd.pat.actions': 'Acciones',
  'pd.pat.confirm': 'Confirmar',
  'pd.pat.confirmT': 'Confirmar, adoptar como regla',
  'pd.pat.reject': 'Descartar',
  'pd.pat.rejectT': 'Descartar, eliminar patrón',
  'pd.pat.remove': 'Eliminar',
  'pd.pat.weaken': 'Debilitar',
  'pd.patterns.medium': 'Medio, plausible, se está observando',
  'pd.patterns.strong': 'Fuerte, reglas confiables',
  'pd.patterns.sub': 'Tus preferencias, extraídas de cada valoración de Encaja / No encaja.',
  'pd.patterns.title': 'Lo que Leadscraper ha aprendido',
  'pd.patterns.weak': 'Débil, señales tempranas',
  'pd.queries.dailyLegacy': 'Diario (legacy)',
  'pd.queries.daysAgo': 'iniciado hace {n} días',
  'pd.queries.emptySub':
    'Una vez que inicies una búsqueda, aparecerá aquí, incluyendo el cronograma.',
  'pd.queries.emptyTitle': 'Aún no se ha iniciado ninguna búsqueda para esta audiencia.',
  'pd.queries.everyH': 'Cada {n} h',
  'pd.queries.filterEmpty': 'No hay consultas en este filtro.',
  'pd.queries.hourly': 'Cada hora',
  'pd.queries.inDays': 'en {n} días',
  'pd.queries.inHours': 'en {n} h',
  'pd.queries.inMinutes': 'en {n} min.',
  'pd.queries.leadsDelivered': '{n} Leads entregados',
  'pd.queries.manual': 'Una vez',
  'pd.queries.monthlyLegacy': 'Mensual (legacy)',
  'pd.queries.newSearch': 'Iniciar nueva búsqueda',
  'pd.queries.overdue': 'vencida',
  'pd.queries.paused': 'pausado',
  'pd.queries.showAll': 'Mostrar todo',
  'pd.queries.sub': 'Haz clic para abrir detalles, cronograma e historial de la búsqueda.',
  'pd.queries.title': 'Consultas de búsqueda de esta audiencia',
  'pd.queries.tomorrow': 'mañana',
  'pd.queries.unnamed': 'Búsqueda sin nombre',
  'pd.queries.weeklyLegacy': 'Semanal (legacy)',
  'pd.ratings': '{n} valoraciones',
  'pd.rej.agency_not_operator': 'Agencia en lugar de operador',
  'pd.rej.consultant_not_operator': 'Consultor en lugar de operador',
  'pd.rej.duplicate_previous_session': 'Ya entregado',
  'pd.rej.insufficient_data': 'Datos insuficientes',
  'pd.rej.learned_rejection_pattern': 'Coincide con tu patrón de rechazo',
  'pd.rej.low_confidence': 'Muy incierto',
  'pd.rej.outside_radius': 'Fuera del radio',
  'pd.rej.wrong_company_form': 'Forma legal incorrecta',
  'pd.rej.wrong_industry': 'Industria incorrecta',
  'pd.rej.wrong_region': 'Región incorrecta',
  'pd.rej.wrong_role': 'Rol incorrecto',
  'pd.rej.wrong_size': 'Tamaño incorrecto',
  'pd.runs': '{n} búsquedas',
  'pd.screenLabel': 'Detalles de la audiencia',
  'pd.side.accepted': '({n} encajan)',
  'pd.side.feedbacks': 'Valoraciones',
  'pd.side.firstRun': 'Primera ejecución',
  'pd.side.focus': 'Enfoque de búsqueda',
  'pd.side.lastRun': 'Última ejecución',
  'pd.side.lastRunLeads': '{n} Leads',
  'pd.side.leadsTotal': 'Leads total',
  'pd.side.matchMiss': 'Encaja / No',
  'pd.side.matchRate': 'Tasa de coincidencia',
  'pd.side.next1.d': 'Con {pct}% de tasa de coincidencia vale la pena buscar 50–100 Leads nuevos.',
  'pd.side.next1.t': 'Iniciar búsqueda',
  'pd.side.next2.d': 'Así Leadscraper aprende más rápido.',
  'pd.side.next2.t': 'Revisar patrones no confirmados',
  'pd.side.next3.d': 'Cuantas más valoraciones, más preciso.',
  'pd.side.next3.t': 'Seguir dando feedback',
  'pd.side.patterns': 'Patrones',
  'pd.side.patternsSub': '{strong} fuertes · {medium} medios',
  'pd.side.reasons': 'Motivos de rechazo frecuentes',
  'pd.side.recommended': 'Recomendado',
  'pd.side.snapshot': 'De un vistazo',
  'pd.target.contacts': 'Contactos',
  'pd.target.excluded': 'Excluidos',
  'pd.target.industry': 'Industria',
  'pd.target.leads': 'Leads',
  'pd.target.patterns': 'Patrones',
  'pd.target.queries': 'Consultas',
  'pd.target.region': 'Región',
  'pd.target.size': 'Tamaño',
  'pd.target.sub': 'Lo que Leadscraper utiliza como base en cada búsqueda.',
  'pd.target.title': 'Audiencia objetivo',
  'pd.time.daysAgo': 'hace {n} días',
  'pd.time.hoursAgo': 'hace {n} h',
  'pd.time.justNow': 'justo ahora',
  'pd.time.minsAgo': 'hace {n} min',
  'pd.toast.confirmed': 'Patrón confirmado, se aplicará desde ahora como regla confiable',
  'pd.toast.rejected': 'Patrón descartado',
  'pd.toast.removed': 'Patrón eliminado',
  'pd.toast.weakened': 'Patrón debilitado, se observará nuevamente',

  'price.afterThen': 'Después {price} / mes · cancelable en cualquier momento',
  'price.badge.popular': 'Popular',
  'price.badge.recommended': 'Recomendado',
  'price.badge.yourPlan': 'Tu plan',
  'price.ctaStartTrial': 'Comenzar 3 días gratis',
  'price.ctaSwitchPlan': 'Cambiar suscripción',
  'price.ctaCurrentPlan': 'Plan actual',
  'price.ctaTopUp': 'Recargar ahora',
  'price.heroSub': 'Más Leads, exactamente cuando los necesitas.',
  'price.heroTrial': 'Tu ventaja competitiva desleal comienza aquí.',
  'price.leads': 'Leads',
  'price.monthlyCancelable': 'cancelable mensualmente',
  'price.oneTime': 'único',
  'price.pack.1000.tag': 'Perfecto para empezar',
  'price.pack.10000.tag': 'Para generación continua de Leads',
  'price.pack.5000.tag': 'Para primeras campañas escaladas',
  'price.pack.50000.tag': 'Para alto volumen y equipos',
  'price.perLead': '€ / Lead',
  'price.perMonth': '/mes',
  'price.perMonthLong': '/ mes',
  'price.plan.basic.f1': '100 Leads cualificados por mes',
  'price.plan.basic.f2': '1 audiencia activa',
  'price.plan.basic.f3': 'IA Leadscraper con aprendizaje continuo',
  'price.plan.basic.f4': 'Integraciones CRM (HubSpot, Pipedrive, Salesforce …)',
  'price.plan.basic.f5': 'Soporte por email',
  'price.plan.basic.tag': 'Para empezar con una audiencia',
  'price.plan.growth.f1': '500 Leads cualificados por mes',
  'price.plan.growth.f2': 'Audiencias ilimitadas',
  'price.plan.growth.f3': 'IA Leadscraper con Memory de equipo',
  'price.plan.growth.f4': 'Todas las integraciones CRM + Webhooks',
  'price.plan.growth.f5': 'Account Manager dedicado',
  'price.plan.growth.f6': 'Acceso a API',
  'price.plan.growth.tag': 'Para equipos de ventas escalables',
  'price.plan.starter.f1': '250 Leads cualificados por mes',
  'price.plan.starter.f2': '3 audiencias activas',
  'price.plan.starter.f3': 'IA Leadscraper con aprendizaje prioritario',
  'price.plan.starter.f4': 'Todas las integraciones CRM',
  'price.plan.starter.f5': 'Soporte prioritario',
  'price.plan.starter.f6': 'Export en CSV, XLSX, JSON',
  'price.plan.starter.tag': 'Perfecto para el inicio',
  'price.selected': 'Seleccionado:',
  'price.subOneoffDesc':
    'Leads adicionales como paquete único, sin duración, sin compromiso. Los Credits no caducan.',
  'price.subTrialDesc':
    'Prueba 3 días gratis: con Leads reales, tus propios perfiles, tu propio Leadscraper Memory. ¿Leads inútiles? Los recuperas sin preguntas.',
  'price.tab.afterSub': '(después de suscripción)',
  'price.tab.lockNote': 'Disponible después del inicio de suscripción',
  'price.tab.oneoff': 'Paquetes únicos',
  'price.tab.sub': 'Suscripciones',
  'price.testLeads': 'Leads de prueba',
  'price.then': 'después',
  'price.trial3days': '3 días gratis',
  'price.trialIncl': 'incl.',
  'price.trust.cancel.s': 'Cancelable mensualmente, sin tarifas ocultas, sin duración mínima.',
  'price.trust.cancel.t': 'Cancelable en cualquier momento',
  'price.trust.gdpr.s':
    'Todos los datos alojados en UE, encriptados, sin transferencias a terceros.',
  'price.trust.gdpr.t': 'Conforme a GDPR',
  'price.trust.refund.s': 'Si un Lead no encaja, recuperas el Credit inmediatamente.',
  'price.trust.refund.t': '¿Leads inútiles? De vuelta.',

  'pricing.beta.headline': 'Tu acceso Beta a Leadscraper',
  'pricing.beta.subText':
    'Plan Growth con 55% de descuento en el primer mes, exclusivo para Beta testers.',
  'pricing.mai.headline': 'Tu ventaja competitiva desleal empieza aquí.',
  'pricing.mai.subText':
    'Ahorra 74% el primer mes, después cambia o cancela con 1 clic cuando quieras.',
  'pricing.trial50.headline': '50 Leads B2B por valor de 100 €, ahora gratis.',
  'pricing.trial50.subText': '50 Leads gratis, prueba 3 días, cancela cuando quieras.',

  'reject.alreadyKnown': 'Ya lo conocemos',
  'reject.alreadyKnown.hint':
    'Ya en tu CRM o contactado antes, sin señal de aprendizaje y no afecta a tu tasa de aciertos.',
  'reject.badData': 'Datos incorrectos',
  'reject.badData.hint': 'La dirección, nombre o información de contacto no es correcta',
  'reject.noBuyingSignal': 'No hay necesidad reconocible',
  'reject.noBuyingSignal.hint':
    'Sin eventos desencadenantes, sin vacantes abiertas, sin señales de crecimiento',
  'reject.notOperator': 'No es operador',
  'reject.notOperator.hint': 'Agencia, intermediario o promotor en lugar de proveedor operativo',
  'reject.other': 'Otra razón',
  'reject.other.hint': 'Escribe brevemente el motivo abajo (texto libre)',
  'reject.wrongIndustry': 'Sector incorrecto',
  'reject.wrongIndustry.hint': 'Leadscraper identificó mal el sector de negocio',
  'reject.wrongOwnership': 'Estructura de propiedad incorrecta',
  'reject.wrongOwnership.hint':
    'Filial de corporativo en lugar de empresa familiar, forma jurídica incorrecta, etc.',
  'reject.wrongRegion': 'Ubicación incorrecta',
  'reject.wrongRegion.hint': 'La sede / región no coincide con la búsqueda',
  'reject.wrongRole': 'Contacto incorrecto',
  'reject.wrongRole.hint': 'La persona o el rol no es el decisor',
  'reject.wrongSize': 'Tamaño de empresa incorrecto',
  'reject.wrongSize.hint': 'Muy pequeña, muy grande o corporativo en lugar de mediana empresa',

  'rel.daysAgo': 'hace {n} días',
  'rel.hAgo': 'hace {n} h',
  'rel.minAgo': 'hace {n} min',
  'rel.now': 'ahora',
  'rel.weeksAgo': 'hace {n} semanas',
  'rel.yesterday': 'ayer',

  'repeat.amountHint': 'Más Leads = mayor cobertura, menos Leads = mayor calidad por Lead.',
  'repeat.amountLabel': '¿Cuántos Leads quieres?',
  'repeat.cancel': 'Cancelar',
  'repeat.paramsLabel': 'Parámetros de esta ejecución',
  'repeat.prediction.basedOn': 'basado en tu tasa de coincidencia actual',
  'repeat.prediction.credits': 'Credits',
  'repeat.prediction.matches': 'coincidencias esperadas',
  'repeat.prediction.time': 'tiempo estimado de ejecución',
  'repeat.prediction.title': 'Resultado esperado',
  'repeat.preset': 'Sugerencias',
  'repeat.start': 'Iniciar búsqueda',
  'repeat.sub': 'Los parámetros están preconfigurados: ajústalos o inicia directamente.',
  'repeat.title': 'Repetir búsqueda',
  'repeat.toast': 'Búsqueda iniciada, resultados en pocos minutos.',

  'res.acceptedNote': 'Leadscraper aprende de esta aceptación.',
  'res.breadcrumb': 'Resultados de búsqueda · {profile}',
  'res.cancel': 'Cancelar',
  'res.density.comfortable': 'Cómodo',
  'res.density.compact': 'Compacto',
  'res.employees': 'Empleados',
  'res.fb.all': 'Todos',
  'res.fb.new': 'Nuevo para ti',
  'res.fb.status': 'Estado de feedback',
  'res.filter': 'Filtro',
  'res.fit': 'Encaja',
  'res.footer':
    'Leadscraper ha revisado {count} entradas adicionales. Las {count} mostradas aquí son las que mejor se ajustan a tu feedback previo.',
  'res.fromMem': 'de tu memoria: „{text}"',
  'res.learning.body':
    'Nueva señal de las últimas dos semanas: aceptas más a menudo empresas con tecnología de impresión o troquelado propia que a confeccionistas puros.',
  'res.learning.title': 'Lo que Leadscraper está aprendiendo ahora',
  'res.location': 'Ubicación',
  'res.new': 'Nuevo',
  'res.notFit': 'No encaja',
  'res.openDetails': 'Abrir detalles →',
  'res.pickReason': 'Elegir motivo →',
  'res.reasonHint': 'Un clic es suficiente: tu motivo afina lo que verás mañana.',
  'res.rejectedNote': 'Motivo guardado. Esto afina tu memoria.',
  'res.sector': 'Sector',
  'res.summary':
    '{count} Leads de 412 revisados. Cada uno viene con una frase de por qué encaja contigo: tu "Encaja / No encaja" afina lo que verás mañana.',
  'res.title': 'Leads · {profile}',
  'res.toast.accepted': '«{company}» guardado como Encaja. Leadscraper afina tu audiencia.',
  'res.toast.rejected': 'Motivo „{reason}" guardado. Leads similares serán menos frecuentes.',
  'res.uncertainty': 'Leadscraper está aquí {score}: {text}.',
  'res.whyNotTitle': '¿Por qué este Lead no encaja?',

  'run.complete': 'Búsqueda completada: {count} Leads entregados.',
  'run.completeEmpty':
    'Búsqueda completada: no se encontraron empresas adecuadas. Precisa tu público objetivo o prueba otra región.',
  'run.cta.broaden_query': 'Formular consulta más amplia',
  'run.cta.edit_query': 'Ajustar consulta',
  'run.cta.retry': 'Intentar de nuevo',
  'run.failed.body':
    'Falla técnica en la última búsqueda. Espera 1-2 minutos e inténtalo de nuevo. Si se atasca otra vez, avísanos.',
  'run.failed.title': 'Leadscraper se ha atascado',
  'run.no_leads_delivered': 'No se entregaron Leads adecuados',
  'run.no_results.body':
    'Tus keywords no arrojan empresas B2B alemanas adecuadas en Google. Prueba términos más cotidianos: ej. "carpintería" en lugar de "manufactura de muebles", o amplía la región.',
  'run.no_results.title': 'No se encontraron resultados para tu consulta en la web',
  'run.partial_yield.body':
    'Leadscraper encontró menos de 10 resultados. Para más volumen: formula la descripción de manera más flexible o amplía la región.',
  'run.partial_yield.title': '{delivered}/{total} Leads entregados',
  'run.searching': '🧠 Leadscraper está buscando para ti…',
  'run.too_strict.body':
    'Leadscraper encontró empresas, pero ninguna coincide claramente con tu público objetivo. Quizás tu descripción es muy específica: intenta con una región más grande, flexibiliza el número de empleados o elimina detalles.',
  'run.too_strict.title': '{reasoned} candidatos evaluados: ninguno encajaba con tu audiencia',

  'runs.delivered': '{n} Leads entregados',
  'runs.deliveredOne': '1 Lead entregado',
  'runs.empty': 'Aún no hay ejecuciones para esta búsqueda.',
  'runs.evaluated': '{n} evaluados',
  'runs.failed': 'falló',
  'runs.harvested.body':
    'Los búsquedas anteriores ya han identificado {n} empresas que encajan. Leadscraper ya conoce estos resultados. Los nuevos resultados aparecen cuando nuevas empresas de tu público objetivo se hacen visibles online. La programación las detecta automáticamente.',
  'runs.harvested.title': 'Audiencia objetivo agotada por ahora',
  'runs.last': 'último',
  'runs.loadError': 'Error al cargar',
  'runs.loadFailed': 'No se pudo cargar el historial: {err}',
  'runs.loading': 'Cargando historial…',
  'runs.noHits': 'sin resultados',
  'runs.running': 'ejecutando ahora',
  'runs.unfeasible': 'no factible',

  'sched.autoPush': 'Enviar nuevos Leads automáticamente al CRM',
  'sched.autoPushNoCRM':
    'Primero debes conectar un CRM en la configuración de la cuenta para usar el envío automático.',
  'sched.autoPushSub':
    'Una vez que Leadscraper complete una ejecución programada, todos los Leads encontrados se enviarán automáticamente a tu CRM conectado.',
  'sched.daily': 'Diariamente',
  'sched.dailySub': 'Todos los días a la misma hora',
  'sched.day.fri': 'Viernes',
  'sched.day.fri.short': 'Vi',
  'sched.day.mon': 'Lunes',
  'sched.day.mon.short': 'Lu',
  'sched.day.sat': 'Sábado',
  'sched.day.sat.short': 'Sa',
  'sched.day.sun': 'Domingo',
  'sched.day.sun.short': 'Do',
  'sched.day.thu': 'Jueves',
  'sched.day.thu.short': 'Ju',
  'sched.day.tue': 'Martes',
  'sched.day.tue.short': 'Ma',
  'sched.day.wed': 'Miércoles',
  'sched.day.wed.short': 'Mi',
  'sched.dayOfMonth': 'Día del mes',
  'sched.monthly': 'Mensualmente',
  'sched.monthlySub': 'Cada mes en la fecha seleccionada',
  'sched.nextRun': 'Próxima ejecución',
  'sched.once': 'Una vez',
  'sched.onceSub': 'Ejecutar ahora una vez',
  'sched.rel.inDays': 'en {n} días',
  'sched.rel.overdue': 'vencido',
  'sched.rel.soon': 'pronto',
  'sched.rel.tomorrow': 'mañana',
  'sched.section': 'Repetición',
  'sched.sectionSub':
    'Permite que Leadscraper ejecute esta búsqueda automáticamente de forma regular.',
  'sched.time': 'Hora de inicio',
  'sched.toast.created': 'Búsqueda programada creada: se ejecutará automáticamente.',
  'sched.toast.deleted': 'Ejecución programada eliminada.',
  'sched.toast.paused': 'Ejecución programada pausada.',
  'sched.toast.resumed': 'Ejecución programada reactivada.',
  'sched.weekday': 'Día de la semana',
  'sched.weekly': 'Semanalmente',
  'sched.weeklySub': 'Cada semana el día seleccionado',

  'schedCard.creditsHint':
    'máx. {n} Credits / día: una vez que no se encuentren más Leads nuevos en tu audiencia objetivo, Leadscraper funciona sin consumo.',
  'schedCard.errorToast': 'Error al guardar: {err}',
  'schedCard.freq.every': 'Cada {n} horas',
  'schedCard.freq.everyShort': 'cada {n} h',
  'schedCard.freq.hourly': 'Cada hora',
  'schedCard.freq.everyMinute': 'Cada minuto (prueba)',
  'schedCard.minuteTestHint':
    'Modo de prueba: se ejecuta ~cada minuto cuando corre el tick del planificador. Solo staging.',
  'schedCard.freq.hourlyShort': 'cada hora',
  'schedCard.leadsPerDay': '~{n} Leads / día',
  'schedCard.nextLabel': 'próxima ejecución {when}',
  'schedCard.nextRun.days': 'en {n} días',
  'schedCard.nextRun.hours': 'en {n} h',
  'schedCard.nextRun.min': 'en {n} min',
  'schedCard.nextRun.overdue': 'atrasado',
  'schedCard.nextRun.tomorrow': 'mañana',
  'schedCard.noRepeat': 'Sin repetición',
  'schedCard.offBody': 'Una sola vez: tú inicias cuando quieras.',
  'schedCard.onBody':
    'Ejecuta en segundo plano. Los nuevos resultados llegan automáticamente a tu lista de Leads.',
  'schedCard.perWeek': '≈ {n} / semana',
  'schedCard.repeat': 'Repetir esta búsqueda',
  'schedCard.save': 'Guardar',
  'schedCard.savedToast': 'Programa guardado.',
  'schedCard.saving': 'Guardando…',

  'schedRuns.col.action': '',
  'schedRuns.col.crm': 'Envío CRM',
  'schedRuns.col.frequency': 'Frecuencia',
  'schedRuns.col.leads': 'Leads/Ejecución',
  'schedRuns.col.nextRun': 'Próxima ejecución',
  'schedRuns.col.params': 'Parámetros',
  'schedRuns.count': 'activa',
  'schedRuns.crm.no': 'Desactivado',
  'schedRuns.crm.yes': 'Activo',
  'schedRuns.delete': 'Eliminar',
  'schedRuns.empty.sub':
    'Activa "Repetición" en tu próxima búsqueda para recibir nuevos Leads regularmente.',
  'schedRuns.empty.title': 'Aún no hay ejecuciones programadas',
  'schedRuns.freq.daily': 'Diariamente · {time}',
  'schedRuns.freq.monthly': '{day} del mes · {time}',
  'schedRuns.freq.weekly': '{day} · {time}',
  'schedRuns.pause': 'Pausar',
  'schedRuns.resume': 'Reanudar',
  'schedRuns.status.paused': 'Pausado',
  'schedRuns.sub':
    'Ejecuciones periódicas que añaden automáticamente nuevos leads a esta audiencia.',
  'schedRuns.title': 'Búsquedas programadas',

  'so.close.btn': 'Dejar ejecutándose en segundo plano',
  'so.close.hint':
    'Puedes seguir trabajando: Leadscraper te avisará cuando nuevos leads estén listos.',
  'so.close.trust': 'Solo fuentes públicas · cada dato queda documentado en el lead.',
  'so.funnel.analyzed': 'Analizado en profundidad',
  'so.funnel.evaluated': 'Evaluado',
  'so.funnel.identified': 'Identificado',
  'so.funnel.ready': 'Listo',
  'so.hero.elapsed': 'Tiempo desde el inicio:',
  'so.hero.inFocus': 'Empresas en foco',
  'so.hero.preparing': 'Leadscraper está revisando tu solicitud',
  'so.hero.reflecting': 'Leadscraper está pensando un nuevo plan',
  'so.hero.round': '(Ronda {n})',
  'so.hero.searching': 'Leadscraper está buscando para ti',
  'so.live.title': 'Leadscraper trabaja en vivo',
  'so.query.title': 'Tu consulta de búsqueda',
  'so.reflector.title': 'Leadscraper ha descartado el primer enfoque',
  'so.step.delivery.sub': 'Las mejores coincidencias se ordenan y entregan para ti',
  'so.step.delivery.title': 'Compilar leads',
  'so.step.discovery.sub': 'Mejores candidatos de fuentes web alemanas',
  'so.step.discovery.title': 'Identificar empresas',
  'so.step.done.sub': 'Búsqueda completada',
  'so.step.done.title': 'Listo',
  'so.step.enriching.sub':
    'Plan de prospección, puntuaciones + investigación profunda de los 10 Leads',
  'so.step.enriching.title': 'Cortex está enriqueciendo',
  'so.step.enriching.title.light': 'Verificando datos básicos',
  'so.step.hydration.sub': 'Sitios web + información legal + carreras + equipo + noticias',
  'so.step.hydration.title': 'Analizar empresas en profundidad',
  'so.step.planning.sub': 'Analizar tus aprendizajes + planificar estrategias de búsqueda',
  'so.step.planning.title': 'Leadscraper recuerda',
  'so.step.reasoning.sub': 'Leadscraper evalúa cada candidato según tu audiencia',
  'so.step.reasoning.title': 'Leadscraper evalúa',

  'src.derived': 'Por Leadscraper',
  'src.directory': 'Directorio',
  'src.news': 'Prensa especializada',
  'src.official': 'Oficial',
  'src.web': 'Sitio web de empresa',

  'trial.afterNote':
    'Después tu suscripción {plan} continúa automáticamente, cancelable en cualquier momento.',
  'trial.day1': 'Queda 1 día',
  'trial.daysN': 'Quedan {n} días',
  'trial.freeTest': 'probar gratis.',
  'trial.leadsLeft': '{left} / {total} Leads de prueba restantes',
  'trial.phase': 'Periodo de prueba',
  'trial.secureSub': 'Asegurar suscripción',
  // LEA-324: SEPA subscription "payment processing" banner.
  'bill.sepaProcessing.badge': 'Procesando pago',
  'bill.sepaProcessing.title': 'Tu pago SEPA se está procesando: tu acceso ya está desbloqueado.',
  'bill.sepaProcessing.note':
    'El adeudo puede tardar de 2 a 5 días hábiles. Ya puedes usar Leadscraper por completo.',

  // ─── Transactional email — shared strings ────────────────────────────────
  // LEA-295: machine-translated from de.ts/en.ts. Tone is informal-business
  // to match the existing app strings. Native-speaker review pending before
  // production rollout (see staging-verification runbook).
  'email.shared.brand.name': 'Leadscraper',
  'email.shared.founder.name': 'Janik Deimann',
  'email.shared.founder.title': 'Fundador, Leadscraper',
  'email.shared.reply_note': '¿Dudas? Responde a este correo.',
  'email.sepa-payment-failed.subject': 'Tu pago SEPA ha fallado',
  'email.sepa-payment-failed.preheader': 'El adeudo de {{amount_formatted}} ha sido devuelto.',
  'email.sepa-payment-failed.badge': 'Pago fallido',
  'email.sepa-payment-failed.hero': 'Tu adeudo<br>ha sido devuelto.',
  'email.sepa-payment-failed.greeting': 'Hola {{first_name}},',
  'email.sepa-payment-failed.intro':
    'el adeudo SEPA de tu paquete de créditos no se ha podido cobrar en tu banco.',
  'email.sepa-payment-failed.credits_line':
    'Por eso hemos retirado {{credits_revoked}} créditos de tu cuenta.',
  'email.sepa-payment-failed.retry_line':
    'Si necesitas los créditos, puedes volver a comprar el paquete en tu cuenta.',
  'email.sepa-payment-failed.button': 'Abrir Leadscraper',
  'email.sepa-payment-failed.detail.pack_label': 'Paquete',
  'email.sepa-payment-failed.detail.amount_label': 'Importe',
  'email.shared.footer.transactional':
    'Recibes este email porque te registraste para una cuenta de Leadscraper. Este mensaje transaccional forma parte de la relación contractual y no se puede dar de baja.',
  'email.shared.footer.legal':
    'Deimann Com GmbH &middot; Randstraße 75 &middot; 22525 Hamburg &middot; Alemania<br />Director General: Janik Deimann &middot; HRB 164162 (AG Hamburg) &middot; NIF DE332747716 &middot; © {{year}}',

  // ─── Transactional email — welcome ───────────────────────────────────────
  'email.welcome.subject': 'Bienvenido a Leadscraper, {{first_name}} 👋',
  'email.welcome.title': 'Bienvenido a Leadscraper',
  'email.welcome.preheader': 'Bienvenido a bordo, tus primeros leads en 5 minutos.',
  'email.welcome.badge': 'Cuenta lista',
  'email.welcome.hero': 'Me alegra tenerte aquí,<br>{{first_name}}.',
  'email.welcome.subhead':
    'Tu cuenta está configurada y tus primeros créditos están listos, ¡vamos allá!',
  'email.welcome.steps.title': 'Empieza en 5 pasos',
  'email.welcome.steps.1.title': 'Añade tu sitio web',
  'email.welcome.steps.1.body':
    'Para que el agente entienda hacia dónde va tu negocio, y en qué fijarse.',
  'email.welcome.steps.2.title': 'Define tu público objetivo',
  'email.welcome.steps.2.body':
    'Sector, región, tamaño de empresa, cargo: cuanto más preciso, mejores los resultados.',
  'email.welcome.steps.3.title': 'Lanza tu primera búsqueda de leads',
  'email.welcome.steps.3.body':
    'El agente investiga, enriquece y entrega las primeras empresas directamente en tu dashboard.',
  'email.welcome.steps.4.title': 'Califica los leads',
  'email.welcome.steps.4.body':
    'Pulgar arriba o abajo: el agente aprende de cada feedback qué te encaja.',
  'email.welcome.steps.5.title': 'Lanza la siguiente búsqueda',
  'email.welcome.steps.5.body':
    'Con cada ejecución los resultados son notablemente más precisos, hasta encajar al 100 % contigo.',
  'email.welcome.cta.primary': 'Al dashboard',
  'email.welcome.signoff.line': '¿Preguntas? Responde directamente a este email: yo lo leo.',

  // ─── Transactional email — subscription-cancelled ────────────────────────
  'email.subscription-cancelled.subject':
    'Lamentamos verte ir, {{first_name}}: cancelación confirmada',
  'email.subscription-cancelled.title': 'Tu suscripción ha sido cancelada',
  'email.subscription-cancelled.preheader': 'Hemos recibido tu cancelación.',
  'email.subscription-cancelled.badge': 'Cancelación confirmada',
  'email.subscription-cancelled.hero': 'Lamentamos verte ir,<br>{{first_name}}.',
  'email.subscription-cancelled.subhead':
    'Hemos recibido tu cancelación. Tu acceso al plan {{plan_name}} sigue activo hasta {{access_until}}.',
  'email.subscription-cancelled.subhead_trial':
    'Hemos recibido tu cancelación. Tu prueba ha terminado y no se te cobrará nada.',
  'email.subscription-cancelled.note_trial':
    'Si más adelante quieres continuar, puedes reactivar tu suscripción en tu cuenta.',
  'email.subscription-cancelled.summary.plan_label': 'Plan',
  'email.subscription-cancelled.summary.until_label': 'Acceso hasta',
  'email.subscription-cancelled.note':
    'Hasta entonces mantienes acceso completo. Después, tus datos se eliminan según nuestra política de privacidad.',
  'email.subscription-cancelled.signoff.line':
    '¿Qué podríamos haber hecho mejor? Responde a este email: yo lo leo.',
  'email.subscription-cancelled.cta.primary': 'Volver al producto &amp; reactivar',
  'email.subscription-cancelled.cta.note':
    'Aterrizarás directamente en el dashboard donde puedes reactivar tu suscripción.',
  'email.subscription-cancelled.footer.transactional':
    'Recibes este email como confirmación de tu cancelación. Este mensaje transaccional forma parte de la relación contractual y no se puede dar de baja.',

  // ─── Transactional email — payment-failed / dunning (LEA-304, AI-translated from DE master) ─────
  'email.payment-failed.subject': 'Tu pago ha fallado, actualiza tus datos',
  'email.payment-failed.title': 'Pago fallido, actualiza tus datos',
  'email.payment-failed.preheader':
    'No pudimos cobrar {{amount_formatted}} de tu plan {{plan_name}}. Por favor, actualiza tus datos de pago.',
  'email.payment-failed.badge': 'Pago fallido',
  'email.payment-failed.hero': 'Tu pago no se ha procesado, {{first_name}}.',
  'email.payment-failed.subhead':
    'No pudimos cobrar <strong style="color:#0B0F19;">{{amount_formatted}}</strong> de tu plan {{plan_name}}. Actualiza tus datos de pago para evitar una interrupción de tus leads.',
  'email.payment-failed.summary.plan_label': 'Plan',
  'email.payment-failed.summary.amount_label': 'Importe pendiente',
  'email.payment-failed.summary.attempt_label': 'Intento',
  'email.payment-failed.summary.attempt_value': '{{attempt_count}} de 3',
  'email.payment-failed.summary.next_label': 'Próximo intento',
  'email.payment-failed.cta.primary': 'Actualizar datos de pago ahora',
  'email.payment-failed.reassurance':
    'Solo te llevará un minuto, después todo seguirá como siempre. ¿Preguntas? Responde a este email.',
  'email.payment-failed.footer.transactional':
    'Recibes este email porque ha fallado un pago de tu suscripción de Leadscraper. Este mensaje transaccional forma parte de la relación contractual y no se puede dar de baja.',

  // ─── Transactional email — trial-ending-soon (LEA-295) ─────
  'email.trial-winback.subject': 'Si solo era miedo al cobro …',
  'email.trial-winback.badge': 'Tu cuenta sigue ahí',
  'email.trial-winback.hero': '30 % de descuento<br>si quieres seguir.',
  'email.trial-winback.preheader':
    'Vuelve — 30 % de descuento durante 3 meses, tu cuenta sigue ahí.',
  'email.trial-winback.greeting': 'Hola {{first_name}}:',
  'email.trial-winback.intro':
    'ayer terminaste tu prueba de inmediato — totalmente válido, para eso está el botón. Pero si solo era para evitar un cobro no deseado: tu cuenta sigue ahí, con todo lo que configuraste.',
  'email.trial-winback.offer':
    'Si quieres continuar: {{plan_name}} con un 30 % de descuento durante 3 meses. Sin formularios nuevos — tu tarjeta ya está registrada.',
  'email.trial-winback.button': 'Ver oferta y reactivar',
  'email.trial-winback.transparency':
    'El clic no cobra nada — primero ves el precio y la fecha de cobro y luego confirmas tú mismo. Enlace: {{winback_url}}',
  'email.trial-winback.signoff': 'Janik',
  'email.trial-ending-soon.cancel_note':
    '¿No quieres continuar? Cancela con un clic, antes del primer cobro: {{cancel_link}}',
  'email.trial-ending-soon.cancel_link_label': 'Cancelar la prueba',
  'email.trial-ending-soon.subject': 'Tu prueba termina pronto',
  'email.trial-ending-soon.preheader':
    'La prueba termina el {{trial_ends_at}}. Elige un plan ahora.',
  'email.trial-ending-soon.greeting': 'Hola {{first_name}},',
  'email.trial-ending-soon.intro':
    'tu prueba de {{plan_name}} termina el {{trial_ends_at}}. Te quedan {{credits_remaining}} créditos.',
  'email.trial-ending-soon.why':
    'Cuando termine la prueba, tu cuenta pasará a solo lectura: podrás seguir viendo tus leads anteriores, pero no iniciar nuevas búsquedas.',
  'email.trial-ending-soon.cta':
    'Si los resultados te funcionan: elige un plan ahora para que todo siga sin interrupciones.',
  'email.trial-ending-soon.button': 'Elegir un plan',
  'email.trial-ending-soon.signoff': 'Janik',

  // ─── Transactional email — trial-ended (LEA-295) ─────
  'email.trial-ended.subject': 'Tu prueba ha terminado',
  'email.trial-ended.badge': 'Prueba finalizada',
  'email.trial-ended.hero': 'Tu prueba<br>ha terminado.',
  'email.trial-ended.preheader': 'Tu prueba ha terminado, cuenta en solo lectura.',
  'email.trial-ended.greeting': 'Hola {{first_name}},',
  'email.trial-ended.intro':
    'tu prueba de {{plan_name}} acaba de terminar. Tu cuenta ahora es de solo lectura: puedes seguir viendo todos tus leads anteriores, pero las nuevas búsquedas están en pausa.',
  'email.trial-ended.cta':
    'Elige un plan para continuar de inmediato. Tus datos y tu memoria de aprendizaje se conservan.',
  'email.trial-ended.button': 'Elegir un plan',
  'email.trial-ended.signoff': 'Hasta pronto.<br>Janik',

  // ─── Transactional email — verify-email (LEA-295) ─────
  'email.verify-email.subject': 'Confirma tu dirección de email',
  'email.verify-email.badge': 'Ya casi está',
  'email.verify-email.hero': 'Confirma tu<br>dirección de correo.',
  'email.verify-email.preheader': 'Confirma tu email para activar Leadscraper.',
  'email.verify-email.greeting': 'Hola {{first_name}},',
  'email.verify-email.body':
    'pulsa el botón de abajo para confirmar tu email y activar tu cuenta de Leadscraper.',
  'email.verify-email.button': 'Confirmar email',
  'email.verify-email.fallback_note': 'Si el botón no funciona, pega este enlace en tu navegador:',
  'email.verify-email.ttl_note': 'El enlace caduca en {{verify_expires_in}}.',
  'email.verify-email.ttl_default': '24 horas',
  'email.verify-email.ignore_note': '¿No creaste una cuenta de Leadscraper? Ignora este email.',

  // ─── Transactional email — refund-confirmation (LEA-295) ─────
  'email.refund-confirmation.subject': 'Reembolso confirmado',
  'email.refund-confirmation.preheader': 'Reembolso: {{amount_formatted}}',
  'email.refund-confirmation.greeting': 'Hola {{first_name}},',
  'email.refund-confirmation.intro': 'te hemos reembolsado {{amount_formatted}}.',
  'email.refund-confirmation.refunded_line':
    'Registrado el {{refunded_at}} en tu método de pago original. Según el banco, el abono aparece en 3-10 días hábiles.',
  'email.refund-confirmation.clawback_yes':
    'Como el reembolso cancela los créditos asociados, se han retirado {{credits_clawed_back}} créditos de tu cuenta.',
  'email.refund-confirmation.clawback_no': 'Tus créditos permanecen intactos.',
  'email.refund-confirmation.reason_line': 'Motivo: {{reason}}.',
  'email.refund-confirmation.outro': '¿Preguntas? Responde a este email.',
  'email.refund-confirmation.footer':
    'Recibes este email porque se ha emitido un reembolso para tu cuenta de Leadscraper.',

  // ─── Transactional email — password-reset ────────────────────────────────
  'email.password-reset.subject': 'Restablecer contraseña, enlace válido durante {{expires_in}}',
  'email.password-reset.title': 'Restablecer contraseña',
  'email.password-reset.preheader':
    'Restablece tu contraseña de forma segura. El enlace caduca en {{expires_in}}.',
  'email.password-reset.badge': 'Restablecer contraseña',
  'email.password-reset.hero': 'Establecer nueva<br>contraseña.',
  'email.password-reset.body':
    'Alguien ha solicitado restablecer tu contraseña. Si fuiste tú, simplemente haz clic en el botón. Si no, ignora este email. Tu contraseña no cambiará.',
  'email.password-reset.expires': 'El enlace caduca en {{expires_in}}.',
  'email.password-reset.cta.primary': 'Restablecer contraseña',
  'email.password-reset.signoff.line':
    '¿Preguntas sobre seguridad de la cuenta? Simplemente responde a este email.',
  'email.password-reset.footer.transactional':
    'Por motivos de seguridad, este email contiene información sobre la solicitud. No la compartas con nadie. Esta notificación de seguridad forma parte de la relación contractual y no se puede dar de baja.',

  // ─── Transactional email — security-alert ────────────────────────────────
  'email.security-alert.subject': 'Alerta de seguridad: {{event}}',
  'email.security-alert.title': 'Alerta de seguridad',
  'email.security-alert.preheader':
    'Alerta de seguridad: {{event}}. Si no fuiste tú, restablece tu contraseña ahora.',
  'email.security-alert.badge': 'Alerta de seguridad',
  'email.security-alert.hero': 'Algo cambió en<br>tu cuenta.',
  'email.security-alert.subhead':
    'Hola {{first_name}}, acabamos de detectar una acción relacionada con la seguridad: <strong style="color:#0B0F19;">{{event}}</strong>. Si fuiste tú, todo está bien y puedes ignorar este email.',
  'email.security-alert.detail.time_label': 'Hora (UTC)',
  'email.security-alert.detail.ip_label': 'Dirección IP',
  'email.security-alert.detail.browser_label': 'Navegador',
  'email.security-alert.warning.line':
    '<strong style="color:#881337;">¿No fuiste tú?</strong> Restablece tu contraseña inmediatamente y revisa tu actividad de cuenta.',
  'email.security-alert.cta.primary': 'Restablecer contraseña ahora',
  'email.security-alert.signoff.line':
    '¿Preguntas sobre seguridad de la cuenta? Simplemente responde a este email: leo cada mensaje.',
  'email.security-alert.footer.transactional':
    'Por motivos de seguridad este email contiene información sobre la acción. No la compartas con nadie. Esta notificación de seguridad forma parte de nuestros términos de servicio y no se puede dar de baja.',
  // LEA-295 bug-fix: see note in de.ts. Machine-translated, pending native review.
  'email.security-alert.event.password_reset': 'Contraseña restablecida',
  'email.security-alert.event.account_deletion_requested':
    'Eliminación de cuenta solicitada (período de gracia de 30 días)',
  'email.security-alert.event.password_changed': 'Contraseña cambiada',
  'email.security-alert.firstname_fallback': 'ahí',
  // ── Phase-Trigger-UI (Welle G66 i18n — Pricing-v2) ──
  'phase.creditOne': 'crédito',
  'phase.creditMany': 'créditos',
  'phase.retry': 'Reintentar',
  'phase.cancel': 'Cancelar',
  'phase.confirm': 'Confirmar',
  'phase.running': 'En curso …',
  'phase.btn.running': 'en curso …',
  'phase.unknownError': 'Error desconocido',
  'phase.errorLabel': 'Error:',
  'phase.gate.loadingConnect': 'Buscando contactos …',
  'phase.gate.loadingPitch': 'Generando insights completos …',
  'phase.gate.loadingHint':
    'Esto suele tardar entre 30 y 60 segundos. Puedes salir de la página: te avisaremos cuando esté listo.',
  'phase.gate.failConnect': 'La búsqueda falló',
  'phase.gate.failPitch': 'La generación de insights falló',
  'phase.gate.failHint': 'Inténtalo de nuevo: no se cobrará ningún crédito adicional.',
  'phase.connect.title': 'Desbloquear contactos y datos directos',
  'phase.connect.desc':
    'Investigamos hasta 3 responsables de decisión con email directo, teléfono directo y URL de LinkedIn. Se incluyen las fuentes (registro de auditoría RGPD).',
  'phase.connect.cta': 'Encontrar contactos',
  'phase.connect.runtime': 'Duración: ~30-60 segundos',
  'phase.pitch.title': 'Desbloquear insights completos y plan de captación',
  'phase.pitch.desc':
    'Plan de captación personalizado de 6 secciones: qué hace la empresa, por qué precisamente este lead, actualidad (eventos desencadenantes), referencias de clientes, ganchos para tu email de ventas.',
  'phase.pitch.cta': 'Generar insights completos',
  'phase.pitch.runtime': 'Duración: ~20-40 segundos',
  'phase.locked.confirmQuestion': 'Confirmar: ¿cobrar {credits} por "{action}"?',
  'phase.deepen.title': 'Profundizar en este lead',
  'phase.deepen.descConnectDone':
    'Los contactos están cargados. Ahora carga los insights completos para el plan de captación + el stack tecnológico.',
  'phase.deepen.descDefault':
    'Identificado. Carga contactos o ve directo a los insights completos: se factura por clic.',
  'phase.deepen.pricingError':
    'No se pudo cargar el catálogo de precios: se usan los precios estándar.',
  'phase.deepen.directPitch': 'Cargar insights completos directamente (sin contactos)',
  'phase.btn.connect': '+ Encontrar contactos ({credits})',
  'phase.btn.pitch': '+ Insights completos ({credits})',
  'phase.toast.connectLoading': 'Los contactos se están cargando.',
  'phase.toast.pitchLoading': 'Los insights completos se están cargando.',
  'phase.toast.noCredits': 'Sin créditos. Recarga o mejora tu plan.',
  'phase.toast.connectSoon':
    'La búsqueda de contactos llegará pronto: se desbloquea con la oleada F2.2.',
  'phase.toast.pitchSoon':
    'Los insights completos llegarán pronto: se desbloquean con la oleada F2.3.',
  'phase.toast.error': 'Error: {msg}',
  'phase.toast.unexpected': 'Error inesperado. Inténtalo de nuevo.',
  'phase.dialog.connectTitle': '¿Encontrar contactos?',
  'phase.dialog.pitchTitle': '¿Cargar insights completos?',
  'phase.dialog.connectDesc':
    'Investigamos a los responsables de decisión (email, teléfono, LinkedIn) de este lead. El resultado suele estar disponible en 1-2 minutos.',
  'phase.dialog.pitchDesc':
    'Generamos el plan de captación, el stack tecnológico, las frases clave y los campos Sparkle de este lead. El resultado suele estar disponible en 1-2 minutos.',
  'phase.dialog.close': 'Cerrar el diálogo',
  'phase.dialog.costNote':
    'Esta acción cuesta {credits}. Una vez gastado un crédito, no se reembolsa automáticamente.',
  'phase.dialog.confirmDeduct': 'Sí, cobrar {credits}',
  // ── LeadDetail Rest-Strings (Welle G66.2 i18n) ──
  'det.src.impressum': 'Aviso legal',
  'det.src.handelsregister': 'Registro mercantil',
  'det.src.subPage': 'Página del equipo',
  'det.src.dorkEnrich': 'Investigación web',
  'det.src.geminiGrounding': 'Investigación con IA',
  'det.confReason.deepResearchConfirmed': 'confirmado mediante investigación',
  'det.confReason.handelsregisterOnly': 'solo registro mercantil',
  'det.confReason.nameMatch': 'coincidencia de nombre',
  'det.confReason.multiSource': 'varias fuentes',
  'det.confReason.rankFallback': 'Ranking de discovery (investigación profunda omitida)',
  'det.confReason.rankFallbackLowConf':
    'Ranking de discovery (investigación profunda sin resultados)',
  'det.trust.authoritative': 'Verificado desde una fuente oficial (aviso legal/registro mercantil)',
  'det.trust.semiAuth': 'De la propia página de la empresa (p. ej. /team)',
  'det.trust.llm': 'Extraído por IA del contenido del sitio',
  'det.trust.derived': 'Derivado de otros datos (baja confianza)',
  'det.trust.sourceGeneric': 'Fuente: {source}',
  'det.trust.confidence': 'confianza',
  'det.pReject.duplicate': 'Duplicado',
  'det.pReject.duplicateHint':
    'La persona ya está en la lista o el nombre no coincide ("Werner Weber Kurt Richter")',
  'det.pReject.wrongRole': 'Rol incorrecto',
  'det.pReject.wrongRoleHint': 'La persona no tiene la autoridad de decisión que buscamos',
  'det.pReject.inactive': 'Ya no activo',
  'det.pReject.inactiveHint': 'La persona ha cambiado, se ha jubilado, etc.',
  'det.pReject.wrongData': 'Datos incorrectos',
  'det.pReject.wrongDataHint': 'Email/teléfono incorrecto o no localizable',
  'det.pReject.betterContact': 'Otra persona es mejor',
  'det.pReject.betterContactHint': 'Hay un contacto más adecuado en esta empresa',
  'det.pReject.private': 'No contactar',
  'det.pReject.privateHint': 'No quiero contactar a esta persona (sin aprendizaje)',
  'det.toast.personFeedbackRealOnly':
    'El feedback de personas solo está disponible para leads reales.',
  'det.toast.removeFailed': 'No se pudo eliminar: inténtalo de nuevo.',
  'det.toast.backendUnavailable': 'Backend no disponible: recarga la app.',
  'det.toast.planRegenerating': 'El plan de captación se está regenerando con el briefing actual …',
  'det.toast.phaseAlreadyRunning': '{phase} ya está en curso, un momento.',
  'det.available': 'disponible',
  'det.unavailable': 'no disponible',
  'det.primary': 'Principal',
  'det.sourcePrefix': 'Fuente:',
  'det.dataViaWebResearch': 'Datos mediante investigación web pública',
  'det.openLink': 'Abrir {label}',
  'det.openLinkedin': 'Abrir el perfil de LinkedIn de {name}',
  'det.openXing': 'Abrir el perfil de XING de {name}',
  // ── LeadsTable Rest-Strings (Welle G66.3 i18n) ──
  'lt.trigErr.noContacts': 'No pudimos identificar contactos. No se cobró ningún crédito.',
  'lt.trigErr.insufficientCredits': 'Créditos insuficientes. Recarga, por favor.',
  'lt.trigErr.phaseRunning': 'Esta fase ya está en curso: espera.',
  'lt.trigErr.phaseCompleted': 'Esta fase ya está completada.',
  'lt.trigErr.triggerFailed': 'Error al activar: {msg}',
  'lt.cta.findContacts': 'Encontrar contactos · 1 crédito',
  'lt.cta.createPlan': 'Crear plan de captación · 1 crédito',
  'lt.cta.openOutreach': 'Abrir mensaje de contacto',
  'lt.verifyStuck': 'La verificación está bloqueada: recarga la página e inténtalo de nuevo.',
  'lt.verifyFailed': 'Error al verificar los contactos.',
  'lt.planFailed': 'No se pudo crear el plan de adquisición.',
  'lt.softKeepAria': 'Posible: haz clic para más detalles',
  'lt.manual.toast.backendUnavailable': 'Backend no disponible: inténtalo más tarde.',
  'lt.manual.toast.added': '{name} añadido',
  'lt.manual.toast.alreadyExists': '{name} ya existe: la abro para ti.',
  'lt.manual.toast.switchProfile':
    'Quizá debas cambiar de audiencia: el lead podría estar en otra.',
  'lt.manual.toast.addFailed': 'No se pudo añadir.',
  'lt.manual.companyFallback': 'Empresa',
  // ── Dashboard Rest-Strings (Welle G66.4 i18n) ──
  'dash.cancel.requested': 'Cancelación solicitada: se aplicará en el próximo punto de control.',
  'dash.cancel.failed': 'Error al cancelar',
  'dash.cancel.titleNoRun': 'ID de ejecución aún no disponible',
  'dash.cancel.titleCancel': 'Cancelar la búsqueda',
  'dash.cancel.inFlight': 'Cancelando …',
  'dash.cancel.confirm': '¿Cancelar de verdad?',
  'dash.refreshing': 'Actualizando …',
  'dash.run.noCredits': 'Sin créditos: suscríbete, por favor.',
  'dash.run.startSub': 'Iniciar suscripción',
  'dash.sugg.region': 'Región:',
  'dash.sugg.contact': 'Contacto:',
  'dash.sugg.extra': 'Extra:',
  'dash.sugg.why': 'Por qué:',
  // ── Bestandskunden-Exclude (A1, 2026-06-02) ──
  'acct.exclude.title': 'Excluir clientes existentes',
  'acct.exclude.desc':
    'Añade los dominios que ya conoces (p. ej. tu exportación de CRM). Se filtran de los resultados de TODAS las búsquedas: un dominio por línea.',
  'acct.exclude.placeholder': 'empresa.es\nejemplo-sl.es\ncliente.com',
  'acct.exclude.count': '{n} dominios excluidos de todas las búsquedas',
  'acct.exclude.save': 'Guardar lista',
  'acct.exclude.saved': 'Lista de exclusión guardada ({n} dominios)',
  // ── Agent-Chat / Cockpit (LEA-435 Wave B) ──
  'agent.nav': 'Asistente',
  'agent.tab.chat': 'Chat',
  'agent.tab.workspace': 'Espacio de trabajo',
  'agent.boot': 'Un momento — tu asistente está arrancando …',
  'agent.thinking': 'Pensando …',
  'agent.turnError': 'Algo no ha funcionado — inténtalo de nuevo en un momento.',
  'agent.budgetExhausted':
    'El saldo de chat de tu cuenta se ha agotado por hoy. Mañana se restablece automáticamente: tus créditos y leads no se ven afectados.',
  'agent.artifact.eyebrow': 'Grupo objetivo',
  'agent.artifact.draftBadge': 'Borrador',
  'agent.artifact.createdBadge': 'Recién creado',
  'agent.artifact.industry': 'Sector',
  'agent.artifact.region': 'Región',
  'agent.artifact.size': 'Tamaño',
  'agent.artifact.exclusions': 'Exclusiones',
  'agent.artifact.any': 'cualquiera',
  'agent.bootError': 'El asistente no está disponible ahora mismo. Recarga la página.',
  'agent.empty.title': '{greeting}, ¿en qué puedo ayudarte?',
  'agent.greet.morning': 'Buenos días',
  'agent.greet.day': 'Hola',
  'agent.greet.evening': 'Buenas tardes',
  'agent.empty.sub':
    'Describe qué clientes buscas — yo construyo la búsqueda, pido tu aprobación y revisamos los resultados juntos.',
  'agent.starter.find': 'Busco nuevos clientes — ayúdame a definir mi público objetivo',
  'agent.starter.describe': 'Analiza mi web y propón públicos objetivos adecuados',
  'agent.starter.review': 'Muéstrame mis últimos leads y revisémoslos',
  'agent.composer.placeholder': 'Mensaje a tu asistente …',
  'agent.composer.send': 'Enviar',
  'agent.composer.stop': 'Detener',
  'agent.composer.hint': 'Enter para enviar · Shift+Enter para una nueva línea',
  'agent.scroll.end': 'Ir al final',
  'agent.confirm.title': 'Aprobación: {action}',
  'agent.confirm.approve': 'Aprobar',
  'agent.confirm.deny': 'Rechazar',
  'agent.tool.analyze': 'Analizar web',
  'agent.tool.analyzeReference': 'Ver web de referencia',
  'agent.tool.draft': 'Borrador de público',
  'agent.tool.createProfile': 'Crear perfil',
  'agent.tool.startRun': 'Iniciar búsqueda',
  'agent.tool.runStatus': 'Estado de búsqueda',
  'agent.tool.listLeads': 'Cargar leads',
  'agent.tool.getLead': 'Detalles del lead',
  'agent.tool.connect': 'Buscar contactos',
  'agent.tool.pitch': 'Crear plan de contacto',
  'agent.tool.feedback': 'Registrar feedback',
  'agent.tool.credits': 'Saldo de créditos',
  'agent.tool.exclude': 'Excluir empresas',
  'agent.tool.cancelApproval': 'Retirar la aprobación',
  'agent.tool.cancelPlan': 'Detener el plan de búsqueda',
  'agent.support.open': 'Soporte',
  'agent.support.title': 'Abrir el chat de soporte — te responde una persona',
  'agent.ws.title': 'Tus públicos',
  'agent.ws.new': 'Nuevo',
  'agent.ws.empty': 'Aquí aparecerán los perfiles que creemos juntos en el chat.',
  'agent.ws.openLeads': 'Ver leads',
  // Kopieren / Umbenennen / Datei-Anhang (LEA-435 Usability-Welle)
  'agent.msg.copy': 'Copiar',
  'agent.msg.copied': 'Copiado',
  'agent.sessions.rename': 'Doble clic para renombrar',
  'agent.composer.attach': 'Adjuntar lista de clientes (CSV/XLSX)',
  'agent.attach.none': 'No se detectaron dominios de empresas en el archivo.',
  'agent.attach.xlsxFailed': 'No se pudo leer el archivo de Excel. Prueba con un archivo CSV.',
  'agent.attach.saved':
    'He subido mi lista de clientes: {n} dominios de empresas quedan excluidos de todas las búsquedas futuras (p. ej. {examples}).',
  'agent.attach.saveFailed':
    'He subido mi lista de clientes ({n} dominios de empresas), pero no se pudo guardar como lista de exclusión.',
  // Session-Verlauf + Relativzeit (LEA-435 Multi-Session)
  'agent.sessions.new': 'Nuevo chat',
  'agent.sessions.empty': 'Aún no hay conversaciones.',
  'agent.sessions.untitled': 'Nueva conversación',
  'agent.sessions.delete': 'Eliminar',
  // LEA-448
  'agent.sessions.deleteConfirm': '¿Eliminar esta conversación? No se puede deshacer.',
  'agent.artifact.radius': '{n} km de radio',
  'agent.leads.companyContactHint':
    'Contacto de empresa del aviso legal, no una persona de contacto.',
  'agent.run.stalled': 'Está tardando más de lo habitual…',
  'agent.run.interrupted': '{n} empresas entregadas — búsqueda finalizada antes de tiempo',
  'agent.run.qualifierDown':
    'Nuestra etapa de calificación no estuvo disponible por un momento — fue cosa nuestra, no de tus criterios. Merece la pena lanzar una nueva búsqueda.',
  'agent.run.recheck': 'Comprobar de nuevo',
  // LEA-448 round-4
  'agent.cost.startRun':
    'hasta {n} créditos — solo cuentan las empresas realmente entregadas; las descartadas nunca se cobran',
  'agent.cost.startRunRescue':
    'segundo intento tras un resultado escaso: no cuenta como otra búsqueda; como siempre, solo se cobran las empresas entregadas (hasta {n} créditos)',
  'agent.cost.connect':
    '{n} crédito — personas de contacto (nombre, cargo, correo, teléfono) de esta empresa a partir de fuentes públicas',
  'agent.cost.pitch':
    '{n} crédito — plan de captación (investigación + primer mensaje listo para enviar) para esta empresa',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'agent.cost.startRunReveal':
    'gratis — buscar no cuesta nada, solo pagas al desbloquear a una persona de contacto',
  'agent.cost.scheduleReveal':
    'gratis — cada búsqueda · {cadence} · se pausa sola tras {k} búsquedas seguidas sin empresas nuevas o si tu saldo está vacío · puedes detenerla en cualquier momento',
  'agent.cost.connectReveal':
    'gratis — las personas de contacto se investigan y se ven al desbloquearlas',
  'agent.cost.pitchReveal': 'gratis — el plan de captación está incluido en el desbloqueo',
  'agent.cost.startRunPlan':
    '{runs} búsquedas una tras otra, hasta {per} créditos cada una — hasta {n} créditos en total para hasta {leads} empresas; solo cuentan las empresas realmente entregadas y el plan se detiene tras un resultado escaso',
  'agent.cost.connectBatch':
    'hasta {n} créditos — personas de contacto (nombre, cargo, correo, teléfono) de {count} empresas a partir de fuentes públicas; una empresa sin contacto localizable no se cobra',
  'agent.cost.pitchBatch':
    'hasta {n} créditos — planes de captación (investigación + primer mensaje listo para enviar) para {count} empresas',
  'agent.sessions.history': 'Historial',
  'agent.sessions.close': 'Cerrar',
  'agent.time.now': 'ahora mismo',
  'agent.time.min': 'hace {n} min',
  'agent.time.hour': 'hace {n} h',
  'agent.time.day': 'hace {n} d',
  // ── Live-Fortschrittskarte (LEA-435) ──
  'agent.run.running': 'Búsqueda en curso',
  'agent.run.finalizing': 'Ultimando — casi listo …',
  'agent.run.preparing': 'Preparando búsqueda …',
  'agent.run.done': 'Búsqueda completada',
  'agent.run.failed': 'Búsqueda fallida',
  'agent.run.cancelled': 'Búsqueda cancelada',
  'agent.run.delivered': '{n} / {total} empresas entregadas',
  'agent.run.reviewCta': 'Revisar leads',
  'agent.run.dismiss': 'Ocultar',
  'agent.run.step.planning': 'Planificación',
  'agent.run.step.discovery': 'Descubrimiento',
  'agent.run.step.hydration': 'Enriquecimiento',
  'agent.run.step.reasoning': 'Evaluación',
  'agent.run.step.delivery': 'Entrega',
  'agent.run.won': '¡{n} leads frescos para ti!',
  'agent.run.empty': 'No se han encontrado empresas que encajen',
  'agent.rescue.head.zero': 'Esta búsqueda no ha encontrado empresas que encajen.',
  'agent.rescue.head.lowOne':
    'Esta búsqueda solo ha encontrado 1 empresa que encaja; ya puedes echarle un vistazo.',
  'agent.rescue.head.low':
    'Esta búsqueda solo ha encontrado {n} empresas que encajan; ya puedes echarles un vistazo.',
  'agent.rescue.cause.ours':
    'Ha sido cosa nuestra, no de tu público objetivo: la búsqueda no se ha completado correctamente por un problema técnico.',
  'agent.rescue.cause.oursQualifier':
    'Ha sido cosa nuestra, no de tu público objetivo: nuestra etapa de verificación no estaba disponible durante la búsqueda, así que las empresas encontradas no se llegaron a evaluar.',
  'agent.rescue.cause.fewFound':
    'En la zona de búsqueda ({area}) solo hemos encontrado unas pocas empresas que encajan con tu descripción. Eso dice más de nuestro alcance allí que de tu mercado.',
  'agent.rescue.cause.harvested':
    'Las empresas que hemos encontrado ya las conoces: te las entregamos en búsquedas anteriores o están en tu lista de empresas conocidas.',
  'agent.rescue.cause.harvestedLow':
    'Las demás empresas que hemos encontrado ya las conoces: te las entregamos en búsquedas anteriores o están en tu lista de empresas conocidas.',
  'agent.rescue.cause.tooBroad':
    'Tu público objetivo no menciona ningún sector concreto. Sin sector, la búsqueda no sabe qué empresas revisar.',
  'agent.rescue.cause.filtered':
    'Hemos encontrado empresas, pero ninguna cumplía tus criterios (sector, tamaño o región).',
  'agent.rescue.cause.filteredLow':
    'Las demás empresas que hemos encontrado no cumplían tus criterios (sector, tamaño o región).',
  'agent.rescue.cause.unknown': 'No hemos podido determinar con seguridad el motivo.',
  'agent.rescue.freeRule':
    'Las búsquedas fallidas nunca cuestan nada: sin empresas entregadas no se cobra nada. Y el nuevo intento no cuenta como otra búsqueda.',
  'agent.rescue.pick': 'Mi propuesta: con un clic empieza la nueva búsqueda:',
  'agent.rescue.noOption.tooBroad':
    'Dime un sector o un oficio concreto y afinamos juntos el público objetivo.',
  'agent.rescue.noOption.wide':
    'La zona de búsqueda ya es tan amplia como tiene sentido: otro intento con los mismos criterios probablemente no aportaría nada nuevo.',
  'agent.rescue.thin.zero':
    'El segundo intento tampoco ha encontrado empresas que encajen. Eso indica que para esta combinación hay muy pocas empresas localizables públicamente; otro intento con los mismos criterios no cambiaría nada.',
  'agent.rescue.thin.low':
    'El segundo intento tampoco ha encontrado apenas empresas que encajen ({n} entregadas). Eso indica que para esta combinación hay pocas empresas localizables públicamente; otro intento con los mismos criterios no cambiaría nada.',
  'agent.rescue.thin.next':
    'Tiene más sentido otro enfoque: por ejemplo, un sector afín u otra región.',
  'agent.rescue.opt.same': 'Repetir la misma búsqueda',
  'agent.rescue.opt.widen': 'Ampliar la zona: {area} (en lugar de solo {from})',
  'agent.rescue.opt.dach': 'Ampliar la zona: Alemania, Austria y Suiza',
  'agent.rescue.opt.dachFrom':
    'Ampliar la zona: Alemania, Austria y Suiza (en lugar de solo {from})',
  'agent.rescue.opt.industry': 'Buscar de nuevo con el sector «{industry}»',
  'agent.rescue.chip.market': 'Probemos «{market}» como público objetivo',
  'agent.rescue.chip.rethink': 'Ayúdame a replantear el público objetivo',
  'agent.rescue.unavailable': 'Este segundo intento ya no está disponible',
  'agent.rescue.card.note':
    'No cuenta como otra búsqueda; como siempre, solo se cobran las empresas entregadas',
  'agent.rescue.card.noteFree': 'Segundo intento gratuito: no cuenta como otra búsqueda',
  'agent.rescue.oursRetryLater':
    'Vuelve a intentarlo en unos minutos: las empresas no entregadas nunca se cobran.',
  'agent.rescue.card.used': 'Iniciada',
  'agent.rescue.card.aria': 'Propuestas para un segundo intento',
  'agent.rescue.preparing': 'Estoy mirando qué ha fallado …',
  // ── Momentum-Leiste (LEA-435) ──
  'agent.momentum.label': 'Tu racha',
  'agent.momentum.audiences': 'Audiencias',
  'agent.momentum.searches': 'Búsquedas',
  'agent.momentum.leads': 'Leads',
  'agent.momentum.contacts': 'Contactos',
  'agent.momentum.pitches': 'Outreach',
  // ── Lead-Bewert-Deck (LEA-435) ──
  'agent.leads.title': 'Tus leads — ¿cuáles encajan?',
  'agent.leads.rated': '{done}/{total} evaluados',
  'agent.leads.accept': 'Encaja',
  'agent.leads.reject': 'No encaja',
  'agent.leads.accepted': 'Encaja',
  'agent.leads.rejected': 'No encaja',
  'agent.leads.contacts': '{n} contactos',
  'agent.leads.openAll': 'Ver todos en detalle',
  'agent.leads.done': 'Genial — ¡todos evaluados! Eso afina tu próxima búsqueda.',
  'agent.leads.chainConnect': '→ Encontrar los decisores para tus resultados ({n})',
  'agent.leads.chainMsg': 'Encuentra los contactos para: {names}. (leadIds: {ids})',
  // ── Erfolgs-Puls (LEA-435) ──
  'agent.pulse.hitRate': 'Tasa de acierto {pct}%',
  'agent.pulse.rising': 'sube',
  'agent.pulse.detail': '{accepted} de {rated} leads encajan · {profiles} audiencias',
  'agent.pulse.nudge':
    'Valora tus leads con 👍/👎 — así aprendo tu tasa de acierto y mejoro con cada búsqueda.',
  // ── Aktions-Chips (LEA-435) ──
  'agent.chip.confirmDraft': 'Sí, créalo así',
  'agent.chip.adjustDraft': 'Ajustar segmentación',
  'agent.chip.startRun': 'Iniciar búsqueda',
  'agent.chip.reviewLeads': 'Revisar leads',
  'agent.chip.msg.confirmDraft': 'Sí, crea el perfil exactamente así.',
  'agent.chip.msg.adjustDraft': 'Quiero ajustar el público objetivo.',
  'agent.chip.msg.startRun': 'Inicia ahora la búsqueda para este perfil.',
  'agent.chip.msg.startRunNamed': 'Inicia ahora la búsqueda para el público «{name}».',
  'agent.chip.msg.reviewLeads': 'Vamos a revisar los leads entregados.',
  // ── Editierbare Firmen-Karte (#122, 2026-06-02) ──
  'common.remove': 'Eliminar',
  'dash.cortex.editHint':
    'Elimina chips con × o añade los adecuados: así Leadscraper acierta mejor con tu oferta (máx. 8 por columna).',
  'dash.cortex.descLabel': 'Descripción',
  'dash.cortex.changeUrl': 'Analizar otro sitio web',
  'dash.cortex.editSaved': 'Perfil de empresa actualizado',
  'dash.cortex.addPlaceholder': 'añadir…',
  'dash.cortex.capReached': 'Máx. 8 alcanzado',
  'pd.target.edit': 'Redescribir',
  'pd.target.editHint':
    'Describe tus clientes ideales en 1–2 frases. Leadscraper deduce de nuevo sector, región y contacto.',
  'pd.target.editPlaceholder':
    'p.ej. fabricantes de embalajes, a nivel nacional, 50–250 empleados, dirección',
  'pd.target.reparsing': 'Leadscraper está pensando …',
  'pd.target.saved': 'Audiencia actualizada',
  'pd.target.saveError': 'No se pudo actualizar. Inténtalo de nuevo.',
  // W21/W22 Dossier — página de audiencia como dosier autoescrito
  // (traspaso de diseño Claude 2026-07-03). Superficie 1: tarjeta del dosier.
  'dos.eyebrow': 'Tu audiencia objetivo · escrita por ti y por Leadscraper',
  'dos.maturity.coldStart': 'Aprendiendo a conocerte',
  'dos.maturity.early': 'Primer boceto',
  'dos.maturity.calibrated': 'Calibrado',
  'dos.maturity.mature': 'Maduro',
  'dos.ratings': '{n} evaluaciones',
  'dos.matchRate': '{pct} % de acierto',
  'dos.weak': 'débil',
  'dos.edit.cta': 'Editar audiencia objetivo',
  'dos.weave.youSearch': 'Buscas',
  'dos.weave.vorgabeLabel': 'Tu dato · de tu briefing',
  'dos.weave.withSize': 'con {size} empleados',
  'dos.weave.sizeValue': '{range} empleados',
  'dos.weave.inRegion': 'en {region}',
  'dos.weave.contact': 'persona de contacto',
  'dos.weave.prefers': 'con preferencia por',
  'dos.weave.and': 'y',
  'dos.weave.weakHint': 'primer indicio:',
  'dos.legend.you': 'tu dato',
  'dos.legend.learned': 'aprendido, el número = evidencias, es clicable',
  'dos.legend.weak': 'débil (1–2 evidencias)',
  'dos.emptyLearned':
    'Todavía no hay nada aprendido. Evalúa tus primeros leads abajo y este dosier empezará a escribirse solo.',
  'dos.heartbeat.active': 'Aprendiendo activamente',
  'dos.heartbeat.waiting': 'Esperando tus primeras evaluaciones',
  'dos.heartbeat.since': 'desde {date}',
  'dos.heartbeat.next': 'próximo análisis a las {n} evaluaciones',
  'dos.proof.title': 'Tus {n} empresas aceptadas',
  'dos.proof.openAll': 'Ver todos en el board',
  'dos.error.learn': 'Los datos de aprendizaje no están disponibles ahora mismo.',
  'dos.error.retry': 'Reintentar',
  'dos.details.show': 'Los {n} patrones en detalle ↓',
  'dos.details.hide': 'Ocultar detalles',
  'dos.aside.patterns': 'Patrones en detalle',
  'dos.kpi.title': 'Tu audiencia en cifras',
  'dos.kpi.match': 'Aciertos',
  'dos.kpi.reachable': 'Contactables',
  'dos.kpi.reachableSub': '{n} de {m} solicitudes',
  'dos.kpi.reachableTeaser': 'Tras la primera solicitud de contacto',
  'dos.kpi.yield': 'Por búsqueda',
  'dos.kpi.yieldSub': '{n} búsquedas',
  'dos.kpi.matchTeaser': 'desde {p} valoraciones',
  'dos.journey.eyebrow': 'Así se construye tu dossier',
  'dos.journey.s1': 'Audiencia descrita',
  'dos.journey.s1Sub': 'Bien registrada: Leadscraper sabe qué buscar.',
  'dos.journey.s2': 'Recibe tus primeros leads',
  'dos.journey.s2Sub': 'Inicia tu primera búsqueda: las primeras empresas llegan en minutos.',
  'dos.journey.s2Done': '{n} leads listos.',
  'dos.journey.s2Running': 'Tu búsqueda está en marcha: las primeras empresas llegarán en breve.',
  'dos.journey.s2RunningBadge': 'Búsqueda en curso · normalmente 5–12 min',
  'dos.journey.s3': 'Valora los primeros {p} leads',
  'dos.journey.s3Progress': '{n} de {p} leads valorados',
  'dos.journey.s3Sub':
    'Con {p} valoraciones Leadscraper escribe aquí su primera evaluación; a partir de {a}, tu feedback guía cada búsqueda.',
  'dos.voice.preview':
    'Tras tus primeras {p} valoraciones, Leadscraper escribirá aquí su evaluación de tu audiencia.',
  'dos.voice.more': 'Leer más',
  'dos.voice.less': 'Mostrar menos',
  'dos.analysis.pending':
    'Leadscraper está analizando tus {n} valoraciones: la primera evaluación aparecerá aquí en breve.',
  'dos.heartbeat.analysing': 'Analizando tus valoraciones …',
  // Dosier — popover de evidencias
  'dos.popover.close': 'Cerrar',
  'dos.popover.evidence': '{n} evidencias',
  'dos.popover.weakChip': 'débil · {n} evidencias',
  'dos.popover.view': 'ver ↗',
  'dos.popover.noExamples':
    'Para este patrón no hay leads de evidencia guardados individualmente: el número cuenta tus evaluaciones.',
  'dos.popover.weakNote': 'Solo {n} evidencias, todavía influye con cautela en la búsqueda.',
  // Dosier — superficie 2: evaluar ahora
  'dos.rate.eyebrow': 'Evaluar ahora',
  'dos.rate.waiting': '{n} leads esperan tu veredicto',
  'dos.rate.waitingOne': '1 lead espera tu veredicto',
  'dos.rate.openBoard': 'Abrir todos en el tablero →',
  'dos.rate.sub': 'Cada evaluación afina el dosier, aquí mismo, sin salir de la página.',
  'dos.rate.fits': 'Encaja con mi audiencia objetivo',
  'dos.rate.fitsNot': 'No encaja',
  'dos.rate.view': 'ver',
  'dos.rate.acceptedCheck': '✓ Aceptado',
  'dos.rate.learned': ', el dosier ha aprendido:',
  'dos.rate.flowsIn': ', se incorpora al próximo análisis.',
  'dos.rate.undo': 'Deshacer',
  'dos.rate.whyQuestion': '¿Qué falló? Con un toque basta: Leadscraper aprende de ello.',
  'dos.rate.noReason': 'Continuar sin motivo',
  'dos.rate.allDone':
    'Todo evaluado: aparecerán nuevos leads aquí en cuanto una búsqueda entregue resultados.',
  'dos.rate.rejectedCheck': '✗ Descartado',
  'dos.rate.avoidedLearned': ', el dossier ahora evita:',
  'dos.reason.industry': 'Industria incorrecta',
  'dos.reason.tooBig': 'Demasiado grande',
  'dos.reason.tooSmall': 'Demasiado pequeña',
  'dos.reason.region': 'Región incorrecta',
  'dos.reason.role': 'Rol incorrecto',
  'dos.reason.other': 'Otro motivo',
  // Dosier — superficie 3: próximas búsquedas
  'dos.sug.eyebrow': 'Derivado de tus patrones',
  'dos.sug.title': 'Tus próximas búsquedas',
  'dos.sug.basis.expansion': 'Ampliación',
  'dos.sug.basis.crossSell': 'Venta cruzada',
  'dos.sug.basis.zoomOut': 'Zoom-out',
  'dos.sug.basis.patternHint': 'Indicio de patrón',
  'dos.sug.basis.salesFit': 'Encaje de venta',
  'dos.sug.tier.veryStrong': 'muy fuerte',
  'dos.sug.tier.strong': 'fuerte',
  'dos.sug.tier.solid': 'sólido',
  'dos.sug.tier.hypothesis': 'débil',
  'dos.sug.fitLabel': 'encaje esperado',
  'dos.sug.start': 'Iniciar búsqueda',
  'dos.sug.history': '{n} búsquedas anteriores',
  'dos.sug.historyOne': '1 búsqueda anterior',
  'dos.sug.showHistory': 'Ver historial →',
  'common.close': 'Cerrar',
  'common.selected': 'Seleccionado',
  'credit.balanceTitle': 'Tu saldo de créditos',
  'credit.available': 'disponibles',
  'det.trigger.cat.serviceRadius': 'Zona de servicio',
  'det.trigger.cat.specialization': 'Especialización',
  'det.trigger.cat.capacity': 'Capacidad',
  'det.trigger.cat.history': 'Historial',
  'det.trigger.cat.partnership': 'Asociación',
  'det.trigger.cat.certification': 'Certificación',
  'det.trigger.cat.other': 'Otros',
  'lead.removeContactTitle': '¿Por qué eliminar?',
  'lead.actionNeedPlan': 'Genera primero un plan de adquisición',
  'lead.actionNoEmail': 'Sin correo electrónico para el contacto priorizado',
  // scraper run experience + API errors (LEA-302) — see de.ts for context
  'scraper.act.loadProfile': 'Cargando tu perfil + valoraciones anteriores …',
  'scraper.act.firstFeedbacks':
    'Recopilando primeras valoraciones: a partir de 10 Cortex aprende tus patrones de aceptación/rechazo.',
  'scraper.act.feedbacksCollected':
    '{seen} valoraciones recopiladas: la personalización se activará a partir de {activeAt} valoraciones por perfil. Esta búsqueda aún funciona sin anulación de patrones.',
  'scraper.act.patternsActive':
    '{seen} valoraciones · {accepted} patrones de aceptación · {rejected} patrones de rechazo activos en el razonamiento',
  'scraper.act.planning':
    'Planificando estrategia de búsqueda: ¿qué fuentes de búsqueda + consultas cubren mejor tu solicitud?',
  'scraper.act.aiSearchTempError':
    'La búsqueda IA tuvo un problema temporal (red/timeout). Por favor, inténtalo de nuevo.',
  'scraper.act.aiSearchUnavailable':
    'Búsqueda IA no disponible actualmente (problema de configuración). Contacta con soporte.',
  'scraper.act.aiSearchBadFormat':
    'La búsqueda IA devolvió un formato inválido. Por favor, inténtalo de nuevo.',
  'scraper.act.aiSearchFailed': 'Búsqueda IA falló ({reason}). Por favor, inténtalo de nuevo.',
  'scraper.act.reasonUnknown': 'desconocido',
  'scraper.act.researcherAnalyzing': 'El investigador de IA está analizando tu búsqueda…',
  'scraper.act.researcherFound': 'Investigador de IA: {n} empresas verificadas identificadas',
  'scraper.act.goal': 'Objetivo: {goal}',
  'scraper.act.strategy': 'Estrategia: {strategy}',
  'scraper.act.reasoning': 'Razonamiento: {reasoning}',
  'scraper.act.srcCurated': '⭐ Fuente curada',
  'scraper.act.srcOwn': '💡 Propuesta propia',
  'scraper.act.srcKindRegister': 'Registro',
  'scraper.act.srcKindDirectory': 'Directorio',
  'scraper.act.srcKindPortal': 'Portal',
  'scraper.act.source': '{tag}: {label} [{kind}]',
  'scraper.act.googleSearch': 'Google-Suche: „{q}"',
  'scraper.act.googleMaps': 'Google Maps: „{q}"{location}',
  'scraper.act.googleNews': 'Google News: „{q}"',
  'scraper.act.researcherEnough':
    'El AI-Researcher es suficiente ({n} empresas), omitiendo búsquedas adicionales en Google',
  'scraper.act.researcherIdentified':
    'El AI-Researcher identificó {n} empresas, omitiendo búsquedas en Google',
  'scraper.act.researcherNone':
    'El AI-Researcher no encontró empresas que coincidan: la consulta de búsqueda es muy específica. Intenta con un perfil más amplio o una región menos específica.',
  'scraper.act.companyIdentified': 'Empresa identificada: {name} ({i}/{total})',
  'scraper.act.enrichBasics':
    'Enriqueciendo {n} empresas con datos básicos (dirección, tamaño, stack tecnológico)...',
  'scraper.act.enrichCompany': 'Reichere Firma {idx}/{total} an: {domain}',
  'scraper.act.phase1Light':
    'Phase-1-Light: {n} Firmen identifiziert in {secs}s. Adresse/Größe/Details werden bei Bedarf nachgescraped.',
  'scraper.act.serperExhausted':
    '⚠ Serper-Credits aufgebraucht, Discovery limited. Auf serper.dev/dashboard nachladen.',
  'scraper.act.mapsHits': '{n} Maps-Treffer für „{query}"',
  'scraper.act.searchHitsCollected': '{n} Treffer aus Google-Suche eingesammelt',
  'scraper.act.directoriesFound':
    '{n} directorios de industria encontrados, extrayendo empresas listadas …',
  'scraper.act.searchingPortal': 'Buscando en {host} empresas listadas …',
  'scraper.act.minedCompanies': '{n} empresas extraídas de {portal}',
  'scraper.act.onlyPortals':
    'No se identificaron empresas operativas: todos los resultados eran portales',
  'scraper.act.queryInfeasible': 'Cortex considera que la consulta no es viable: {reason}',
  'scraper.act.rethinking': 'Cortex está reconsiderando (Ronda {round}): {reason}',
  'scraper.act.searchingPortalNew': 'Buscando en {host} (nuevo paso del plan) …',
  'scraper.act.minedPortalRound': '{n} empresas de {host} (Ronda Reflector {round})',
  'scraper.act.backlogResumed': '{n} candidatos del backlog de ejecuciones anteriores reanudados',
  'scraper.act.companiesIdentifiedAgg':
    '{n} empresas identificadas ({rescued}/{attempted} rescatadas de portales agregadores), iniciando análisis profundo',
  'scraper.act.companiesIdentified': '{n} empresas identificadas, iniciando análisis profundo',
  'scraper.act.handelsregisterChecked': 'Registro mercantil verificado: {hrb}',
  'scraper.act.scanningWebsite': 'Analizando sitio web: {domain}',
  'scraper.act.relatedPages': '{n} páginas adicionales analizadas: {domain}',
  'scraper.act.deepAnalysis': 'Análisis empresarial profundo: {name}',
  'scraper.act.pipelineStarted':
    'Pipeline iniciado, {n} candidatos pasan en paralelo por hidratación + evaluación',
  'scraper.act.allDroppedPrefilter':
    'Todas las {n} empresas encontradas fueron descartadas como no adecuadas (sector/región). Precisa tu audiencia objetivo o prueba otra región.',
  'scraper.act.noCompaniesFound':
    'Discovery no encontró empresas para esta búsqueda. Precisa tu audiencia objetivo.',
  'scraper.act.phase1OnlyRun':
    'Ejecución solo fase 1: {n} Leads identificados. Fases 2 + 3 fueron omitidas.',
  'scraper.act.leadsDeliveredEnriching':
    '{n} Leads entregados, Cortex aún enriqueciendo (plan de adquisición, puntuaciones, investigación profunda)',
  'scraper.act.deeperResearch':
    'Investigación más profunda: {name}, {findings} de {sources} fuentes',
  'scraper.act.coldStart': 'Cold-Start (sin ejecuciones previas)',
  'scraper.act.runHistory':
    '{runs} ejecuciones previas · {delivered} ya entregados · {dropped} ya descartados',
  'scraper.act.buyerProfile': 'Perfil del comprador: {narrative} (Confianza: {confidence})',
  'scraper.act.confHigh': 'alta',
  'scraper.act.confMid': 'media',
  'scraper.act.confLow': 'baja',
  'scraper.act.subsidiary':
    'Filial DACH detectada: {domain} ({src}), se utilizará para búsqueda de contactos.',
  'scraper.act.subsidiarySrcDirect': 'verificado directamente',
  'scraper.act.subsidiarySrcGoogle': 'vía investigación Google',
  'scraper.rq.harvestedMsg':
    'Audiencia objetivo agotada por ahora: búsquedas anteriores ya han entregado {prior} empresas adecuadas.',
  'scraper.rq.harvestedRec':
    'Cortex ya ha encontrado las empresas conocidas. Nuevos resultados surgirán cuando nuevas empresas de tu audiencia objetivo se vuelvan visibles online. El Schedule las detectará automáticamente.',
  'scraper.rq.noMarketMsg':
    'Solo {n} empresas encontradas en toda la web para la búsqueda. Esta audiencia objetivo parece no ser encontrable públicamente: quizás demasiado específica o datos empresariales internos.',
  'scraper.rq.noMarketRec':
    'Intenta formular de manera más amplia o combina con sectores look-alike. Schedule no vale la pena para esta consulta.',
  'scraper.rq.tooNicheMsg':
    'Solo {n} empresas potenciales en el mercado: tu audiencia objetivo es muy nicho.',
  'scraper.rq.tooNicheRec':
    'Schedule solo vale la pena para audiencias objetivo con 50+ empresas. Considera región más amplia o más variantes de sectores.',
  'scraper.rq.qualifierDownMsg':
    'La evaluación por IA no estuvo disponible durante esta búsqueda, así que las {n} empresas encontradas no pudieron valorarse: es un problema técnico nuestro, no un veredicto sobre tu mercado.',
  'scraper.rq.qualifierDownRec':
    'Vuelve a lanzar la búsqueda en unos minutos. No hace falta cambiar tus criterios: esta vez no se evaluó ni una sola empresa.',
  'scraper.rq.unmatchedMsg':
    '{n} empresas analizadas: ninguna correspondió a tus criterios (sector, tamaño, región).',
  'scraper.rq.unmatchedRec':
    'Revisar descripción: ¿criterios demasiado estrictos? La aceptación look-alike no ayuda porque ningún look-alike era plausible.',
  'scraper.sum.delivered':
    '{n} Leads entregados ({hard} seguros{softFrag}) de {total} empresas analizadas.',
  'scraper.sum.softFragment': ', {soft} posiblemente relevantes',
  'scraper.sum.deliveredNiche':
    '{n}/10 Leads entregados: la audiencia objetivo es nicho (solo {total} empresas identificadas en el mercado).',
  'scraper.sum.nicheRec':
    'Normal en Schedule recurrente. Nuevos resultados surgen con el tiempo. Si necesitas más volumen: considera región más amplia o sectores relacionados.',
  'scraper.sum.deliveredDropped':
    '{n}/10 Leads entregados: Cortex ha descartado {dropped} candidatos adicionales como no adecuados.',
  'scraper.sum.droppedRec':
    'Si quieres más volumen: formula la descripción de manera más flexible o acepta look-alikes/Soft-Keeps.',
  'scraper.sum.deliveredMixed': '{n}/10 Leads entregados: rendimiento mixto de {total} empresas.',
  'scraper.sum.mixedRec':
    'Normal en Schedule recurrente. Cortex recopila resultados adicionales con el tiempo.',
  'scraper.sum.noneMatched': '{total} empresas analizadas: ninguna correspondió a tus criterios.',
  'scraper.sum.noneMatchedRec':
    'Revisar descripción: criterios demasiado estrictos o probar otra región.',
  'scraper.mem.active': 'Activamente personalizado · {n} evaluaciones',
  'scraper.mem.analyzing': 'Siendo reanalizado · {n} evaluaciones',
  'scraper.mem.firstImpression': 'Primera impresión · {n}/{active} hasta activo',
  'scraper.mem.learning': 'Aprendiendo contigo · {n}/{preview} hasta vista previa',
  'scraper.reflector.fallback':
    'Reflector no disponible: consulta reportada como no viable para que el usuario no espere indefinidamente.',
  // LEA-543: Zielgruppe sind Privatpersonen — Leadscraper findet nur Unternehmen.
  // Server-seitig lokalisiert via tForLang, zusammen unter 240 Zeichen (die
  // Fehler-Antwort wird im Client bei 300 Zeichen abgeschnitten).
  'apierr.b2cOnly':
    'Leadscraper encuentra empresas y a las personas que deciden dentro de ellas — no proporcionamos particulares.',
  'apierr.b2cPivot': 'Una alternativa viable: {pivot}',
  'apierr.junkQuery':
    'Por favor describe específicamente A QUIÉN buscas: ej. "Panaderías en Madrid" o "Asesores fiscales Cataluña 5-50 empleados". Términos genéricos como "B2B", "Test", "Perfil" o textos con errores no son aceptados.',
  'apierr.invalidWebsite': 'Por favor ingresa un sitio web válido (ej. mi-empresa.es)',
  'apierr.noUserCompanyStep1': 'Primero analiza el sitio web (Paso 1).',
  'apierr.noUserCompany': 'Primero analiza el sitio web.',
  'apierr.insufficientPhase': 'Necesitas {cost} Credit(s) para esta fase. Actual: {credits}.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'apierr.pitchRequiresReveal':
    'Primero desbloquea los contactos de esta empresa — el plan de captación está incluido.',
  'apierr.planGenFailed':
    'No se pudo generar el plan de prospección. No se consumió ningún Credit.',
  'apierr.urlParse': 'No se pudo analizar la URL.',
  'apierr.urlIncomplete': 'Por favor proporciona una URL completa.',
  'apierr.dupCompany': 'Ya has creado esta empresa{nameSuffix}.',
  'apierr.dupCompanySuffix': ' ({name})',
  'apierr.manualUnreachable':
    'El sitio web no estaba disponible durante la creación: no se pudieron obtener los datos.',
  'apierr.manualPhase1Failed':
    'Fase 1 falló (sitio web no disponible). Intenta nuevamente con "Actualizar datos".',
  'apierr.cancelRequested': 'Cancelación solicitada. Se aplicará en el siguiente checkpoint.',
  'apierr.noCredits': 'No hay Credits disponibles. Por favor suscríbete o compra más Credits.',
  'apierr.rescueNotAvailable':
    'El segundo intento gratuito para esta búsqueda no está disponible (o ya no lo está).',
  'apierr.intentParse':
    'No pude extraer una industria específica de tu descripción "{desc}". Por favor sé más específico: ej. en lugar de "Madrid" → "Panaderías en Madrid" o "Asesores fiscales en Madrid".',
  // i18n localization batch (LeadDetail / acquisition plan)
  'det.acquisitionPlan': 'Plan de adquisición',
  'det.creatingPlan': 'Cortex está creando tu plan de adquisición…',
  'det.planLoadTime':
    'Normalmente 30-60 segundos, no es necesario recargar, aparece automáticamente',
  'det.planUncertaintyWarning': 'Aviso: el texto del plan contiene incertidumbres',
  'det.companyClassification': 'Clasificación de la empresa',
  'det.opportunities': 'Oportunidades',
  'det.risksAndDealbreakers': 'Riesgos / factores excluyentes',
  'det.channelMix': 'Mezcla de canales · secuencia de 7 días',
  'ld.sparkle.sampleMessageLabel': 'Mensaje de ejemplo para el primer contacto',
  'ld.sparkle.sampleMessageCopied': 'Mensaje de ejemplo copiado.',
  'common.copy': 'copiar',
  'ld.sparkle.messageSubject': 'Asunto: ',
  'ld.lean.urteil': 'Por qué este lead',
  'ld.lean.winkel': 'Tu enfoque',
  'ld.lean.kontakte': 'A quién primero',
  'ld.lean.nachricht': 'Primer contacto, listo para enviar',
  'ld.lean.nachrichtShort': 'Borrador de primer contacto',
  'ld.lean.telefon': 'Apertura telefónica',
  'ld.lean.check': 'Antes de enviar',
  'ld.lean.copyAI': 'Copiar para IA',
  'ld.lean.copyAITitle':
    'Copia el plan, datos públicos de empresa y contactos y tu perfil de oferta como handover para ChatGPT, Claude y cía.',
  'ld.lean.copiedAI': 'Handover copiado: pégalo en tu herramienta de IA',
  'ld.lean.varMain': 'Recomendada',
  'ld.lean.sendMail': 'Enviar como email',
  'ld.lean.sendMailTitle': 'Abre tu programa de correo con {addr}, asunto y texto rellenados',
  'ld.lean.zentrale': 'Centralita',
  'ld.lean.nameNotPublic': 'nombre no público',
  'ld.lean.verifiziert': 'verificado',
  'ld.lean.chEmail': 'Email',
  'ld.lean.chTelefon': 'Teléfono',
  'ld.lean.chLinkedIn': 'LinkedIn',
  'ld.lean.chXing': 'Xing',
  'ld.ai.instructions':
    'Eres mi copiloto de ventas para este lead concreto. Abajo están todos los datos que mi herramienta (Leadscraper) investigó en fuentes públicas y preparó como plan de adquisición: úsalos directamente, no los pidas primero.\n\nMarcadores: ✓ = verificado públicamente (web, aviso legal, LinkedIn, registro), ~ = suposición sin fuente sólida. Mantén esta distinción y no inventes nada sobre la empresa ni la persona de contacto.\n\nPuedes ayudarme a refinar el mensaje de primer contacto, crear un guion de llamada, ensayar objeciones o preparar el seguimiento.',
  'ld.ai.secLead': 'Lead',
  'ld.ai.secData': 'Datos disponibles',
  'ld.ai.secContacts': 'Contactos',
  'ld.ai.secCompany': 'Mi empresa',
  'ld.ai.secPlan': 'Plan de adquisición',
  'ld.ai.secUncertain': 'Incertidumbres y verificar',
  'ld.ai.secTask': 'Qué necesito de ti',
  'ld.ai.taskBody':
    'Empieza ya: refina el mensaje de primer contacto de arriba con mi tono y propón UNA mejora concreta que aumente mi tasa de respuesta.',
  'ld.ai.company': 'Empresa',
  'ld.ai.industry': 'Sector',
  'ld.ai.size': 'Tamaño',
  'ld.ai.region': 'Región',
  'ld.ai.dataAsOf': 'Datos a fecha: investigado el {date}',
  'det.recommendedNextStep': 'Siguiente paso recomendado',
  'det.botProtectionWarning':
    'Este sitio web tenía protección anti-bots activa: no pudimos rastrear directamente la página de aviso legal/contacto. Los datos que se muestran aquí los recopilamos de fuentes públicas (Google, directorios sectoriales) y pueden ser menos precisos que los datos directos del aviso legal.',
  'det.possibleNotVerified': 'Posible: no verificable al 100 %',
  'det.noJustificationYet':
    'Aún no hay justificación: para este lead no se pudo ejecutar el emparejamiento de comprador (perfil de usuario incompleto o sitio web inaccesible). Iniciar las fases 2/3 obtendrá más datos.',
  'det.offering': 'Oferta',
  'det.nicheSignals': 'Señales de nicho',
  'det.niche.signalsOne': '1 señal',
  'det.niche.signalsMany': '{n} señales',
  'det.vatId': 'NIF/IVA: ',
  'det.revenue': 'Ingresos ',
  'det.agency': 'Agencia',
  'det.distributor': 'Distribuidor',
  'det.stack': 'Stack:',
  'det.webDesign': 'Diseño web:',
  'det.masteryBusiness': 'Empresa con certificación de maestría',
  'det.guild': 'Gremio: ',
  'det.imprintVerified': '✓ Aviso legal verificado',
  'det.sealsOfQuality': 'Sellos de calidad:',
  'det.social': 'Social:',
  'det.verifyingContacts': 'Verificando contactos…',
  'det.inferringPattern': 'Infiriendo el patrón…',
  'det.emailPatternPlaceholder': '{nombre}.{apellido}@empresa.de',
  'det.sales': 'Ventas',
  'det.marketing': 'Marketing',
  'det.engineering': 'Ingeniería',
  'det.finance': 'Finanzas',
  'det.management': 'Dirección',
  'det.procurist': 'Apoderado',
  'det.contactRemoved': 'eliminado, ya no se entregará.',
  'det.percentSure': '% de seguridad',
  'det.foundIn': 'encontrado en:',
  'det.recommendedChannel': 'Canal recomendado',
  'det.tier1': 'Nivel 1 · contacto directo',
  'det.tier2': 'Nivel 2 · canal de perfil',
  'det.tier3': 'Nivel 3 · vía central',
  'det.tier4': 'Nivel 4 · contacto de reserva',
  'det.tier5': 'Nivel 5 · solo enrutamiento de empresa',
  'det.inferred': '⚠ supuesto',
  'det.companyCentral': '(Sede central)',
  'det.quality.title': 'Calidad del lead',
  'det.quality.company': 'Empresa',
  'det.quality.contact': 'Contacto',
  'det.quality.noContacts':
    'No hay decisores verificables públicamente para esta empresa: Leadscraper no inventa contactos.',
  'det.quality.companyFitPlain': 'Sector, región y tamaño coinciden con tu búsqueda.',
  'det.quality.companyFitSoft': 'Sector y región encajan, aún no del todo claro en cada criterio.',
  'det.quality.noContactsCentral':
    'Sigue siendo accesible a través de la centralita (ver contacto).',
  'det.quality.outreach': 'Outreach',
  'det.quality.lockedContactVerify': 'Verifica primero el contacto',
  'det.quality.lockedPlanCreate': 'Crea primero el plan de adquisición',
  'ld.sparkle.conversationOpener': 'Apertura de conversación',
  'ld.sparkle.openerCopied': 'Apertura copiada.',
  'lt.next.contactVerificationStarted': 'Verificación de contacto iniciada …',
  'lt.next.contactVerificationLabel': 'Verificación de contacto',
  'lt.next.planGenerationStarted': 'Generación del plan de adquisición iniciada …',
  'lt.next.planGenerationLabel': 'Generación del plan de adquisición',
  'lt.next.verifiedNoContacts': 'Verificado: no se encontraron contactos',
  // LEA-379 i18n#5 (Om QA): lead-card loading status — these keys existed only in
  // de/en, so ES fell back to German. Copy is tweakable — flag Janik if off.
  'lt.loading.connecting': 'Buscando contactos …',
  'lt.loading.planning': 'Generando plan de adquisición …',
  'lt.loading.adding': 'Añadiendo …',
  'lt.loading.verifying': 'Verificando …',
  'lt.loading.connectingLive': 'Verificando contactos …',
  'lt.loading.planningLive': 'Creando plan de adquisición …',
  'det.size.employees': 'empleados',
  'det.since': 'desde ',

  // ── Prism-Funnel (Stage C i18n-Extraktion, /dev/prism-demo) ──────────────
  // Allgemein / Kicker
  'prism.kicker.account': 'Cuenta creada',
  'prism.kicker.waiting': 'Tus primeros clientes te esperan',
  'prism.audienceFallback': 'tu público objetivo',
  // LEA-379 i18n#4 (Om QA): Stripe checkout line-item, localized per session lang.
  'billing.tripwire.lineItem.name': 'Leadscraper · Paquete inicial de 50 leads',
  'billing.tripwire.lineItem.desc': '50 leads verificados, listos para contactar.',
  'prism.a11y.close': 'Cerrar',
  // Schritt 1 — Zielgruppe
  'prism.target.eyebrow': 'Paso 1 de 3 · Público objetivo',
  'prism.target.title': '¿A quién quieres llegar?',
  'prism.target.titleGrad': 'Los encontramos al instante.',
  'prism.target.sub':
    'Describe tu público objetivo en una frase: tu búsqueda en vivo se ajusta exactamente a él.',
  'prism.target.label': 'Tu público objetivo',
  'prism.target.placeholder': 'p. ej. gerentes de asesorías fiscales en Madrid',
  'prism.target.chip.steuer': 'Asesorías fiscales en Madrid',
  'prism.target.chip.agentur': 'Agencias de marketing en Barcelona',
  'prism.target.chip.handwerk': 'Empresas de reformas en Valencia',
  'prism.target.chipQuery.steuer': 'Gerentes de asesorías fiscales en Madrid',
  'prism.target.chipQuery.agentur': 'Propietarios de agencias de marketing en Barcelona',
  'prism.target.chipQuery.handwerk': 'Empresas de reformas en Valencia',
  'prism.target.tip':
    '💡 Lo que mejor funciona: sector + región, p. ej. «dentistas en Sevilla». También entendemos roles como «gerentes de pymes».',
  'prism.target.suggestion': '¿Quieres decir, p. ej., «{suggestion}»?',
  'prism.target.validating': 'Comprobando tu público objetivo …',
  'prism.target.cta': 'Buscar mi público',
  'prism.target.foot': 'Gratis · de momento sin datos de pago',
  'prism.target.errFallback': 'Esto aún no parece un público objetivo.',
  // Schritt 2 — Website
  'prism.website.eyebrow': 'Paso 2 de 3 · Sitio web',
  'prism.website.title': 'Tu web:',
  'prism.website.titleGrad': 'para que la IA te entienda',
  'prism.website.sub':
    'La web de tu propia empresa, para entender qué vendes y qué clientes encajan contigo.',
  'prism.website.label': 'URL de tu web',
  'prism.website.placeholder': 'https://tuempresa.es',
  'prism.website.hint':
    '¿Aún no tienes web propia? Salta este paso. La búsqueda se hace entonces solo con tu público objetivo.',
  'prism.website.errInvalid': 'Esto aún no parece una dirección web: p. ej. «tuempresa.es».',
  'prism.website.cta': 'Analizar mi web',
  'prism.website.foot': 'Solo se analiza · no se publica nada',
  // Analyse-Phase
  'prism.analyzing.reading': 'La IA está leyendo tu web …',
  'prism.analyzing.wait': 'Afinando tu público objetivo …',
  'prism.analyze.step1': 'Web cargada y leída en vivo',
  'prism.analyze.step2': 'Modelo de negocio identificado',
  'prism.analyze.step3': 'Oferta y propuesta de valor analizadas',
  'prism.analyze.step4': 'Público objetivo ideal deducido',
  // Schritt 3 — Fragen
  'prism.questions.eyebrow': 'Último paso · Ajuste fino',
  'prism.questions.back': '← Atrás',
  'prism.questions.title': 'Confírmanos algo:',
  'prism.questions.titleGrad': 'pregunta {num} de {total}',
  'prism.questions.q1': '¿Qué tamaño deben tener las empresas?',
  'prism.questions.q1o1': 'Hasta 50 empleados',
  'prism.questions.q1o2': 'Más de 50',
  'prism.questions.q1o3': 'Da igual',
  'prism.questions.q2': '¿Deben estar especializadas las empresas?',
  'prism.questions.q2o1': 'Sí, en un segmento',
  'prism.questions.q2o2': 'De perfil amplio',
  'prism.questions.q2o3': 'Da igual',
  'prism.questions.q3': '¿Dónde deben estar las empresas?',
  'prism.questions.q3o1': 'Solo en mi región',
  'prism.questions.q3o2': 'En todo el país',
  'prism.questions.q3o3': 'Da igual',
  'prism.questions.yes': 'Sí, exacto',
  'prism.questions.no': 'Más bien no',
  'prism.questions.foot': 'Cuanto más precisa tu respuesta, más certeros tus primeros leads.',
  // Such-Phase
  'prism.searching.label': 'empresas encontradas en tu público objetivo …',
  // Wave 2: concrete/procedural so the endless rotation doesn't feel "stuck" —
  // 6 true process steps instead of 4.
  'prism.searching.wait1': 'Comprobando el encaje de los resultados …',
  'prism.searching.wait2': 'Los resultados flojos quedan fuera …',
  'prism.searching.wait3': 'Comprobando duplicados …',
  'prism.searching.wait4': 'Comprobando que las webs estén accesibles …',
  'prism.searching.wait5': 'Contrastando ubicaciones …',
  'prism.searching.wait6': 'Unificando los perfiles de empresa …',
  'prism.search.step1': 'Búsquedas planificadas para tu público objetivo',
  'prism.search.step2': 'Empresas recopiladas mediante búsqueda web y en mapas',
  'prism.search.step3': 'Portales, directorios y duplicados descartados',
  'prism.search.step4': 'Encaje de los mejores resultados con tu público objetivo evaluado',
  'prism.search.step5': 'Webs de los mejores resultados comprobadas en vivo',
  'prism.search.step6': 'Región y tipo de empresa de los mejores resultados contrastados',
  'prism.search.step7': 'Resultados débiles descartados',
  'prism.search.step8': 'Plausibilidad del resultado comprobada',
  'prism.search.step9': 'Mejores resultados seleccionados',
  'prism.search.n.companies': '{count} empresas',
  'prism.search.n.ap': '{count} contactos',
  'prism.search.n.valid': '{count} válidos',
  'prism.search.n.revenue': '~{count} M €',
  'prism.search.n.top': 'Top 50',
  // Fit-Score-Labels
  'prism.score.perfect': 'Encaje perfecto',
  'prism.score.outstanding': 'Encaje excepcional',
  'prism.score.veryStrong': 'Encaje muy fuerte',
  'prism.score.good': 'Buen encaje',
  'prism.score.titleAttr': 'Puntuación de encaje {score}/100',
  // Refine-Screen (Engine schwach)
  'prism.refine.title': 'Aún no hay suficientes resultados. Vamos a afinarlo.',
  'prism.refine.body': 'Para {audience} aún no hemos encontrado suficientes empresas convincentes.',
  'prism.refine.hint1': 'Concreta tu público objetivo, lo que mejor funciona es',
  'prism.refine.hintStrong': 'sector + región',
  'prism.refine.hint2':
    '(p. ej. «asesorías fiscales en Madrid», «clínicas dentales en Barcelona», «constructoras en Andalucía»). Cuanto más concreto seas, más empresas reales encontramos para ti.',
  'prism.refine.try': 'Estos ya funcionan bien, con un solo clic:',
  // F9: pantalla 429 — cupo diario, nombrado con honestidad (no es un refine de calidad).
  'prism.rateLimit.title': 'Has alcanzado tu límite diario de búsquedas en vivo.',
  'prism.rateLimit.body':
    'Esto no tiene nada que ver con tu público objetivo: limitamos las búsquedas en vivo gratuitas por día. Tu público objetivo y tu web quedan guardados.',
  'prism.rateLimit.reset': 'Tu cupo se restablece a las {time}.',
  'prism.rateLimit.cta': 'Volver al inicio',
  // D2 (LEA-430): reanudación «bienvenido de nuevo» + alternativa honesta al temporizador.
  'prism.resume.title': '¡Bienvenido de nuevo!',
  'prism.resume.body': 'Tu búsqueda para {audience} está lista — tu resultado está guardado.',
  'prism.resume.cta': 'Ver resultado',
  'prism.resume.dismiss': 'Iniciar una nueva búsqueda',
  'prism.resume.saved': 'Tu selección está guardada — sin presión de tiempo.',
  'prism.understood.title': 'Tu empresa, entendida',
  'prism.understood.opps': 'Oportunidades',
  // Wave 2: label above the highlighted "why now" line.
  'prism.understood.momentumLabel': 'Por qué ahora:',
  // DEPRECATED (Wave 2): "A tener en cuenta" is no longer rendered (legacy bundles).
  'prism.understood.risks': 'A tener en cuenta',
  'prism.understood.demoModel': 'Servicio B2B que ayuda a pymes a captar nuevos clientes.',
  'prism.understood.demoOpp1': 'Nicho bien definido con alto valor por cliente',
  'prism.understood.demoOpp2': 'Poca competencia especializada en la región',
  'prism.understood.demoOpp3': 'Responsables accesibles directamente (equipos pequeños)',
  'prism.understood.demoRisk1': 'Ciclos de decisión largos en pymes',
  'prism.understood.demoRisk2': 'El primer contacto necesita un gancho concreto',
  'prism.seed.badge': 'Pack inicial',
  'prism.seed.working': '{delivered}/{total} leads entregados',
  'prism.seed.workingSub':
    'Tarda entre 10 y 30 minutos. Los nuevos leads aparecen automáticamente. Mejor exporta cuando estén todos.',
  'prism.seed.creditsNote':
    'Tus {total} créditos iniciales se canjean sobre la marcha: 1 crédito por lead terminado.',
  'prism.seed.done': 'Los {delivered} leads ya están en tu cuenta.',
  'prism.seed.donePartial':
    '{delivered} leads entregados: los créditos restantes quedan en tu saldo.',
  'prism.refine.cta': 'Afinar mi público ahora',
  // Ergebnis (Aha)
  // Wave 2: the real kept-count now carries the headline.
  'prism.results.foundSuffix': 'empresas encontradas en tu público objetivo',
  // #4 (Quickwins): variante personalizada — {audience} llega como »cita« lista
  // desde el cliente (nunca flexionar, el gate vive en el cliente).
  'prism.results.foundSuffixAud': 'empresas encontradas para {audience}',
  // DEPRECATED (#13): "only X match" undersells the engine and contradicts
  // the 50-unlock — replaced by topLine (abundance + curation).
  'prism.results.matched': '{count} coinciden con tu público objetivo',
  // #13: story = we show the strongest matches, the market has more of them.
  'prism.results.topLine': 'Abajo: tus mejores resultados según encaje.',
  // Wave 2: crossfade label target for the number morph (reserved; the
  // "comprobadas en vivo" framing currently carries foundSuffix).
  'prism.results.checkedLabel': 'de las cuales comprobadas en vivo, tus más fuertes',
  // DEPRECATED (Wave 2): replaced by prism.results.matched.
  'prism.results.checked': '{count} de ellas ya comprobadas en vivo',
  'prism.results.unlockHint': 'Desbloquea tus primeras',
  'prism.results.unlockOffer': '{n} empresas adecuadas por 49 €',
  'prism.results.disclaimer':
    'Estimación del potencial de mercado basada en tu análisis en vivo: encontramos exactamente estas empresas para ti.',
  'prism.results.stat.checked': 'empresas encontradas',
  // Wave 2: new real stat labels.
  'prism.results.stat.onTarget': 'coinciden con tu público objetivo',
  // #13: market-abundance tile instead of "X match" — real engine estimate
  // (market.projected_range_dach); tile is omitted when no estimate exists.
  'prism.results.stat.market': 'empresas en tu mercado (estimación)',
  'prism.results.stat.avgFit': 'Puntuación de encaje media de tus mejores resultados',
  // DEPRECATED (Wave 2): synthetic tiles — no longer rendered.
  'prism.results.stat.contacts': 'personas de contacto localizables',
  'prism.results.stat.revenue': 'potencial de facturación del público',
  'prism.results.chart.sizeTitle': 'Empresas por tamaño',
  'prism.results.chart.sizeMuted': 'en tu público objetivo',
  'prism.results.chart.emp1': '1–9 empl.',
  'prism.results.chart.emp2': '10–49 empl.',
  'prism.results.chart.emp3': '50–199 empl.',
  'prism.results.chart.emp4': '200+ empl.',
  'prism.results.chart.qualityTitle': 'Calidad de datos de tus leads',
  'prism.results.chart.qualityMuted': 'comprobado hoy',
  'prism.results.chart.mail': 'Email verif.',
  'prism.results.chart.dial': 'Tel. directo',
  'prism.results.chart.decider': 'Decisores',
  'prism.results.insights.title': 'Potencial y timing de tu público objetivo',
  'prism.results.insights.openRate': 'Tasa media de apertura de emails B2B verificados',
  'prism.results.insights.bestTimeValue': 'Mar–Jue · 9–11 h',
  'prism.results.insights.bestTime': 'Mejor franja de contacto en este sector',
  'prism.results.insights.dealValue': 'Valor medio de pedido por cliente ganado',
  'prism.results.insights.competitionValue': 'baja',
  'prism.results.insights.competition': 'Competencia en prospección en frío en tu región',
  'prism.results.why.title': 'Buen momento:',
  'prism.results.why.p1': 'En tu público objetivo se han incorporado últimamente',
  'prism.results.why.strong': 'un 18 % más de decisores nuevos',
  'prism.results.why.p2':
    ', la fase ideal para el primer contacto, antes de que la competencia reaccione.',
  'prism.results.timing.title': 'Por qué ahora es exactamente el momento adecuado',
  'prism.results.timing.legend': 'La mejor fase para contactar a tu público objetivo, ahora',
  'prism.timing.text':
    'En {month}, la disponibilidad de {who} suele estar en su punto más alto: se están asignando los presupuestos del próximo trimestre y los decisores cogen el teléfono. Quien da el primer paso ahora llega antes de que la competencia se ponga al día en {next}.',
  // Monate (Saisonalitäts-Chart + Timing-Text)
  'prism.month.now': 'Ahora',
  'prism.month.short.1': 'Ene',
  'prism.month.short.2': 'Feb',
  'prism.month.short.3': 'Mar',
  'prism.month.short.4': 'Abr',
  'prism.month.short.5': 'May',
  'prism.month.short.6': 'Jun',
  'prism.month.short.7': 'Jul',
  'prism.month.short.8': 'Ago',
  'prism.month.short.9': 'Sep',
  'prism.month.short.10': 'Oct',
  'prism.month.short.11': 'Nov',
  'prism.month.short.12': 'Dic',
  'prism.month.long.1': 'enero',
  'prism.month.long.2': 'febrero',
  'prism.month.long.3': 'marzo',
  'prism.month.long.4': 'abril',
  'prism.month.long.5': 'mayo',
  'prism.month.long.6': 'junio',
  'prism.month.long.7': 'julio',
  'prism.month.long.8': 'agosto',
  'prism.month.long.9': 'septiembre',
  'prism.month.long.10': 'octubre',
  'prism.month.long.11': 'noviembre',
  'prism.month.long.12': 'diciembre',
  // Frei-Lead
  'prism.freelead.tag': 'Tu primer lead, corre de nuestra cuenta',
  'prism.freelead.verified': 'verificado',
  'prism.freelead.lockedChip': '🔒 Persona de contacto y datos de contacto tras desbloquear',
  'prism.freelead.note1': 'Así es',
  'prism.freelead.noteStrong': 'cada una',
  'prism.freelead.note2':
    'de tus {n} empresas adecuadas: una persona de contacto real con email o teléfono. Las otras {rest} las desbloqueas en el siguiente paso.',
  'prism.freelead.alt1': 'Esta empresa encaja con tu público objetivo. Al desbloquear añadimos',
  'prism.freelead.altStrong': 'personas de contacto reales con email o teléfono',
  'prism.freelead.alt2': ', para las {n}.',
  // Lead-Zeilen
  'prism.lead.ap': 'Personas de contacto',
  'prism.lead.inclDeciders': 'tras desbloquear',
  'prism.results.moreStrong': '≈{count} empresas más',
  'prism.results.moreRest': 'encontradas. Investigamos los contactos tras desbloquear.',
  'prism.results.planTitle': 'Tu plan de prospección inicial:',
  'prism.results.planBody':
    'las {n} empresas más fuertes primero, personas de contacto con email o teléfono, exportables como CSV o Excel.',
  'prism.results.cta': 'Desbloquear mis {n} empresas adecuadas',
  'prism.results.detailsLink': '¿Qué incluye exactamente?',
  'prism.results.foot':
    '49 € hoy · {n} empresas adecuadas · desde el día 4: 290 €/mes, cancelable en cualquier momento',
  // Paywall
  'prism.paywall.step2': 'Desbloquear',
  'prism.paywall.step3': 'Empezar',
  'prism.paywall.resPrefix': 'Tus',
  'prism.paywall.resStrong': '50 leads',
  'prism.paywall.resSuffix': 'están reservados para ti',
  'prism.paywall.resExpired': 'Reserva caducada: te guardamos la búsqueda un poco más.',
  'prism.paywall.eyebrow': '{count} empresas encontradas, listas para desbloquear',
  'prism.paywall.title1': 'Desbloquea tus primeras',
  'prism.paywall.titleGrad': '{n} empresas adecuadas',
  'prism.paywall.title2': 'ahora mismo.',
  // #4 (Quickwins): variante H1 personalizada ({audience} = »cita« lista).
  'prism.paywall.title2Aud': 'para {audience} ahora mismo.',
  'prism.paywall.sub1': 'Hemos encontrado',
  'prism.paywall.subStrong1': '{count} empresas',
  'prism.paywall.sub2': 'para {audience}. Las',
  'prism.paywall.subStrong2': '{n} más fuertes',
  'prism.paywall.sub3':
    'te esperan. Investigamos las personas de contacto y sus datos tras desbloquear.',
  // Lead-Tresor
  'prism.vault.title': 'Tus {n} empresas más fuertes están listas',
  // Wave 2: 3-stage story from real numbers — {count}=discovery.kept
  // (comprobadas en vivo), {audience}=typed target audience.
  // #13: no more "exactly X match" (contradicted "50 strongest" and shrank
  // the market) — {onTarget} stays as an unused-but-compatible placeholder.
  'prism.vault.sub':
    'De {count} empresas encontradas para {audience}, aquí tienes tus {n} más fuertes. Investigamos las personas de contacto y sus datos tras desbloquear.',
  'prism.vault.locked': 'bloqueado',
  'prism.vault.blurEmail': 'contacto@empresa.es',
  // Wave 2: real remaining count from the scored pool instead of a static "+45".
  'prism.vault.more': '+ {count} empresas más encontradas, bloqueadas',
  'prism.vault.cta': 'Desbloquear los {n}: 49 €',
  'prism.vault.reassure': '49 € hoy · desde el día 4: 290 €/mes · cancelable en cualquier momento',
  // Gründer-Karte + Video
  'prism.founder.head': 'Un mensaje personal del fundador',
  'prism.founder.quote':
    '«Hola, soy Janik. Durante toda tu fase de prueba te acompaño personalmente, y el precio de entrada es bajo a propósito, para que puedas probar Leadscraper con calma. Danos la oportunidad: estoy seguro de que encajamos contigo.»',
  'prism.founder.role': 'Fundador · Leadscraper',
  'prism.video.playAria': 'Reproducir vídeo demo',
  'prism.video.chip': 'Demo en vivo · 10:04',
  'prism.video.title': 'Mira cómo Janik encuentra tus primeros leads',
  'prism.video.cta': 'Ver la demo: búsqueda real, dashboard real',
  'prism.video.iframeTitle': 'Demo en vivo · Leadscraper',
  // Timeline (So läuft dein Test)
  'prism.timeline.title': 'Así funciona tu prueba de 3 días',
  'prism.timeline.today': 'Hoy',
  'prism.timeline.todayStrong': '49 € hoy',
  'prism.timeline.todayRest': ': {n} empresas adecuadas desbloqueadas, en tu cuenta en 10 a 30 minutos.',
  'prism.timeline.days13': 'Días 1–3',
  'prism.timeline.testP1': 'Pruebas con leads reales.',
  'prism.timeline.testStrong': '3 días de margen',
  'prism.timeline.testP2': '. Si no encaja, cancelas con 1 clic y no pagas ni un céntimo más.',
  'prism.timeline.day4': 'Desde el día 4',
  'prism.timeline.aboP1': 'Después, tu plan sigue con',
  'prism.timeline.aboStrong': '250 créditos por 290 €/mes',
  'prism.timeline.aboP2': ' — cancelable en cualquier momento.',
  // Versus-Block
  'prism.versus.title': 'Por qué Leadscraper, y no el camino de siempre',
  'prism.versus.oldTitle': 'El camino de siempre',
  'prism.versus.old1': 'Horas buscando en Google a mano o comprando listas desactualizadas',
  'prism.versus.old2': 'Alta tasa de rebote, zona gris del RGPD',
  'prism.versus.old3': 'Rebuscar cada persona de contacto por tu cuenta',
  'prism.versus.old4': '1.000–1.500 €/mes + contrato anual (Cognism, Dealfront)',
  'prism.versus.old5': 'Semanas hasta la primera respuesta',
  'prism.versus.newTitle': 'Con Leadscraper',
  'prism.versus.new1': '{n} empresas adecuadas en 10 a 30 minutos, a medida de tu público objetivo',
  'prism.versus.new2': 'Emails comprobados técnicamente, teléfono si está disponible',
  'prism.versus.new3': 'Personas de contacto incluidas de serie',
  'prism.versus.new4': 'Pruébalo por 49 € · cancelable mes a mes · sin contrato anual',
  'prism.versus.new5': 'Exporta hoy, contacta mañana',
  'prism.versus.foot1': 'El mismo trabajo que a otros les cuesta',
  'prism.versus.footStrong1': 'semanas',
  'prism.versus.foot2': 'y',
  'prism.versus.footStrong2': 'más de 1.000 €/mes',
  'prism.versus.foot3': ', tú lo tienes hoy, de prueba, por',
  'prism.versus.footStrong3': '49 €',
  // ROI-Panel
  'prism.roi.title': 'Lo que te aportan tus {n} empresas adecuadas',
  'prism.roi.row1': 'Leads con personas de contacto, listos en 10 a 30 minutos',
  'prism.roi.row2': 'Tu inversión de hoy',
  'prism.roi.row3': 'Un solo cliente ganado ya devuelve',
  'prism.roi.row3v': 'muchas veces tu inversión',
  'prism.roi.hl1': 'Un',
  'prism.roi.hlStrong': 'único',
  'prism.roi.hl2':
    'cliente de tus primeras {n} empresas adecuadas recupera los 49 € con creces: todo lo que venga después es ventaja.',
  'prism.roi.perLead': 'por lead listo para usar',
  'prism.roi.stat2v': '10–30 min',
  'prism.roi.stat2': 'en vez de semanas de búsqueda',
  'prism.roi.stat3v': '3 días',
  'prism.roi.stat3': 'de prueba antes de que empiece el plan',
  // Plan-Karte
  'prism.plan.badge': 'Oferta de entrada · 3 días de prueba',
  'prism.plan.leadsUnit': 'empresas adecuadas · personas de contacto en 10 a 30 minutos',
  'prism.plan.anchor': 'Hacerlo tú mismo: ~10 h de trabajo manual',
  'prism.plan.priceSuffix': 'hoy',
  'prism.price.netVat': 'más IVA',
  'prism.plan.perLeadStrong': 'menos de 1 €',
  'prism.plan.f1': 'Emails comprobados técnicamente, teléfono si está disponible',
  'prism.plan.f2': 'Personas de contacto por empresa, si se encuentran públicamente',
  'prism.plan.f3': 'Exportación en CSV o Excel, conexión con CRM posible',
  'prism.plan.cta': 'Desbloquear ahora: 49 €',
  'prism.plan.secure': 'Pago seguro con Stripe · cifrado SSL',
  'prism.plan.subnote': 'Cancelación en cualquier momento con 1 clic desde tu cuenta.',
  'prism.plan.gbCondition': 'Condiciones de la garantía: ver § 7 de los',
  'prism.guarantee.title': 'Garantía de devolución',
  'prism.guarantee.sub':
    'Durante los 3 días de prueba te devolvemos los 49 €: escribe a support@leadscraper.eu, rellena nuestro breve formulario de opinión y con el reembolso damos de baja tu plan. Solo para esta oferta de entrada.',
  'prism.legal.agb': 'Términos y Condiciones',
  'prism.legal.agbUrl': 'https://www.leadscraper.de/es/terminos-y-condiciones',
  'prism.legal.privacyUrl': 'https://www.leadscraper.de/es/politica-de-privacidad',
  'prism.legal.privacy': 'Política de privacidad',
  // Reviews-Band (Überschriften — Kunden-Zitate/Namen bleiben bewusst unübersetzt)
  'prism.reviews.title': 'Equipos de ventas que ya se han cambiado',
  // Trust-Bar
  'prism.trust.payStrong': '49 € hoy',
  'prism.trust.payRest': '· tarjeta, PayPal, Apple y Google Pay, seguro vía Stripe',
  'prism.trust.cancelStrong': 'Cancelable en cualquier momento',
  'prism.trust.cancelRest': '· con 1 clic desde tu cuenta, sin plazos ni preguntas',
  'prism.trust.dataStrong': 'Solo datos públicos',
  'prism.trust.dataRest': '· RGPD por diseño · servidores en la UE',
  // FAQ
  'prism.faq.title': 'Preguntas frecuentes',
  'prism.faq.q1': '¿Qué pasa después de los 3 días?',
  'prism.faq.a1':
    'Desde el día 4 continúa tu plan con 250 créditos por 290 €/mes, cancelable en cualquier momento con un clic. Así decides con calma durante los 3 días.',
  'prism.faq.q2': '¿Puedo cancelar cuando quiera?',
  'prism.faq.a2':
    'Sí, cada mes: basta un clic en tu cuenta, sin plazos ni preguntas. Si cancelas en los 3 días de prueba, solo pagas los 49 €. Más adelante, tu acceso sigue hasta el final del mes pagado.',
  'prism.faq.q3': '¿De dónde salen los leads? ¿Cumple con el RGPD?',
  'prism.faq.a3':
    'Exclusivamente de datos empresariales disponibles públicamente. RGPD por diseño, procesamiento y servidores únicamente en la UE.',
  'prism.faq.q4': '¿Y si los leads no encajan?',
  'prism.faq.a4':
    'Durante los 3 días de prueba te devolvemos los 49 € si rellenas nuestro breve formulario de opinión (Términos § 7). Escribe a support@leadscraper.eu; con el reembolso damos de baja tu plan. Después ya no hay reembolso, pero puedes cancelar el plan en cualquier momento.',
  'prism.faq.q5': '¿Recibo personas de contacto reales?',
  'prism.faq.a5':
    'Sí: por cada empresa, personas de contacto investigadas con dirección de email o número de teléfono. Los emails se comprueban técnicamente; no podemos garantizar que cada buzón exista. Si no se encuentra ningún contacto alcanzable para una empresa, no se cobra nada por ella.',
  // Gründer-Zeile
  'prism.founderline.strong': 'Dirigida por su fundador, desde Hamburgo',
  'prism.founderline.rest': '· Janik Deimann, fundador',
  'prism.founderline.sub': 'Deimann Com GmbH · Aquí te atienden personas, no una cola de tickets.',
  'prism.founderline.ask':
    '¿Aún con dudas? Escríbenos a support@leadscraper.eu. Te responde una persona.',
  // Fixe Kauf-Leiste
  'prism.sticky.leads': '{n} empresas adecuadas ·',
  'prism.sticky.today': 'hoy · desde el día 4: 290 €/mes',
  'prism.sticky.cta': 'Desbloquear ahora',
  // Inline-Checkout
  'prism.checkout.eyebrow': 'Oferta de entrada · 49 € hoy',
  'prism.checkout.title': '{n} empresas adecuadas · desbloquear ahora',
  'prism.checkout.sumPrice': '49 € hoy',
  'prism.checkout.sumDesc': '{n} empresas adecuadas desbloqueadas, 3 días de prueba',
  'prism.checkout.after': 'desde el día 4',
  'prism.checkout.monthly': '290 € / mes',
  'prism.checkout.reassure3d':
    'Si cancelas dentro de los 3 días, solo pagas los 49 €. Tus leads siguen siendo tuyos: podrás verlos y exportarlos también después.',
  'prism.checkout.deliverNote':
    'En esta búsqueda hay {count} empresas adecuadas listas. Un crédito solo cuenta si encontramos un contacto; el resto de tus 50 créditos lo usas en otras búsquedas.',
  'prism.checkout.cancelNote': 'Cancela la suscripción cuando quieras, un clic.',
  'prism.checkout.invite':
    'Te invitamos: 50 leads por un pago único a precio de coste, solo para empezar, para que puedas probar Leadscraper sin riesgo.',
  'prism.checkout.or': 'o con tarjeta',
  'prism.checkout.tabCard': 'Tarjeta',
  'prism.checkout.tabSepa': 'Domiciliación SEPA',
  'prism.checkout.cardholder': 'Titular de la tarjeta',
  'prism.checkout.cardholderPh': 'Nombre y apellidos',
  'prism.checkout.cardNumber': 'Número de tarjeta',
  'prism.checkout.expiry': 'Caducidad',
  'prism.checkout.expiryPh': 'MM / AA',
  'prism.checkout.country': 'País',
  'prism.checkout.countryDe': 'Alemania',
  'prism.checkout.countryAt': 'Austria',
  'prism.checkout.countryCh': 'Suiza',
  'prism.checkout.paying': 'Activando …',
  'prism.checkout.embedLoading': 'Cargando el pago seguro …',
  'prism.checkout.payCta': 'Desbloquear {n} empresas adecuadas: 49 €',
  'prism.checkout.securePrefix': 'Pago seguro con',
  'prism.checkout.secureSuffix': '· cifrado SSL',
  // Wave 2: generic button reference — the live CTA of the PaymentElement
  // (locked zone) reads "Continuar al pago", not "Desbloquear 50 leads".
  'prism.checkout.fine1': 'Al hacer clic en el botón de arriba aceptas los',
  'prism.checkout.fine2':
    'así como la renovación automática como plan Starter (250 créditos / 290 € al mes) desde el día 4, cancelable en cualquier momento con un clic. Esta oferta se dirige exclusivamente a empresas y profesionales autónomos (B2B, § 14 BGB). Todos los precios son netos, IVA no incluido. Garantía de devolución: solo para esta oferta de entrada, solo dentro de los 3 días de prueba y con el formulario de opinión rellenado (Términos § 7).',
  // Success-Screen
  'prism.success.title': '{n} empresas adecuadas desbloqueadas',
  'prism.success.body':
    'Tus {n} empresas adecuadas ya están desbloqueadas. Las personas de contacto llegan en 10 a 30 minutos, exportables como CSV/CRM. Desde el día 4 se activa tu plan Starter (250 créditos/mes), cancelable mes a mes.',
  'prism.success.cta': 'Vamos allá',

  // --- LEA-379 i18n backfill (2026-07-06): keys that previously fell back to
  //     German (packages/i18n index.ts fallback). Machine-translated from EN/DE,
  //     billing/cancel copy pending Janik wording review. ---
  'acct.plan.downgradeScheduled': 'Cambio de plan programado',
  'acct.plan.downgradeScheduledDetail':
    'El {date} pasarás a {plan}. Hasta entonces mantienes tu plan actual y tus Credits se conservan.',
  'acct.plan.downgradeCancel': 'Cancelar cambio de plan',
  'acct.plan.downgradeCanceling': 'Cancelando …',
  // LEA-555 — trial intercept.
  // LEA-557 — retention discount (30% x 3 Monate).
  // LEA-558 — VIP-Einrichtung (990-€-Vergleichswert nur in der Copy).
  // LEA-560 — Win-back-Banner.
  'acct.winback.title': 'Tu oferta de bienvenida',
  'acct.winback.body':
    '{plan} con un 30 % de descuento durante 3 meses. El checkout muestra el precio y la fecha de cobro antes de que pase nada.',
  'acct.winback.cta': 'Ir al checkout',
  'acct.winback.starting': 'Abriendo …',

  // LEA-524 — Pausendauer + Wiederaufnahme-Datum.
  'acct.cancel.save.offerTitle': 'Antes de cancelar, quizá algo de esto encaje mejor',
  'acct.cancel.save.offerSub': 'Sin presión. Cancelar sigue estando a un clic.',
  'acct.cancel.pauseMonthsLabel': 'Pausar durante',
  'acct.cancel.pauseMonths1': '1 mes',
  'acct.cancel.pauseMonths': '{n} meses',
  'acct.cancel.pauseResumeHint':
    'Tu suscripción se reanuda automáticamente el {date}; a partir de entonces se vuelve a cobrar.',
  'acct.cancel.pausedDetailUntil':
    'No se realiza ningún cargo. Conservas el acceso y tus créditos restantes. Tu suscripción se reanuda automáticamente el {date}; puedes reanudarla antes cuando quieras.',
  'acct.cancel.pausedNoteUntil':
    'Pausada hasta el {date}, sin cargos. Tus créditos siguen disponibles.',

  'acct.cancel.trial.vipTitle': 'Janik configura tu cuenta personalmente',
  'acct.cancel.trial.vipBody':
    'Públicos objetivo, perfiles de búsqueda, primeras búsquedas — el fundador configura tu cuenta contigo personalmente. Un servicio con un valor de 990 € — gratis para ti si sigues probando.',
  'acct.cancel.trial.vipCta': 'Solicitar configuración personal',
  'acct.cancel.trial.vipRequesting': 'Solicitando …',
  'acct.cancel.trial.vipDoneTitle': 'Solicitud enviada',
  'acct.cancel.trial.vipDoneBody':
    'Janik se pondrá en contacto contigo personalmente en 24 horas. Tu prueba continúa con normalidad — no se canceló ni se cobró nada.',

  'acct.cancel.save.discountTitle': '30 % de descuento durante los próximos 3 meses',
  'acct.cancel.save.discountBody':
    'Quédate y paga un 30 % menos durante tres meses — el descuento se aplica directamente a tu suscripción, tu tarjeta queda como está, sin nuevo checkout.',
  'acct.cancel.save.discountCta': 'Activar el 30 % de descuento',
  'acct.cancel.save.discounting': 'Activando …',
  'acct.cancel.save.discountDoneTitle': 'Descuento activo',
  'acct.cancel.save.discountDoneBody':
    'Tus próximas tres facturas mensuales tienen un 30 % de descuento. Después tu plan continúa al precio normal — puedes cancelar cuando quieras con un clic.',

  'acct.cancel.trial.interceptTitle': 'Espera — tu prueba sigue activa hasta el {date}.',
  'acct.cancel.trial.interceptTitleNoDate': 'Espera — tu prueba sigue activa.',
  'acct.cancel.trial.interceptSub': 'Hasta entonces no se te cobrará nada.',
  'acct.cancel.trial.reminderTitle': 'Te avisaremos a tiempo',
  'acct.cancel.trial.reminderBody':
    'No tienes que apuntar nada ni recordar nada. Te escribiremos 24 horas antes de que termine — y si no quieres continuar, puedes cancelar directamente desde ese correo.',
  'acct.cancel.trial.reminderPointMail': 'El enlace para cancelar está en el propio correo.',
  'acct.cancel.trial.reminderPointNoCharge': 'Antes de eso no se te cobrará nada.',
  'acct.cancel.trial.reminderCta': 'Seguir probando y avisarme',
  'acct.cancel.trial.keepTestingCta': 'Seguir probando',
  'acct.cancel.trial.reminderSaving': 'Activando …',
  'acct.cancel.trial.reminderDoneTitle': 'Recordatorio activado',
  'acct.cancel.trial.reminderDoneBody':
    'Te escribiremos el {date} — 24 horas antes de que termine tu prueba, con el enlace para cancelar en el propio correo.',
  'acct.cancel.trial.reminderDoneBodyNoDate':
    'Te escribiremos 24 horas antes de que termine tu prueba, con el enlace para cancelar en el propio correo.',
  'acct.cancel.trial.cancelNowLink': 'Cancelar definitivamente',
  'acct.cancel.trial.confirm.endsNow':
    'Tu acceso de prueba termina de inmediato, no en la fecha de vencimiento.',
  'acct.cancel.trial.confirm.forfeits':
    'Tus perfiles de búsqueda y los créditos restantes se pierden.',
  'acct.cancel.trial.confirm.noCharge': 'No se te cobrará nada.',
  'acct.cancel.trial.done.title': 'Prueba finalizada',
  'acct.cancel.trial.done.body':
    'Tu prueba ha terminado y no se te ha cobrado nada. Si cambias de opinión, puedes contratar una suscripción cuando quieras.',

  'acct.cancel.trigger': 'Cancelar suscripción',
  'acct.cancel.manageHint': 'Gestionar suscripción',
  'acct.cancel.scheduledTitle': 'Cancelación programada',
  'acct.cancel.scheduledDetail':
    'Tu suscripción termina el {date}. Mantienes el acceso completo hasta entonces.',
  'acct.cancel.reactivate': 'Deshacer la cancelación',
  'acct.cancel.reactivating': 'Deshaciendo …',
  'acct.cancel.restored': 'Suscripción restaurada. Tu plan continúa.',
  'acct.cancel.title': 'Cancelar suscripción',
  'acct.cancel.stepOf': 'Paso {n} de {total}',
  'acct.cancel.reasonTitle': '¿Por qué quieres cancelar?',
  'acct.cancel.reasonSub': 'Opcional: tu respuesta nos ayuda a mejorar Leadscraper.',
  'acct.cancel.reason.too_expensive': 'Demasiado caro',
  'acct.cancel.reason.too_few_leads': 'Pocos (buenos) Leads',
  'acct.cancel.reason.wrong_contacts': 'Contactos equivocados',
  'acct.cancel.reason.unreliable_data': 'Emails/datos de contacto poco fiables',
  'acct.cancel.reason.too_complicated': 'Demasiado complicado',
  'acct.cancel.reason.missing_feature': 'Falta una función',
  'acct.cancel.reason.temporary_only': 'Solo lo necesitaba temporalmente',
  'acct.cancel.reason.switched_tool': 'Me paso a otra herramienta',
  'acct.cancel.reason.other': 'Otro',
  'acct.cancel.freeTextPlaceholder': 'Cuéntanos más (opcional) …',
  'acct.cancel.save.downgradeTitle': '¿Quizás encaja un plan más pequeño?',
  'acct.cancel.save.downgradeBody':
    'En lugar de cancelar, puedes cambiar a un plan más barato: conservas tus Credits y pagas menos a partir del próximo ciclo.',
  'acct.cancel.save.downgradeCta': 'Ver planes más baratos',
  'acct.cancel.save.downgradeOffer':
    'Cambia a {plan}: {price}\u00A0€/mes · {leads} Leads/mes. Conservas tus Credits y pagas menos a partir del próximo ciclo.',
  'acct.cancel.save.downgradeCtaPlan': 'Cambiar a {plan}',
  'acct.cancel.save.downgrading': 'Cambiando …',
  'acct.cancel.save.seeAllPlans': 'Ver todos los planes',
  'acct.cancel.save.helpTitle': 'Vamos a solucionarlo',
  'acct.cancel.save.helpBody':
    'Muchas de estas cosas las estamos mejorando activamente. Escríbenos qué te faltó: a menudo podemos reajustar tu búsqueda rápidamente.',
  'acct.cancel.confirm.accessUntil': 'Mantienes el acceso completo hasta el {date}.',
  'acct.cancel.confirm.noCharge': 'Después de eso no se te volverá a cobrar.',
  'acct.cancel.confirm.reactivate':
    'Puedes deshacer la cancelación en cualquier momento antes de esa fecha.',
  'acct.cancel.audit.title': 'Una última cosa (opcional)',
  'acct.cancel.audit.sub': '¿Qué funcionó y qué no? Va directo a las mejoras.',
  'acct.cancel.audit.rightCompanies': '¿Las empresas correctas?',
  'acct.cancel.audit.rightContacts': '¿Los contactos correctos?',
  'acct.cancel.audit.contactDataUsable': '¿Email/teléfono/LinkedIn utilizables?',
  'acct.cancel.audit.enoughLeads': '¿Suficientes Leads?',
  'acct.cancel.audit.helpedWin': '¿Te ayudó a ganar clientes?',
  'acct.cancel.audit.good': 'Bien',
  'acct.cancel.audit.bad': 'Mal',
  'acct.cancel.lead.title': '¿Qué Lead te decepcionó? (opcional)',
  'acct.cancel.lead.sub': 'Si un Lead concreto no encajó, decírnoslo es lo que más nos ayuda.',
  'acct.cancel.lead.pick': 'Elige un Lead',
  'acct.cancel.lead.loading': 'Cargando …',
  'acct.cancel.lead.none': 'No se encontraron Leads entregados.',
  'acct.cancel.cf.title': 'Ayúdanos a hacerlo mejor (opcional)',
  'acct.cancel.cf.gapPlaceholder': '¿Qué necesitabas que no pudimos ofrecerte?',
  'acct.cancel.cf.toolPlaceholder': '¿Te pasas a otra herramienta? ¿A cuál?',
  'acct.cancel.cf.betterPlaceholder': '¿Qué hace mejor?',
  'acct.cancel.justCancel': 'Cancelar ahora',
  'acct.cancel.keep': 'Prefiero quedármelo',
  'acct.cancel.next': 'Continuar',
  'acct.cancel.back': 'Atrás',
  'acct.cancel.stillCancel': 'Cancelar igualmente',
  'acct.cancel.confirmBtn': 'Confirmar cancelación',
  'acct.cancel.confirming': 'Cancelando …',
  'acct.cancel.done.title': 'Cancelación confirmada',
  'acct.cancel.done.body':
    'Tu suscripción termina el {date}. Hasta entonces mantienes el acceso completo, y puedes deshacer la cancelación en cualquier momento antes de esa fecha.',
  'acct.cancel.done.close': 'Cerrar',
  'acct.cancel.save.pauseTitle': '¿Pausar en vez de cancelar?',
  'acct.cancel.save.pauseBody':
    'Congela tu suscripción en lugar de cancelarla: sin cargos, tus Credits y datos se conservan, y puedes reanudarla en cualquier momento con un clic.',
  'acct.cancel.save.pauseCta': 'Pausar suscripción',
  'acct.cancel.save.pausing': 'Pausando …',
  'acct.cancel.pauseTrigger': 'Pausar',
  'acct.cancel.pausing': 'Pausando …',
  'acct.cancel.pausedBadge': 'Pausada',
  'acct.cancel.pausedNote': 'Suscripción pausada: sin cargos. Tus Credits siguen disponibles.',
  'acct.cancel.pausedTitle': 'Suscripción pausada',
  'acct.cancel.pausedDetail':
    'No se te cobra nada. Mantienes el acceso y tus Credits restantes. Reanúdala cuando quieras.',
  'acct.cancel.resume': 'Reanudar suscripción',
  'acct.cancel.resuming': 'Reanudando …',
  'billing.errorRetry': 'Intentar de nuevo',
  'billing.transientError': 'Temporalmente no disponible. Vuelve a intentarlo en un momento.',
  'billing.downgradeScheduled':
    'Cambio de plan programado: el {date} pasarás a {plan}. Tus Credits se conservan.',
  'billing.downgradeAlready': 'Ya hay un cambio a {plan} programado para el {date}.',
  'dash.run.suggHeading': 'Búsquedas de ejemplo para tu negocio',
  'dash.run.intent.broad': 'Clásica',
  'dash.run.intent.growth': 'Señal de crecimiento',
  'dash.run.intent.tool': 'Señal de herramienta',
  'dash.run.intent.default': 'Sugerencia',
  'dash.run.costPreview': 'hasta {n} créditos',
  'det.sourcesPending':
    'Las pruebas de origen de este Lead aún se están recopilando. Aparecerán aquí una vez verificadas.',
  'ld.contact.emailCopied': 'Dirección de email copiada.',
  'ld.contact.phoneCopied': 'Número de teléfono copiado.',
  'ld.contact.copy': 'Copiar',
  'ld.contact.copied': 'Copiado.',
  'ld.contact.tagCentral': 'Centralita',
  'ld.contact.tagUnconfirmed': 'sin confirmar',
  'ld.contact.tagPattern': 'Patrón',
  'ld.contact.centralTooltip': 'Línea directa no pública. Llama y pregunta por {name}.',
  'ld.contact.centralTooltipNoName': 'Línea directa no pública. Esto llega a la centralita.',
  'ld.contact.verifiedSmtp': 'Buzón de email confirmado (SMTP).',
  'ld.contact.unverifiedHint': 'Tomado de una fuente pública, aún no verificado por SMTP.',
  'ld.contact.patternTooltip':
    'Dirección probable según el patrón de email de la empresa, sin confirmar.',
  'ld.contact.derivePattern': 'Deducir email según el patrón de la empresa',
  'ld.contact.bestRoute': 'Mejor vía:',
  'ld.contact.route.central': 'Llamar a través de la centralita',
  'ld.contact.route.centralEmail': 'Enviar email a la centralita',
  'ld.contact.route.linkedin': 'Mensaje de LinkedIn',
  'ld.contact.route.xing': 'Mensaje de Xing',
  'ld.contact.route.phone': 'Llamar (línea directa)',
  'ld.contact.route.email': 'Email',
  'ld.contact.route.pattern': 'Email según patrón de la empresa',
  'ld.contact.provMailbox': 'Buzón confirmado',
  'ld.contact.provImpressum': 'Nombrado en el Impressum',
  'ld.contact.provFound': 'Encontrado en fuentes públicas',
  'ld.contact.provVia': 'confirmado vía',
  'ld.contact.confHigh': 'Alta',
  'ld.contact.confMid': 'Media',
  'ld.contact.confLow': 'Baja',
  'ld.contact.photoVia': 'Foto: {src} ↗',
  'ld.contact.roleProof': 'Rol confirmado públicamente ↗',
  'ld.section.roleFallback':
    'El rol solicitado ({roles}) no está confirmado públicamente, mostramos los siguientes mejores contactos.',
  'ld.section.noDirect':
    'Los contactos directos no son públicos aquí, accesibles a través de la centralita.',
  'lt.expH.legalForm': 'Forma jurídica',
  'lt.expH.street': 'Calle',
  'lt.expH.zip': 'Código postal',
  'lt.expH.website': 'Sitio web',
  'lt.expH.vatId': 'NIF/IVA',
  'lt.expH.hr': 'Registro mercantil',
  'lt.expH.founded': 'Fundada',
  'lt.expH.size': 'Empleados',
  'lt.expH.revenue': 'Rango de facturación',
  'lt.expH.description': 'Descripción',
  'lt.expH.techStack': 'Stack tecnológico',
  'lt.expH.triggers': 'Señales/Triggers',
  'lt.expH.scoreCompany': 'Puntuación de encaje de empresa',
  'lt.expH.scoreData': 'Calidad de datos',
  'lt.expH.seniority': 'Seniority',
  'lt.expH.department': 'Departamento',
  'lt.expH.phone': 'Teléfono',
  'lt.expH.linkedin': 'LinkedIn',
  'lt.expH.xing': 'Xing',
  'lt.expH.qualification': 'Cualificación',
  'lt.expH.confidence': 'Confianza',
  'lt.expH.channel': 'Canal recomendado',
  'lt.filter.all': 'Todos',
  'lt.filter.torate': 'Por valorar',
  'lt.filter.identified': 'Empresa añadida',
  'lt.filter.connected': 'Con contactos',
  'lt.filter.planned': 'Plan listo',
  'lt.filter.archived': 'Archivados',
  'lt.view.list': 'Lista',
  'lt.view.listSubheader': 'Tabla: todas las columnas visibles',
  'lt.funnel.subheader': 'Embudo: Leads agrupados por fase',
  'lt.funnel.addCompany': 'Añadir empresa',
  'lt.funnel.add': 'Añadir',
  'lt.funnel.addTooltip': 'Añadir empresa por URL · 1 crédito',
  'lt.funnel.pullAllContacts': 'Obtener todos los contactos',
  'lt.funnel.empty': 'Aún no hay Leads en esta fase',
  'lt.funnel.dropHint': 'Suelta aquí para iniciar la fase',
  'lt.col.planned': 'Plan de adquisición listo',
  'lt.card.new': 'Nuevo',
  'lt.card.viewPlan': 'Ver plan',
  'lt.card.findContacts': 'Encontrar contactos',
  'lt.card.createPlan': 'Crear plan de adquisición',
  'lt.card.contactsCount': '{n} contactos',
  'lt.card.fitTooltip':
    'Encaje {score} %: qué tan bien encaja esta empresa con tu público objetivo',
  'lt.card.noContacts': 'Aún no hay contactos',
  'lt.card.noJustification':
    'Aún no hay razonamiento de Cortex: el Lead se enriquecerá en la próxima ejecución.',
  'lt.card.rejectTitle': 'Marcar como no encaja',
  'lt.card.rejectAria': 'Marcar {company} como no encaja',
  'lt.card.openWebsite': 'Abrir {website}',
  'lt.manual.verifyingDesc': 'Verificando sitio web, extrayendo datos básicos …',
  'lt.manual.addedDesc':
    'Añadida por URL: sector, dirección y datos de contacto se completan durante la verificación.',
  'lt.phaseChip.identified': 'Añadida',
  'lt.phaseChip.connected': 'Contactos',
  'lt.phaseChip.planned': 'Plan listo',
  'nav.matchRateMin': 'La tasa de acierto se muestra a partir de 5 valoraciones',
  'notif.review.bodyAll': '{n} Leads sin valorar en {m} públicos objetivo.',
  'price.ctaDowngradeScheduled': 'Cambio ya programado',
  'run.startFailed': 'No se pudo iniciar la búsqueda. Inténtalo de nuevo.',
  'email.subscription-paused.subject': 'Tu suscripción está pausada',
  'email.subscription-paused.badge': 'Suscripción en pausa',
  'email.subscription-paused.hero': 'Tu suscripción<br>está en pausa.',
  'email.subscription-paused.detail.plan_label': 'Plan',
  'email.subscription-paused.detail.until_label': 'En pausa hasta',
  'email.subscription-paused.preheader': 'Sin cargos hasta el {{pause_ends_at}}.',
  'email.subscription-paused.greeting': 'Hola {{first_name}},',
  'email.subscription-paused.intro':
    'tu suscripción {{plan_name}} está ahora pausada. No se te cobrará hasta el {{pause_ends_at}}.',
  'email.subscription-paused.access':
    'Mantienes el acceso completo y tus Credits restantes: solo dejas de recibir los nuevos Credits mensuales.',
  'email.subscription-paused.resume_note':
    'El {{pause_ends_at}} tu suscripción se reanuda automáticamente. Puedes reanudarla o cancelarla en cualquier momento antes de esa fecha.',
  'email.subscription-paused.button': 'Gestionar suscripción',
  'email.subscription-paused.signoff': 'Hasta pronto, el equipo de Leadscraper',
  'email.subscription-pause-ending.subject': 'Tu suscripción se reanuda pronto',
  'email.subscription-pause-ending.preheader': 'Tu pausa termina el {{resumes_at}}.',
  'email.subscription-pause-ending.greeting': 'Hola {{first_name}},',
  'email.subscription-pause-ending.intro':
    'un recordatorio rápido: tu pausa termina el {{resumes_at}}. Tu suscripción {{plan_name}} se reanudará entonces automáticamente.',
  'email.subscription-pause-ending.charge_note':
    'A partir de entonces la facturación se reanuda con normalidad. Si prefieres no reanudarla, puedes cancelar antes de esa fecha.',
  'email.subscription-pause-ending.button': 'Gestionar suscripción',
  'email.subscription-pause-ending.signoff': 'El equipo de Leadscraper',
  'scraper.sum.recallUnverified':
    '{n}/10 Leads entregados: el investigador de IA fue suficiente, así que se omitió la búsqueda web amplia. El mercado podría ser mucho mayor que las {total} empresas encontradas hasta ahora.',
  'scraper.sum.recallUnverifiedRec':
    'Esto no es un mercado pequeño: es una búsqueda omitida. Estamos ampliando la discovery para medir el tamaño real del mercado.',
  'scraper.sum.supplyExhausted':
    '{n}/10 Leads entregados: otras {dropped} coincidencias ya te las habíamos entregado en búsquedas anteriores y se filtraron como duplicados. El mercado no es pequeño; simplemente ya has recibido la mayoría de las empresas que podemos encontrar por ahora.',
  'scraper.sum.supplyExhaustedRec':
    'Normal en búsquedas recurrentes. Con el tiempo aparecen nuevas empresas. Para más volumen fresco: elige una región más amplia o sectores relacionados.',
  'det.emailPatternExampleTag': 'Ejemplo',
  'det.emailPatternLockedHint': 'Se determina para esta empresa cuando verificas los contactos.',
  'det.email.verified': 'verificado',
  'det.email.unverified': 'sin verificar',
  'det.linkedinProfile': 'Perfil de LinkedIn',
  'det.xingProfile': 'Perfil de Xing',
  // --- Autopilot-Modus (Port aus feat/autopilot-setup-experience) ---
  'autopilot.act.title': 'Actividad reciente',
  'autopilot.appr.action': 'Aprobar',
  'autopilot.appr.givenShort': 'Aprobado',
  'autopilot.appr.opsShort': 'Aprobado por nosotros',
  'autopilot.appr.opsFeedback':
    'Lo hemos revisado y aprobado, no tienes que hacer nada. Si te parece bien, puedes confirmarlo aquí. Envía cualquier cambio directamente a tu persona de contacto.',
  'autopilot.appr.opsNoAction':
    'Lo hemos revisado y aprobado, no tienes que hacer nada. Envía cualquier cambio directamente a tu persona de contacto.',
  'autopilot.appr.opsChanged':
    'El contenido ha cambiado desde tu respuesta del {date}. Hemos revisado y aprobado la versión actual.',
  'autopilot.appr.opsConfirm': 'Me parece bien',
  'autopilot.appr.opsConfirmAsk': '¿Guardar tu respuesta?',
  'autopilot.appr.opsDone': 'Gracias, tu respuesta se ha guardado.',
  'autopilot.appr.opsAllDone': 'Todo está aprobado. Si notas algo, avísanos.',
  'autopilot.appr.launchHintOps':
    'Aprobamos el inicio en cuanto el público, los mensajes y la gestión de respuestas estén revisados.',
  'autopilot.camp.readonlyOps':
    '¿Quieres cambiar algo? Avisa a tu persona de contacto y lo ajustamos.',
  'autopilot.appr.pvShow': 'Ver',
  'autopilot.appr.pvHide': 'Contraer',
  'autopilot.appr.pvShowFirst': 'Primero revisa lo que apruebas',
  'autopilot.appr.pvHeading': 'Esto es lo que apruebas',
  'autopilot.appr.pvSampleTitle': 'Muestra de empresas objetivo',
  'autopilot.appr.pvSampleFoot':
    'Una muestra de tu público — verás la lista completa durante la operación.',
  'autopilot.appr.pvEmpty': 'Estamos preparando el contenido para ti.',
  'autopilot.appr.pvFirms': '{n} empresas',
  'autopilot.appr.pvPace': '{n}/día',
  'autopilot.appr.pvStart': 'De inmediato',
  'autopilot.appr.pvWait': '+{d} días',
  'autopilot.appr.pvSubject': 'Asunto:',
  'autopilot.appr.pvAb': 'Variante A/B:',
  'autopilot.appr.pvLaunchReady':
    'Todo el contenido está aprobado: al iniciar, sale el primer correo.',
  'autopilot.appr.pvLaunchWait':
    'El inicio se desbloquea cuando estén las tres aprobaciones anteriores.',
  'autopilot.appr.allDone':
    'Todo aprobado — iniciaremos tu campaña y te avisaremos en cuanto esté activa.',
  'autopilot.appr.confirmAsk': '¿Aprobar de forma vinculante?',
  'autopilot.appr.copy': 'Mensajes y secuencia',
  'autopilot.appr.copyHint':
    'Tus correos, redactados por completo — ves ejemplos reales, no plantillas.',
  'autopilot.appr.done': 'Aprobación registrada — con marca de tiempo y checksum.',
  'autopilot.appr.error': 'Error al aprobar — inténtalo de nuevo.',
  'autopilot.appr.given': 'Aprobado el {date}',
  'autopilot.appr.hash': 'Checksum',
  'autopilot.appr.icp': 'Público objetivo y segmento',
  'autopilot.appr.icpHint':
    'A quién se dirige tu motor — sectores, regiones, responsables de decisión.',
  'autopilot.appr.intro':
    'Tú apruebas, nosotros ejecutamos. Cada aprobación queda documentada — mantienes el control sobre el público objetivo, el contenido y el inicio.',
  'autopilot.appr.launch': 'Lanzamiento de la campaña',
  'autopilot.appr.launchHint': 'Tu aprobación final — solo después de esto sale el primer correo.',
  'autopilot.appr.locked': 'Se desbloqueará en cuanto se den las demás aprobaciones',
  'autopilot.appr.logIntro':
    'Cada aprobación se registra con marca de tiempo; el contenido aprobado se congela y se protege mediante checksum.',
  'autopilot.appr.logTitle': 'Registro de aprobaciones',
  'autopilot.appr.pending': 'Esperando tu aprobación',
  'autopilot.appr.preparingShort': 'En preparación',
  'autopilot.appr.preparing':
    'Estamos preparando el contenido — te avisaremos en cuanto puedas aprobarlo.',
  'autopilot.appr.playbook': 'Playbook de respuestas',
  'autopilot.appr.playbookHint':
    'Cómo respondemos las consultas en tu nombre antes de hacer el traspaso.',
  'autopilot.appr.soon': 'El contenido se está preparando para ti',
  'autopilot.appr.title': 'Tus aprobaciones',
  'autopilot.camp.approvedAt': 'Aprobado por ti el {date}',
  'autopilot.camp.approvedShort': 'Aprobado — inicio en breve',
  'autopilot.camp.audience': 'Público objetivo',
  'autopilot.camp.audienceN': '{n} empresas en el segmento',
  'autopilot.camp.awaitApproval': 'Esperando tu aprobación de lanzamiento',
  'autopilot.camp.back': 'Todas las campañas',
  'autopilot.camp.chip.paused': 'Pausada',
  'autopilot.camp.chip.running': 'En curso',
  'autopilot.camp.chip.scheduled': 'Programada',
  'autopilot.camp.hideMail': 'Contraer',
  'autopilot.camp.nextSend': 'Próximo envío {when}',
  'autopilot.camp.open': 'Ver',
  'autopilot.camp.pace': 'hasta {n} correos/día a través de tus bandejas',
  'autopilot.camp.progress': '{done} de {total} empresas contactadas',
  'autopilot.camp.queue': '{n} empresas verificadas en reserva',
  'autopilot.camp.readonly':
    '¿Quieres cambiar algo? Avisa a tu contacto — cualquier cambio se activará solo después de tu aprobación.',
  'autopilot.camp.runningSince': 'activa desde {date}',
  'autopilot.camp.sReplies': '{n} respuestas',
  'autopilot.camp.sSent': '{n} enviados',
  'autopilot.camp.sectionRunning': 'En curso',
  'autopilot.camp.sending': 'Envío',
  'autopilot.camp.sequence': 'La secuencia',
  'autopilot.camp.sequenceHint':
    'Cada correo es único — el motor completa las {{variables}} de forma individual para cada empresa.',
  'autopilot.camp.showMail': 'Ver correo',
  'autopilot.camp.startsAt': 'Comienza {when}',
  'autopilot.camp.stepStart': 'Inicio de la secuencia',
  'autopilot.camp.stepWait': '+{n} días después',
  'autopilot.camp.subject': 'Asunto',
  'autopilot.contact.hint':
    'Línea directa, sin sistema de tickets. El botón de emergencia está bajo Aprobaciones.',
  'autopilot.contact.title': 'Tu persona de contacto',
  'autopilot.contact.write': 'Escribir mensaje',
  'autopilot.end.testing': 'Actualmente en prueba: {label}',
  'autopilot.exp.empty':
    'En cuanto tu motor empiece a probar hipótesis, verás aquí qué se está probando y por qué.',
  'autopilot.exp.since': 'desde {date}',
  'autopilot.exp.title': 'Experimentos',
  'autopilot.foot.details': 'Detalles en Técnica',
  'autopilot.foot.quota': 'Cuota {used}/{target}',
  'autopilot.health.amber': 'En observación',
  'autopilot.health.blacklistOk': 'Listas negras limpias',
  'autopilot.health.bounce': 'Tasa de rebote {n}%',
  'autopilot.health.green': 'Todos los sistemas en verde',
  'autopilot.health.red': 'Nos estamos ocupando de ello',
  'autopilot.health.suppressed': '{n} bajas respetadas, bloqueadas en todas las campañas',
  'autopilot.health.title': 'Estado del sistema',
  'autopilot.hist.campaigns': 'Finalizadas',
  'autopilot.hist.completed': 'finalizada',
  'autopilot.hist.emptyHint':
    'En cuanto tu primera campaña esté en marcha, aquí se recopilarán los balances de campañas y los resultados de las pruebas finalizadas.',
  'autopilot.hist.emptyTitle': 'Aún no hay historial',
  'autopilot.hist.intro':
    'Lo que está en marcha, lo que ya terminó y lo que tu motor ha aprendido en el proceso. Consulta y navega; el control lo llevas tú mediante tus aprobaciones.',
  'autopilot.hist.ongoing': 'en curso',
  'autopilot.hist.running': 'en curso',
  'autopilot.hist.steps': '{n} etapas de secuencia',
  'autopilot.hist.tests': 'Pruebas finalizadas',
  'autopilot.hist.tie': 'Empate',
  'autopilot.hist.title': 'Campañas',
  'autopilot.hist.vs': 'contra',
  'autopilot.ho.none': 'No hay traspasos pendientes — el motor está trabajando.',
  'autopilot.ho.title': 'Traspasos cálidos',
  'autopilot.infra.dns': 'Autenticación de correo configurada (SPF · DKIM · DMARC)',
  'autopilot.infra.domain': 'Dominio de envío registrado — a tu nombre',
  'autopilot.infra.mailboxes': 'Buzones configurados',
  'autopilot.infra.title': 'Tu infraestructura',
  'autopilot.infra.verify': 'Dominio verificado y habilitado para el envío',
  'autopilot.infra.yourTask': 'Tu tarea',
  'autopilot.setup.title': 'Tu engine está en construcción',
  'autopilot.setup.intro': 'Lo que estamos montando para ti ahora mismo — cada paso documentado.',
  'autopilot.setup.ev.domain_registered':
    'Dominio de envío {domain} registrado — a nombre de tu empresa, tú eres el titular.',
  'autopilot.setup.ev.dns_shield':
    'Red de seguridad DNS para {domain} activa: autenticación del remitente (SPF · DKIM · DMARC) y protección anti-spoofing.',
  'autopilot.setup.ev.redirect_live':
    '{domain} lleva ahora a los visitantes directamente a {target} — transparencia total para cada destinatario.',
  'autopilot.setup.ev.mailboxes_created':
    '{n} buzones configurados en {domain}, protegidos y cifrados.',
  'autopilot.setup.ev.warmup_started':
    'Red de calentamiento iniciada: {n} buzones construyen reputación de entrega día a día.',
  'autopilot.setup.ev.warmup_progress':
    'Calentamiento: día {day} de {total} — {rate} % de entrega en bandeja de entrada.',
  'autopilot.setup.ev.blacklist_clean':
    'Comprobación de reputación: {n} listas de bloqueo revisadas — todo limpio.',
  'autopilot.kpi.contacted': 'Contactados',
  'autopilot.kpi.delivered': 'Entregados',
  'autopilot.kpi.handovers': 'Traspasos',
  'autopilot.kpi.lockedHint': 'Los datos aparecerán en cuanto tu campaña esté activa.',
  'autopilot.kpi.modulePrice': 'Módulo: {price}/mes',
  'autopilot.kpi.replies': 'Respuestas',
  'autopilot.kpi.won': 'Ganados',
  'autopilot.kpi.wonValueLabel': 'Valor de pedidos ganados',
  'autopilot.mb.empty': 'Tus buzones se están configurando en este momento.',
  'autopilot.mb.hint':
    'El warmup funciona de forma continua — incluso en operación en vivo, una base mínima mantiene alta la capacidad de entrega.',
  'autopilot.mb.perDay': '{n} correos/día',
  'autopilot.mb.score': 'Capacidad de entrega',
  'autopilot.mb.st.connecting': 'conectando',
  'autopilot.mb.st.ready': 'listo',
  'autopilot.mb.st.sending': 'activo · warmup de mantenimiento',
  'autopilot.mb.st.warmup': 'Warmup · Día {d}/{total}',
  'autopilot.mb.title': 'Buzones y Warmup',
  'autopilot.mb.count': '{active} de {total} activos',
  'autopilot.mb.scoreLabel': 'Puntuación de entrega',
  'autopilot.mode.autopilot': 'Autopilot',
  'autopilot.mode.lockedHint': 'Autopilot es un módulo adicional – más información',
  'autopilot.mode.search': 'Estándar',
  'autopilot.nav.history': 'Campañas',
  'autopilot.nav.overview': 'Dashboard',
  'autopilot.nav.replies': 'Kanban',
  'autopilot.nav.tech': 'Técnica',
  'autopilot.notActive.hint': 'Si quieres usar Autopilot, contáctanos.',
  'autopilot.notActive.title': 'Autopilot no está activo para esta cuenta',
  'autopilot.ov.activeTitle': 'Tu motor está en marcha',
  'autopilot.ov.awaitCta': 'Ir a las aprobaciones',
  'autopilot.ov.awaitHint': 'Solo faltan tus aprobaciones — después iniciaremos el envío.',
  'autopilot.ov.awaitTitle': 'Tu motor está listo para arrancar',
  'autopilot.ov.endedTitle': 'Autopilot finalizado',
  'autopilot.ov.engineTitle': 'Tu motor',
  'autopilot.ov.offerHint':
    'En cuanto el contrato esté cerrado, comenzaremos a configurar tu motor.',
  'autopilot.ov.offerTitle': 'Tu Autopilot se está preparando',
  'autopilot.ov.pausedHint':
    'No se está enviando nada. Contacta a tu persona de referencia para continuar.',
  'autopilot.ov.pausedTitle': 'Envío pausado',
  'autopilot.ov.setupHint':
    'Se están configurando el dominio, la autenticación y los buzones — todo lo hacemos nosotros. No tienes que hacer nada; te avisaremos en cuanto tus primeras aprobaciones estén listas.',
  'autopilot.ov.setupTitle': 'Estamos construyendo tu motor',
  'autopilot.ov.warmupDay': 'Warmup · Día {d} de {total}',
  'autopilot.ov.warmupHint':
    'Tus buzones se están calentando cuidadosamente para que tus correos lleguen a la bandeja de entrada, no al spam. Mientras tanto, puedes ir completando tus aprobaciones.',
  'autopilot.ov.warmupTitle': 'Warmup en curso',
  'autopilot.pause.hintContact':
    'Tu persona de contacto detiene el envío por ti: escríbele y se aplica de inmediato.',
  'autopilot.pause.action': 'Pausar envío',
  'autopilot.pause.hint':
    'Detiene el envío de forma inmediata y total. Tu persona de contacto se pondrá en contacto contigo personalmente después.',
  'autopilot.pause.title': 'Parada de emergencia',
  'autopilot.pause.confirm': '¿Detener de verdad?',
  'autopilot.pause.done':
    'Envío pausado — tu persona de contacto se pondrá en contacto contigo personalmente.',
  'autopilot.pause.error': 'No se pudo pausar — contacta directamente con tu persona de contacto.',
  'autopilot.pause.pausedHint':
    'El envío está en pausa. Tu persona de contacto se pondrá en contacto contigo antes de reanudarlo.',
  'autopilot.pulse.checked': '{n} verificados por IA',
  'autopilot.pulse.next': 'Próximo envío {when}',
  'autopilot.pulse.queue': '{n} en espera',
  'autopilot.pulse.quiet':
    'Aún no se ha enviado nada — el motor se está configurando. En cuanto arranque, verás aquí el pulso diario.',
  'autopilot.pulse.researched': '{n} investigados',
  'autopilot.pulse.sent': '{n} enviados hoy',
  'autopilot.pulse.title': 'El motor en este momento',
  'autopilot.quota.progress': '{used} de ~{target} empresas',
  'autopilot.quota.title': 'Cuota de este mes',
  'autopilot.rc.interested': 'Interés',
  'autopilot.rc.later': 'Más tarde',
  'autopilot.rc.noNeed': 'Sin necesidad',
  'autopilot.rc.ooo': 'Ausencia',
  'autopilot.rc.unsub': 'Baja',
  'autopilot.rcls.title': 'Respuestas por clasificación',
  'autopilot.rep.actionFailed': 'La acción falló — inténtalo de nuevo.',
  'autopilot.rep.call': 'Llamar ahora',
  'autopilot.rep.contacted': 'Marcar como asumido',
  'autopilot.rep.contactedDone': 'Asumido el {date}',
  'autopilot.rep.contactedSet': 'Marcado como asumido — gracias, esto nos ayuda.',
  'autopilot.rep.contactedShort': 'Asumido',
  'autopilot.rep.dealPlaceholder': 'Valor del contrato',
  'autopilot.rep.emptyHint':
    'En cuanto tu campaña esté activa, aquí aparecerán las respuestas de las empresas contactadas — con historial completo y nuestra evaluación.',
  'autopilot.rep.emptyTitle': 'Aún no hay respuestas',
  'autopilot.rep.intro':
    'Cada respuesta llega aquí — clasificada y con historial completo. Nosotros lo aclaramos, tú llamas.',
  'autopilot.rep.lostPlaceholder': 'Motivo (opcional)',
  'autopilot.rep.noFit': 'No es un fit',
  'autopilot.rep.noFitSet': 'Marcado como "no es un fit" — tu motor aprende de esto.',
  'autopilot.rep.saveClose': 'Guardar',
  'autopilot.rep.title': 'Respuestas',
  'autopilot.rep.viewThread': 'Ver conversación ({n})',
  'autopilot.rep.threadEmpty': 'Aún no hay historial de conversación.',
  'autopilot.rep.threadSent': 'Enviado · {step}',
  'autopilot.rep.threadSentPlain': 'Enviado por ti',
  'autopilot.rep.threadFoot': 'Enviado en tu nombre. Los cambios pasan por tu persona de contacto.',
  'autopilot.rep.cls.interested': 'Interés',
  'autopilot.rep.cls.later': 'Más tarde',
  'autopilot.rep.cls.noNeed': 'Sin necesidad',
  'autopilot.rep.cls.referral': 'Otra persona de contacto',
  'autopilot.rep.cls.question': 'Pregunta',
  'autopilot.rep.cls.outOfOffice': 'Ausencia',
  'autopilot.rep.cls.unsubscribed': 'Baja',
  'autopilot.rep.wonNoValue': 'Ganado',
  'autopilot.rep.wonSet': 'Ganado — ¡excelente! El valor del pedido se refleja en tu balance.',
  'autopilot.report.first':
    'Tu próximo informe llega el {date} — enviados, entregados, respuestas, entregas. Sin maquillar nada.',
  'autopilot.report.title': 'Informe mensual',
  'autopilot.res.angles': 'Enfoques',
  'autopilot.res.anglesHint': 'Con qué enfoque iniciamos la conversación.',
  'autopilot.res.emptyHint':
    'En cuanto tu campaña esté activa y lleguen las primeras respuestas, aquí verás qué funciona y qué no.',
  'autopilot.res.emptyTitle': 'Aún sin resonancia',
  'autopilot.res.footnote':
    'Las tasas solo se calculan a partir de 30 empresas contactadas; por debajo de eso, un porcentaje sería aleatorio.',
  'autopilot.res.intro':
    'De dónde vienen las respuestas — y a qué nadie reacciona. Tu Engine mide cada contacto y saca conclusiones de ello.',
  'autopilot.res.learnedTitle': 'Qué hace tu Engine con esto',
  'autopilot.res.segments': 'Segmentos',
  'autopilot.res.segmentsHint': 'Qué sectores y roles responden.',
  'autopilot.res.subjects': 'Líneas de asunto',
  'autopilot.res.subjectsHint': 'Qué se abre y se responde.',
  'autopilot.res.thin': 'datos insuficientes',
  'autopilot.res.title': 'Qué genera interés',
  'autopilot.spark.empty': 'Aparecerá en cuanto comience el envío.',
  'autopilot.spark.title': 'Actividad de envío (4 semanas)',
  'autopilot.stage.clarify': 'En aclaración',
  'autopilot.stage.handover': 'Transferido',
  'autopilot.stage.lost': 'Perdido',
  'autopilot.stage.new': 'Nuevo',
  'autopilot.stage.won': 'Ganado',
  'autopilot.status.active': 'Activo',
  'autopilot.status.awaiting': 'Esperando aprobación',
  'autopilot.status.contract': 'Contrato firmado',
  'autopilot.status.ended': 'Finalizado',
  'autopilot.status.offer': 'En preparación',
  'autopilot.status.paused': 'Pausado',
  'autopilot.status.setup': 'Configuración',
  'autopilot.status.warmup': 'Warmup',
  'autopilot.step.approvals': 'Aprobaciones',
  'autopilot.step.live': 'En vivo',
  'autopilot.step.setup': 'Configuración',
  'autopilot.step.warmup': 'Warmup',
  'autopilot.talk.all': 'Ver todas',
  'autopilot.talk.empty':
    'En cuanto tu campaña esté activa, aquí verás con quién está hablando el motor ahora mismo.',
  'autopilot.talk.emptyLive':
    'Por ahora no hay conversaciones abiertas — con la próxima respuesta, la empresa aparecerá aquí.',
  'autopilot.talk.title': 'Conversaciones en curso',
  'autopilot.tasks.approvals': '{n} aprobaciones esperan tu revisión',
  'autopilot.tasks.call1': 'Hay una entrega en caliente esperando tu llamada',
  'autopilot.tasks.calls': '{n} traspasos cálidos esperan tu llamada',
  'autopilot.tasks.none': 'Nada pendiente — el motor trabaja para ti.',
  'autopilot.tasks.title': 'Tus tareas',
  'autopilot.tech.allGreen': 'Todo operativo',
  'autopilot.tech.auto': 'Se ejecuta automáticamente',
  'autopilot.tech.autoHint':
    'Estas tareas de mantenimiento se ejecutan en segundo plano, sin que tengas que hacer nada.',
  'autopilot.tech.blacklists': 'Monitoreo de listas negras',
  'autopilot.tech.clean': 'limpio',
  'autopilot.tech.dmarcReports': 'Informes agregados DMARC activos',
  'autopilot.tech.domains': 'Dominios de envío',
  'autopilot.tech.integrations': 'Sistemas conectados',
  'autopilot.tech.intro':
    'Toda tu infraestructura de envío de un vistazo — dominios, autenticación DNS, buzones, monitoreo. Nosotros lo configuramos todo y lo mantenemos en verde; tú no tienes que tocar nada.',
  'autopilot.tech.mailboxes': 'Buzones y autenticación',
  'autopilot.tech.nis2': 'Dominio confirmado',
  'autopilot.tech.owner': 'Propietario: tú',
  'autopilot.tech.pending':
    'Tu infraestructura se está configurando — aquí aparecerá pronto tu panel de control completo.',
  'autopilot.tech.pipeline': 'El pipeline de IA',
  'autopilot.tech.pipelineHint':
    'Cada correo pasa por estas verificaciones independientes antes de estar listo para enviarse.',
  'autopilot.tech.placement': 'Última prueba de entregabilidad: {n}% bandeja de entrada',
  'autopilot.tech.registrar': 'Registrador: {name}',
  'autopilot.tech.rep': 'Reputación {n}',
  'autopilot.tech.replyLogic': 'Inteligencia de respuestas',
  'autopilot.tech.reputation': 'Reputación y monitoreo de entrega',
  'autopilot.tech.ssl': 'TLS/SSL',
  'autopilot.tech.title': 'Técnica y entregabilidad',
  'autopilot.tech.warmup': 'Calentamiento',
  'autopilot.warm.traffic.weekendShort': 'Finde',
  'autopilot.warm.traffic.pauseShort': 'Pausa',
  'autopilot.warm.traffic.weekend':
    'Fin de semana: la red de calentamiento reduce su actividad según lo previsto',
  'autopilot.warm.traffic.pause': 'Día de descanso en la red de calentamiento',
  'autopilot.ov.hero.warmOffen':
    'Tus buzones siguen calentándose (día {d} de {total}). Da tu aprobación ahora y empezaremos en cuanto estén listos.',
  'autopilot.ov.hero.warmFrei':
    'Todo aprobado. Tus buzones siguen calentándose (día {d} de {total}); después saldrá el primer correo.',
  'autopilot.ov.hero.fertigOffen':
    'Tus buzones ya están preparados. Solo faltan tus aprobaciones para empezar.',
  'autopilot.ov.hero.fertigFrei':
    'Calentamiento completado y todo aprobado. Estamos preparando el primer envío.',
  'autopilot.ov.hero.startNachFreigabe': 'en cuanto des tu aprobación',
  'autopilot.ov.hero.startInVorbereitung': 'en preparación',
  'autopilot.mb.st.fertig': 'Calentamiento completado',
  'autopilot.appr.zf.lead':
    'Contactaremos a todas las empresas que no descartes. La marca de verificación es opcional y nos ayuda a entender qué empresas prefieres.',
  'autopilot.appr.zf.f.alle': 'Todas {n}',
  'autopilot.appr.zf.f.dabei': 'Incluidas {n}',
  'autopilot.appr.zf.f.raus': 'Descartadas {n}',
  'autopilot.appr.zf.f.ohneKontakt': 'Sin contacto {n}',
  'autopilot.camp.offenN': '{n} aprobaciones pendientes: {liste}',
  'autopilot.camp.offen1': 'Una aprobación pendiente: {liste}',
  'autopilot.appr.zf.neuTitle': 'Nueva desde tu última visita',
  'autopilot.appr.zf.g.bekanntHinweis':
    '«Ya la conocemos» elimina la empresa de tus sugerencias de forma permanente, también en campañas futuras.',
  'autopilot.camp.offenDanach': ', después {label}',
  'autopilot.ov.ring.bereit': 'listos',
  'autopilot.ov.hero.bereitOffen':
    'Listo para lanzar: los {n} buzones tienen al menos {s} de puntuación de entregabilidad. Solo faltan tus aprobaciones.',
  'autopilot.ov.hero.bereitFrei':
    'Listo y aprobado. Los {n} buzones tienen al menos {s} de entregabilidad; preparamos el primer envío.',
  'autopilot.ov.hero.teilOffen':
    '{bereit} de {n} buzones están listos (entregabilidad desde {s}). Aprueba ahora y empezamos en cuanto todos lo estén.',
  'autopilot.ov.hero.teilFrei':
    '{bereit} de {n} buzones están listos (entregabilidad desde {s}). Empezamos en cuanto todos lo estén.',
  'autopilot.ov.hero.scoreRegel': 'Entregabilidad por buzón · listo desde {s}',
  'autopilot.mb.st.bereit': 'Listo para lanzar',
  'autopilot.mb.st.bereitTeil': '{bereit} de {n} listos',
  'autopilot.mb.st.mbBereit': 'listo · día {d}/{total}',
  'autopilot.warm.regel':
    'Un buzón está listo a partir de {s} de entregabilidad. Los {total} días son orientativos, no la condición.',
  'autopilot.camp.vs.post': '{n} por correo postal',
  'autopilot.camp.vs.geprueft': '{n} confirmadas',
  'autopilot.camp.vs.ungeprueft': '{n} sin confirmar',
  'autopilot.camp.vs.zust.ok': 'Dirección confirmada',
  'autopilot.camp.vs.zust.ungeprueft': 'Dirección sin confirmar',
  'autopilot.camp.vs.erkl.geprueft':
    'Comprobamos cada dirección antes del envío. Confirmada significa que el servidor la aceptó. Sin confirmar suele indicar catch-all, donde el servidor responde igual para cualquier dirección.',
  'autopilot.camp.vs.absender': 'Remitente',
  'autopilot.camp.vs.takt': 'Ritmo',
  'autopilot.camp.vs.taktWert': '{n} correos al día',
  'autopilot.camp.vs.naechster': 'próximo envío {when}',
  'autopilot.camp.vs.keinAbsender':
    'Esta campaña aún no tiene un buzón asignado como remitente. Lo configuraremos antes del lanzamiento.',
  'autopilot.camp.vs.hint':
    'Así sale el correo. Subrayado en verde: rellenado con nuestra investigación. Discontinuo: se rellena por persona al enviar.',
  'autopilot.camp.vs.wartetTitel':
    'Empresas sin dirección de correo investigada. Se añaden automáticamente en cuanto se encuentra un contacto con dirección.',
  'autopilot.camp.vs.empfaenger': 'Destinatarios',
  'autopilot.camp.vs.vorschauFuer': 'Vista previa para',
  'autopilot.camp.vs.an': 'Para',
  'autopilot.camp.vs.platzhalter': 'se rellena por persona al enviar',
  'autopilot.erkl.aria': '¿Cómo se calcula esto?',
  'autopilot.erkl.quelle': 'Fuente: {q}',
  'autopilot.warm.traffic.title': 'Tráfico de calentamiento de tus buzones',
  'autopilot.warm.traffic.hint':
    'Correos de calentamiento salientes y registrados en la bandeja de entrada de todos tus buzones.',
  'autopilot.mb.place.hint':
    'Correos de calentamiento en bandeja de entrada y spam en todos tus buzones.',
  'autopilot.ov.zu.sub': 'de {n} correos de calentamiento en los últimos 7 días',
  'autopilot.warm.scoreChart.title': 'Puntuación de entregabilidad por buzón',
  'autopilot.warm.scoreChart.hint':
    'La banda abarca todos los buzones, la línea sigue al más bajo. Listo a partir de {s}.',
  'autopilot.warm.scoreChart.perBox': 'por buzón',
  'autopilot.warm.scoreChart.perDomain': 'por dominio',
  'autopilot.warm.scoreChart.schwelle': 'listo a partir de {s}',
  'autopilot.warm.scoreChart.xHinweis':
    'Cada punto es un cambio de puntuación guardado, con el valor actual a la derecha.',
  'autopilot.warm.scoreChart.messpunkt': 'Punto {n}',
  'autopilot.warm.chart.gesendet': 'Enviados',
  'autopilot.warm.scoreChart.titleDomain': 'Puntuación de entregabilidad por dominio',
  'autopilot.warm.scoreChart.hintDomain':
    'La banda abarca tus dominios, la línea sigue al más bajo. Un buzón está listo a partir de {s}.',
  'autopilot.warm.erkl.traffic':
    'Aquí ves correos de calentamiento de la red lemwarm. Las cifras incluyen el tráfico entrante de la red y no muestran envíos de campañas.',
  'autopilot.warm.erkl.placement':
    'Los valores muestran dónde llegan tus correos de calentamiento, incluidos los entrantes de la red. La tasa de bandeja de entrada se calcula dividiendo los correos en la bandeja de entrada entre la suma de estos y los de spam.',
  'autopilot.warm.erkl.tage':
    'Los días son una referencia para el calentamiento; la condición es una puntuación de entregabilidad de al menos {s} por buzón.',
  'autopilot.warm.traffic.nochKeineKampagne':
    'Esto es tráfico de la red de calentamiento, todavía no son correos de campañas.',
  'autopilot.warm.placement.vorwoche':
    'Tasa de bandeja de entrada de los últimos 7 días registrados frente a los 7 anteriores.',
  'autopilot.camp.vs.absenderKonto':
    'Estos buzones pertenecen a tu cuenta. Cuál de ellos envía esta campaña se define antes del lanzamiento.',
  'autopilot.camp.vs.quellePruefung': 'verificación de correo',
  'autopilot.appr.zf.unvollstaendig':
    'Mostramos las empresas más recientes hasta el límite de visualización. Las más antiguas no aparecen aquí.',
  'autopilot.appr.zf.ladeFehler':
    'No se pudieron cargar algunas de tus empresas. Recarga la página y lo intentamos de nuevo.',
  'autopilot.warm.scoreChart.schwelleKurz': 'listo',
  'autopilot.warm.scoreChart.alle': 'Todos',
  'autopilot.warm.scoreChart.hintEines': 'Historial de {adresse}. Listo a partir de {s}.',
  // LEA-505 — Ein-Klick-Nachkauf von Kontakt-Paketen (Bestätigungskarte + Checkout-Einwilligung)
  'refill.checkoutConsent':
    'Tu tarjeta se guardará para futuras recargas con un clic. Solo se cobra cuando confirmas expresamente una recarga por el importe mostrado — sin suscripción, sin recarga automática. Puedes eliminar la tarjeta en cualquier momento en el portal de cliente.',
  'refill.title': 'Comprar más contactos',
  'refill.subtitle': 'Con tu tarjeta guardada — sin pasar de nuevo por el checkout.',
  'refill.choose': 'Elegir un paquete',
  'refill.pack': '{n} contactos',
  'refill.net': '{amount} sin IVA',
  'refill.total': 'Total',
  'refill.inclTax': 'incl. {tax} de IVA',
  'refill.reverseCharge':
    'Sin IVA — inversión del sujeto pasivo, el destinatario declara el impuesto.',
  'refill.cardLabel': 'Pagado con {brand} •••• {last4}',
  'refill.cta': 'Pagar {amount} ahora',
  'refill.quoting': 'Calculando el importe …',
  'refill.paying': 'Procesando el pago …',
  'refill.terms': 'Pago único, sin suscripción. Tus contactos no caducan.',
  // LEA-518 — first contact-pack purchase (Checkout) for reveal customers
  'packs.first.title': 'Comprar contactos',
  'packs.first.subtitle': 'Elige un paquete y úsalo para desbloquear contactos.',
  'packs.first.balance': 'Contactos disponibles: {n}',
  'packs.first.popular': 'Popular',
  'packs.first.cta': 'Continuar al pago',
  'packs.first.redirecting': 'Redirigiendo a Stripe…',
  'packs.first.checkoutNote':
    'En el siguiente paso pagas de forma segura con Stripe y ves el importe final con IVA incluido.',
  'packs.first.error': 'No se pudo iniciar el pago. Inténtalo de nuevo.',
  'packs.first.loadError': 'No se pudieron cargar los paquetes en este momento.',
  'packs.first.retry': 'Reintentar',
  'refill.success': '{n} contactos añadidos. Nuevo saldo: {balance}.',
  'refill.again': 'Comprar otro paquete',
  'refill.amountChanged': 'El importe ha cambiado. Confirma el nuevo importe, por favor.',
  'refill.inProgress': 'Ya hay una recarga en curso. Un momento …',
  'refill.processing': 'El pago todavía se está procesando. Lo volvemos a comprobar en un momento.',
  'refill.failedDeclined': 'Tu banco ha rechazado el pago. No se ha cobrado nada.',
  'refill.failedAuth': 'La confirmación con tu banco no se completó. No se ha cobrado nada.',
  'refill.failed': 'El pago no se ha realizado. No se ha cobrado nada.',
  'refill.error': 'No ha funcionado. Inténtalo de nuevo en un momento.',
  'refill.checking': 'Estamos comprobando el estado de tu pago …',
  'refill.unknown':
    'Todavía no hemos podido confirmar el pago. Revisa tu saldo antes de volver a comprar.',
  'refill.retryQuote': 'Volver a cargar el importe',
  'refill.checkStatus': 'Comprobar el pago',

  'auth.register.errPwPolicy':
    'La contraseña es demasiado débil. Usa al menos 8 caracteres con mayúsculas, minúsculas, un número y un carácter especial.',
  'auth.err.emailTaken': 'Este email ya está registrado. Inicia sesión.',
  'auth.err.rateLimited':
    'Demasiados intentos desde esta conexión. Vuelve a intentarlo en {minutes} minutos como máximo.',
  'auth.err.rateLimitedLater':
    'Demasiados intentos desde esta conexión. Inténtalo de nuevo más tarde.',
  'auth.err.network': 'No se pudo conectar con el servidor. Comprueba tu conexión a internet.',
  'auth.err.busy': 'El servidor está muy ocupado ahora mismo. Inténtalo de nuevo en un momento.',
  'auth.err.signupFailed': 'No se pudo completar el registro. Inténtalo de nuevo en un momento.',
  'auth.err.invalidInput': 'Revisa los datos introducidos.',
  'auth.err.turnstileFailed':
    'La comprobación anti-bot ha fallado o ha caducado. Recarga la página e inténtalo de nuevo.',
  'auth.err.turnstileBlocked':
    'No se pudo ejecutar la comprobación de seguridad. Puede que un bloqueador de anuncios o de rastreadores la esté bloqueando: permite challenges.cloudflare.com para esta página o prueba con otro navegador.',
  'auth.err.popupBlocked':
    'Se bloqueó la ventana de inicio de sesión. Permite las ventanas emergentes de este sitio e inténtalo de nuevo.',
  'auth.err.popupClosed':
    'La ventana de inicio de sesión se cerró antes de completar la autenticación.',
  'auth.err.otherProvider': 'Ya existe una cuenta con este email. Inicia sesión con {provider}.',
  'auth.err.otherMethod':
    'Ya existe una cuenta con este email. Inicia sesión como te registraste (Google, Microsoft o email y contraseña).',
  'auth.err.providerPassword': 'email y contraseña',
  'auth.err.firstName': 'Introduce tu nombre.',
  'auth.err.lastName': 'Introduce tus apellidos.',
  'auth.err.pwLong': 'La contraseña es demasiado larga.',
  'auth.err.oauthFailed':
    'Falló el inicio de sesión con el proveedor de identidad. Inténtalo de nuevo.',
  'auth.err.noEmailFromProvider':
    'No recibimos ninguna dirección de email de tu proveedor. Prueba con otro método de inicio de sesión.',
  'auth.err.ssoUnavailable':
    'El inicio de sesión con Google o Microsoft no está disponible ahora. Usa tu email y contraseña.',
  'auth.err.accountGone': 'Esta cuenta se ha eliminado o está desactivada.',
  'auth.err.sessionFailed': 'No se pudo crear la sesión. Inténtalo de nuevo.',
  'auth.register.next.prism':
    'Siguiente paso: describe tu público objetivo y ve empresas reales. Solo pagas cuando desbloqueas leads.',
  'auth.register.next.noCard':
    'Tras registrarte puedes empezar de inmediato. No hacen falta datos de pago.',
  'auth.register.next.trial':
    'Siguiente paso: elige un plan y pruébalo 3 días. Se necesita tarjeta, 0 € hoy; después el plan continúa salvo que canceles antes de que termine la prueba.',
  'auth.register.next.plan':
    'Siguiente paso: elige un plan. El pago con tarjeta se cobra de inmediato.',
  'auth.register.busyHint': 'Estamos creando tu cuenta. Tarda unos segundos.',
  'auth.login.legalSso':
    '¿Eres nuevo? Al iniciar sesión con Google o Microsoft se crea una cuenta automáticamente y aceptas nuestros {terms}. Encontrarás información sobre tus datos en nuestra {privacy}.',
  'auth.r19.form.pw.title': 'Requisitos de la contraseña',
  'auth.r19.form.pw.len': 'Al menos 8 caracteres',
  'auth.r19.form.pw.case': 'Mayúsculas y minúsculas',
  'auth.r19.form.pw.digit': 'Un número',
  'auth.r19.form.pw.special': 'Un carácter especial',
  'auth.r19.form.pw.met': 'cumplido',
  'auth.r19.form.pw.open': 'pendiente',
  'auth.r19.chat.greeting':
    'Escribe aquí tu pregunta. Si añades tu correo electrónico, también podremos responderte más tarde.',
  'auth.r19.chat.failed': 'No se puede abrir el chat ahora mismo. Escríbenos por correo a',

  'prism.abandon.fit': 'Las empresas no encajan',
  'prism.abandon.fitQ': '¿Qué empresas esperabas?',
  'prism.abandon.freeText': 'O cuéntanoslo en una frase…',
  'prism.abandon.later': 'Lo veré más tarde',
  'prism.abandon.price': 'El precio',
  'prism.abandon.q': 'Pregunta rápida: ¿qué te frena?',
  'prism.abandon.send': 'Enviar',
  'prism.abandon.skip': 'Omitir',
  'prism.abandon.thanks': 'Gracias, nos ayuda de verdad.',
  'prism.checkout.autoNote':
    'Pasa automáticamente al plan Starter (250 créditos/mes) si no cancelas dentro de los 3 días de prueba.',
  // Prism-Umsatzpaket (16.10.2026): Abo-Satz, Entscheider vor dem Kauf, Hinweise.
  'prism.abo.line':
    '49 € hoy · desde el día 4: 290 €/mes · cancelable cada mes con un clic',
  'prism.abo.afterDelivery':
    'Cada semana ~{n} empresas nuevas. Para cada una buscamos al responsable de decisión, y solo pagas si lo encontramos.',
  'prism.abo.afterCredits':
    'Después, {credits} créditos cada mes para nuevas empresas y contactos.',
  'prism.teaser.tag':
    'Responsable gratis por adelantado',
  'prism.teaser.running':
    'Estamos buscando al responsable de {company} …',
  'prism.teaser.foundShort':
    'Responsable encontrado: {name}',
  'prism.teaser.noneShort':
    'Ningún responsable con prueba',
  'prism.teaser.failedShort':
    'Búsqueda no disponible ahora',
  'prism.teaser.open':
    'Ver',
  'prism.teaser.close':
    'Cerrar',
  'prism.teaser.role':
    'Cargo',
  'prism.teaser.source':
    'Prueba',
  'prism.teaser.email':
    'Correo',
  'prism.teaser.src.impressum':
    'Aviso legal de {domain}',
  'prism.teaser.src.handelsregister':
    'Registro mercantil',
  'prism.teaser.src.website':
    'Web de {domain}',
  'prism.teaser.mail.verified':
    'verificado con el servidor de correo',
  'prism.teaser.mail.probable':
    'muy probablemente válido',
  'prism.teaser.mail.found':
    'tal como aparece en su web',
  'prism.teaser.mail.none':
    'no encontramos un correo personal',
  'prism.teaser.foundNote':
    'Así investigamos cada una de tus {n} empresas. El correo completo lo ves después de desbloquear, y el teléfono cuando esté disponible.',
  'prism.teaser.noneBody':
    'Para {company} no encontramos ningún responsable con prueba (aviso legal, registro mercantil o su propia web). Antes que inventar algo, preferimos no mostrarte nada.',
  'prism.teaser.noneNote':
    'Después de desbloquear, un crédito solo cuenta si encontramos un contacto.',
  'prism.teaser.failedBody':
    'La búsqueda no funcionó ahora mismo. Después de desbloquear se hace para las {n} empresas.',
  'prism.teaser.cta':
    'Desbloquear las {n}',
  'prism.cardHint.body':
    'Al responsable de {company} lo investigamos después de desbloquear: nombre y cargo, además de correo o teléfono si son públicos.',
  'prism.cardHint.example':
    'Tienes un ejemplo arriba, en {top}.',
  'prism.cardHint.cta':
    'Desbloquear',
  'prism.website.skip':
    'Seguir sin web',
  'prism.website.issue.own_product':
    'Esa es nuestra web, no la tuya. Escribe aquí la web de tu propia empresa para que entendamos qué vendes.',
  'prism.website.issue.ai_chat':
    'Es un enlace a un chat de IA. Necesitamos la web de tu propia empresa, p. ej. «tu-empresa.es».',
  'prism.website.issue.social':
    'Un perfil en redes sociales nos dice muy poco de tu oferta. ¿Tienes web propia? Si no, simplemente salta este paso.',
  'prism.website.issue.redirect':
    'Es un enlace corto o de redirección. Escribe directamente la dirección de tu web, p. ej. «tu-empresa.es».',
  'prism.notice.title':
    'Una nota sobre los datos',
  'prism.notice.local_b2c':
    'Las tiendas pequeñas para particulares (p. ej. peluquerías o bares) suelen mostrar en internet solo el teléfono y el dueño. Allí encontramos correos verificados de responsables con menos frecuencia que en empresas que venden a otras empresas.',
  'prism.notice.outside_dach':
    'Nuestros datos son más completos en Alemania, Austria y Suiza. Fuera de ellos suelen faltar el aviso legal y el registro mercantil, así que encontramos menos responsables.',
  'prism.notice.continue':
    'Puedes buscar igualmente.',
  // Gratis-Leads vor dem Kauf + Hinweise für die übrige Liste (16.10.2026).
  'prism.free.tag':
    'Tus {n} leads gratis, listos para usar',
  'prism.free.tagRunning':
    'Estamos buscando tus {n} leads gratis',
  'prism.free.tagOne':
    'Tu lead gratis, listo para usar',
  'prism.free.tagNone':
    'Leads gratis: esta vez ninguno con prueba',
  'prism.free.tagSlow':
    'Tus leads gratis tardan un poco más',
  'prism.free.slowBody':
    'La búsqueda tarda más de lo habitual esta vez. Te mostraremos tus leads gratis aquí en cuanto estén listos, aunque vuelvas más tarde.',
  'prism.free.running':
    'Estamos buscando a los responsables de tus mejores empresas … ({found} de {n})',
  'prism.free.noneBody':
    'En tus mejores empresas no encontramos ningún responsable con prueba y correo (aviso legal, registro mercantil o su propia web). Antes que inventar algo, preferimos no mostrarte nada. Después de desbloquear, un crédito solo cuenta si encontramos un contacto.',
  'prism.free.fewer':
    'Pudimos probar {found} de {n}. En las demás empresas destacadas faltaba una prueba, así que ahí no mostramos nada.',
  'prism.free.yours':
    'Cópialos o expórtalos, son tuyos.',
  'prism.free.export':
    'Exportar como CSV',
  'prism.free.copy':
    'Copiar',
  'prism.free.copied':
    'Copiado',
  'prism.free.cta':
    'Desbloquear las {n}',
  'prism.free.usedNote':
    'Los leads gratis son una vez por cuenta y empresa. Aquí ves a este responsable como vista previa.',
  'prism.free.csv.company':
    'Empresa',
  'prism.free.csv.domain':
    'Dominio',
  'prism.free.csv.name':
    'Nombre',
  'prism.free.csv.role':
    'Cargo',
  'prism.free.csv.email':
    'Correo',
  'prism.free.csv.phone':
    'Teléfono',
  'prism.free.csv.source':
    'Prueba',
  'prism.pattern.first':
    'nombre',
  'prism.pattern.last':
    'apellido',
  'prism.pattern.f':
    'n',
  'prism.hint.freeAbove':
    'Desbloqueado gratis, ver arriba',
  'prism.hint.dmsOne':
    '1 responsable: {roles}',
  'prism.hint.dmsMany':
    '{count} responsables: {roles}',
  'prism.hint.dmsNoRole':
    '{count} responsables con prueba',
  'prism.hint.pattern':
    'Patrón de correo detectado:',
  'prism.hint.src.impressum':
    'Aviso legal',
  'prism.hint.src.handelsregister':
    'Registro mercantil',
  'prism.hint.src.website':
    'Web',
  'prism.hint.unlock':
    'Desbloquear',
  'prism.hint.unlockSub':
    'contacto',
  'prism.freelead.tagTop': 'Tu empresa con mejor encaje',
  'prism.rail.label': 'Progreso',
  'prism.rail.audience': 'Público',
  'prism.rail.website': 'Sitio web',
  'prism.rail.refine': 'Ajuste',
  'prism.rail.result': 'Resultado',
  'prism.rail.done': 'completado',
  'prism.steps.earlier': '{n} pasos anteriores completados',
  'prism.lead.evidenceTag': 'En su web:',
  'prism.plan.termsStrong': 'Desde el día 4: 290 €/mes.',
  'prism.plan.termsBody':
    'Tras los 3 días de prueba, tu acceso pasa automáticamente al plan Starter (250 créditos/mes). Si cancelas antes desde tu cuenta, solo pagas los 49 €.',
  'prism.rateLimited.body':
    'Has agotado tus búsquedas de hoy. Mañana seguimos — tus datos quedan guardados.',
  'prism.rateLimited.title': 'Límite diario alcanzado',
  'prism.results.queriesLabel': 'Así hemos buscado:',
  'prism.results.queriesMore': '+{count} más',
  'prism.score.possible': 'Encaje posible',
  'prism.target.errEmpty': 'Dinos primero a quién quieres llegar — p. ej. «dentistas en Madrid».',
  // LEA-595: Setup-Lieferungen freischalten (für jedes Offer).
  'ld.reveal.title': 'Contactos encontrados, aún bloqueados',
  'ld.reveal.hint':
    'Verás el nombre, el correo y el teléfono al desbloquear. Un desbloqueo abre todos los contactos de esta empresa.',
  'ld.reveal.cta': 'Desbloquear contactos',
  'ld.reveal.confirm':
    'Esto usa 1 crédito. Después verás los contactos de esta empresa completos, y el plan de captación no cuesta nada extra.',
  'ld.reveal.confirmCta': 'Desbloquear por 1 crédito',
  'ld.reveal.busy': 'Desbloqueando…',
  'ld.reveal.done': 'Contactos desbloqueados, 1 crédito usado.',
  'ld.reveal.already': 'Ya estaba desbloqueado, no se ha cobrado nada de nuevo.',
  'ld.reveal.notEligible':
    'No hay ninguna persona de contacto localizable, así que no hay nada que desbloquear ni se cobra nada.',
  'ld.reveal.verificationPending':
    'Los contactos aún se están verificando. Inténtalo de nuevo en un minuto; no se ha cobrado nada.',
  'ld.reveal.researchRunning':
    'La búsqueda de contactos sigue en curso. Podrás desbloquear cuando termine.',
  'ld.reveal.failed': 'No se pudo desbloquear. Inténtalo de nuevo; nunca se cobra dos veces.',
  'ld.reveal.noCredits': 'Necesitas 1 crédito para desbloquear.',
  'ld.reveal.buyContacts': 'Tu saldo está vacío – aquí puedes comprar más contactos',
  'ld.reveal.planLocked': 'Primero desbloquea los contactos',
  'ld.reveal.planNoContact': 'Sin persona de contacto localizable, no hay plan de captación',
  'ld.contact.lockedEmailPhone': 'Correo y teléfono al desbloquear',
  'ld.contact.lockedEmail': 'Correo al desbloquear',
  'ld.contact.lockedPhone': 'Teléfono al desbloquear',
  // Wöchentliche Lieferung, Etappe B (16.10.2026) — Kundenseite + Assistant.
  'delivery.card.title': 'Entrega semanal',
  'delivery.card.badgeNew': 'Nuevo',
  'delivery.card.forAudience': 'para {name}',
  'delivery.card.amount': 'Cada semana ~{n} empresas nuevas. Para cada una buscamos al responsable de decisión, y solo pagas si lo encontramos.',
  'delivery.card.credits': 'Hasta {credits} créditos por entrega: 1 por empresa, 1 por responsable encontrado',
  'delivery.card.switchLabel': 'Activar o desactivar la entrega semanal',
  'delivery.card.on': 'Activa',
  'delivery.card.off': 'Desactivada',
  'delivery.card.offHint': 'Actívala y la primera entrega empieza enseguida.',
  'delivery.card.next.label': 'Próxima entrega',
  'delivery.card.next.afterRating': 'cuando hayas valorado la actual, a más tardar el {date}',
  'delivery.card.next.soon': 'empieza en breve',
  'delivery.card.running': 'Entrega {no} en curso: {delivered} de {target} empresas',
  'delivery.card.runningConnect': 'Entrega {no}: {delivered} empresas listas, ahora buscamos a los responsables',
  'delivery.card.lowCredits': 'Tienes {credits} créditos, una entrega completa necesita {need}.',
  'delivery.card.topUp': 'Recargar créditos',
  'delivery.card.loadFailed': 'No se pudo cargar la entrega.',
  'delivery.pause.out_of_credits.title': 'En pausa: sin créditos',
  'delivery.pause.out_of_credits.body': 'Con créditos nuevos la entrega sigue sola.',
  'delivery.pause.niche_exhausted.title': 'En pausa: tu público objetivo está agotado',
  'delivery.pause.niche_exhausted.body': 'Aquí ya no encontramos empresas nuevas. Amplíalo con un clic:',
  'delivery.pause.subscription_ended.title': 'En pausa: tu suscripción ha terminado',
  'delivery.pause.subscription_ended.body': 'Con un plan activo la entrega continúa.',
  'delivery.pause.subscription_ended.cta': 'Elegir plan',
  'delivery.pause.subscription_paused.title': 'En pausa: tu suscripción está en pausa',
  'delivery.pause.subscription_paused.body': 'En cuanto tu suscripción vuelva a funcionar, la entrega continúa.',
  'delivery.pause.payment_issue.title': 'En pausa: pago pendiente',
  'delivery.pause.payment_issue.body': 'Actualiza tu método de pago y la entrega continúa.',
  'delivery.pause.payment_issue.cta': 'Actualizar pago',
  'delivery.pause.other.title': 'En pausa',
  'delivery.pause.other.body': 'Escríbenos un mensaje corto y lo revisamos.',
  'delivery.expand.hint': 'Esto cambia tu público objetivo, también para tus búsquedas manuales.',
  'delivery.pause.profile_missing.title': 'En pausa: este público objetivo ya no existe',
  'delivery.pause.profile_missing.body': 'Crea un público objetivo nuevo y activa allí la entrega.',
  'delivery.pause.profile_missing.cta': 'Crear público objetivo',
  'delivery.pause.not_self_service.title': 'En pausa: nuestro equipo gestiona tu cuenta',
  'delivery.pause.not_self_service.body': 'Recibes tus empresas a través de Autopilot.',
  'delivery.pause.account_closed.title': 'En pausa: eliminación solicitada',
  'delivery.pause.account_closed.body': 'No hacemos entregas a una cuenta en proceso de eliminación.',
  'delivery.pause.unsupported_model.title': 'En pausa: no incluida en tu plan',
  'delivery.pause.unsupported_model.body': 'La entrega forma parte de Basic, Starter y Growth.',
  'delivery.short.title': 'Última entrega: {delivered} de {target} empresas',
  'delivery.short.body': 'Tu público objetivo no da para más ahora mismo. Amplíalo con un clic:',
  'delivery.expand.loading': 'Comprobando sugerencias …',
  'delivery.expand.none': 'Describe tu público objetivo de forma más amplia para continuar.',
  'delivery.expand.edit': 'Editar público objetivo',
  'delivery.expand.applied': 'Público objetivo ampliado. La próxima entrega empieza en breve.',
  'delivery.expand.opt.area': 'Ampliar a todo {area} en lugar de {from} e iniciar la entrega',
  'delivery.expand.opt.dach': 'Ampliar a Alemania, Austria y Suiza e iniciar la entrega',
  'delivery.expand.opt.industry': 'Añadir {industry} a tu público objetivo e iniciar la entrega',
  'delivery.expand.opt.size': 'Permitir todos los tamaños de empresa en lugar de {from} empleados e iniciar la entrega',
  'delivery.toast.on': 'La entrega está activa. La primera empieza en breve.',
  'delivery.toast.off': 'La entrega está desactivada.',
  'delivery.toast.failed': 'No ha funcionado. Inténtalo de nuevo.',
  'delivery.toast.planRequired': 'Para la entrega necesitas un plan activo.',
  'delivery.history.title': 'Entregas anteriores',
  'delivery.history.cycle': 'Entrega {no}',
  'delivery.history.companies': '{n} empresas',
  'delivery.history.withContact': '{n} con responsable',
  'delivery.history.acceptRate': '{pct} % encaja',
  'delivery.history.noRating': 'sin valorar',
  'delivery.history.review': 'Valorar ahora ({n} pendientes)',
  'delivery.history.show': 'Ver',
  'delivery.history.empty': 'Tu primera entrega aparecerá aquí.',
  'delivery.history.more': 'Ver todas',
  'delivery.history.less': 'Ver menos',
  'delivery.filter.prefix': 'Filtrado por:',
  'delivery.notif.ready.title': 'Tu entrega ha llegado: {n} empresas',
  'delivery.notif.ready.body': '{connected} con responsable de decisión, para {name}. Valóralas y llega la siguiente.',
  'delivery.notif.paused.out_of_credits.title': 'Entrega en pausa: sin créditos',
  'delivery.notif.paused.out_of_credits.body': 'Con créditos nuevos sigue sola.',
  'delivery.notif.paused.niche_exhausted.title': 'Entrega en pausa: público objetivo agotado',
  'delivery.notif.paused.niche_exhausted.body': 'Amplía {name} con un clic para continuar.',
  'agent.delivery.tool.status': 'Consultar entrega',
  'agent.delivery.tool.set': 'Entrega semanal',
  'agent.delivery.cost.enable': 'Hasta {credits} créditos por entrega: cada semana ~{n} empresas nuevas, y para cada una buscamos al responsable de decisión. Ese crédito solo lo pagas si lo encontramos. Puedes desactivarla cuando quieras.',
};

export default es;
